import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  isBlank1dvkhjjvox3p0 as isBlank,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString30pk9tzaqopn as toString,
  equals2au1ep9vhcato as equals,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  listOfvhqybd2zx248 as listOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  isInterface3d6p8outrmvmk as isInterface,
  getValue48kllevslyh6 as getValue,
  setOf45ia9pnfhe90 as setOf,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  emptyList1g2z5xcrvp2zy as emptyList,
  KtList3hktaavzmj137 as KtList,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  toSet2orjxp16sotqu as toSet,
  to2cs3ny02qtbcb as to,
  mapOf2zpbbmyqk8xpf as mapOf,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Subsystem_REST_getInstance2giohqo6b8l7w as Subsystem_REST_getInstance,
  ProcessingPhase_MAPPING_getInstance16v9dkpvbjhjf as ProcessingPhase_MAPPING_getInstance,
  Impact_MEDIUM_getInstance1z2bb1nzb3ufh as Impact_MEDIUM_getInstance,
  InfrastructureIssue2tvwph0eyadg1 as InfrastructureIssue,
  ILogger102gekz4uf4a8 as ILogger,
  Companion_instancebove5hxj27a1 as Companion_instance_0,
  Impact_HIGH_getInstancexaobkfkrtcpy as Impact_HIGH_getInstance,
  reportInfrastructureIssueAndThrow19mdgs7yfj5lz as reportInfrastructureIssueAndThrow,
} from './Shared7Punches-infrastructure-logging.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  DoubleSerializer_getInstance2avi1jm48x8le as DoubleSerializer_getInstance,
  BooleanSerializer_getInstancet3wtk7fl7i4f as BooleanSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  IntSerializer_getInstance9scrtcljaiv6 as IntSerializer_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import {
  Companion_getInstancepumzx9q4106p as Companion_getInstance_0,
  Application_getInstance1d4ly18wdhadx as Application_getInstance,
  contentType1lwcfjsjo0z8g as contentType,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instance9oj4j8z4op1j as NullBody_instance,
} from './ktor-ktor-http.mjs';
import {
  Companion_instance38at02i5wbrbj as Companion_instance_1,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  BadRequest1sf43sgrco9q2 as BadRequest,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
} from './Shared7Punches-common-base.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { InstantIso8601Serializer_getInstancerozk8wbw256e as InstantIso8601Serializer_getInstance } from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForObject(AssignmentMappers, 'AssignmentMappers');
initMetadataForObject(LdrMapperHelpers, 'LdrMapperHelpers');
initMetadataForObject(RoleMappers, 'RoleMappers');
initMetadataForObject(Location, 'Location');
initMetadataForClass(Role, 'Role');
initMetadataForClass(Department, 'Department');
initMetadataForClass(Department_0, 'Department');
initMetadataForClass(Role_0, 'Role');
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Content, 'Content', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForClass(Response, 'Response', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiAttestation, 'ApiAttestation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(QuestionResponse, 'QuestionResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiSaveAttestationRequest, 'ApiSaveAttestationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForInterface(IAttestationPromptAccessor, 'IAttestationPromptAccessor', VOID, VOID, VOID, [1]);
initMetadataForInterface(IAttestationPromptMutator, 'IAttestationPromptMutator', VOID, VOID, VOID, [1]);
initMetadataForClass(AttestationPromptRepository, 'AttestationPromptRepository', VOID, VOID, [IAttestationPromptAccessor, IAttestationPromptMutator], [1]);
initMetadataForCoroutine($getAttestationCOROUTINE$2, CoroutineImpl);
initMetadataForCoroutine($saveAttestationCOROUTINE$3, CoroutineImpl);
initMetadataForInterface(AttestationRepository, 'AttestationRepository', VOID, VOID, VOID, [0, 3]);
initMetadataForClass(AttestationRepositoryImpl, 'AttestationRepositoryImpl', VOID, VOID, [AttestationRepository], [0, 3]);
initMetadataForInterface(IAttestationPromptRemoteSource, 'IAttestationPromptRemoteSource', VOID, VOID, VOID, [3, 2]);
initMetadataForClass(AttestationPromptRemoteSource, 'AttestationPromptRemoteSource', VOID, VOID, [IAttestationPromptRemoteSource], [3, 2]);
initMetadataForInterface(AttestationRemoteSource, 'AttestationRemoteSource', VOID, VOID, VOID, [2, 3]);
initMetadataForCoroutine($getAttestationCOROUTINE$6, CoroutineImpl);
initMetadataForCoroutine($saveAttestationResponseCOROUTINE$7, CoroutineImpl);
initMetadataForClass(AttestationRemoteSourceImpl, 'AttestationRemoteSourceImpl', VOID, VOID, [AttestationRemoteSource], [2, 3]);
initMetadataForClass(Content_0, 'Content');
initMetadataForClass(Response_0, 'Response');
initMetadataForClass(Attestation, 'Attestation');
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiClockRequest, 'ApiClockRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiClockUserResponse, 'ApiClockUserResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForClass(ApiRole, 'ApiRole', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForClass(ApiDepartment, 'ApiDepartment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_4);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiClockResponse, 'ApiClockResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForClass(TimePunchUserAction, 'TimePunchUserAction', VOID, Enum);
initMetadataForCoroutine($clockInCOROUTINE$8, CoroutineImpl);
initMetadataForCoroutine($clockOutCOROUTINE$9, CoroutineImpl);
initMetadataForCoroutine($startPaidBreakCOROUTINE$10, CoroutineImpl);
initMetadataForCoroutine($startUnpaidBreakCOROUTINE$11, CoroutineImpl);
initMetadataForCoroutine($startCustomBreakCOROUTINE$12, CoroutineImpl);
initMetadataForCoroutine($endBreakCOROUTINE$13, CoroutineImpl);
function clockOut$default(employeePunchId, tips, $completion, $super) {
  tips = tips === VOID ? null : tips;
  return $super === VOID ? this.m9c(employeePunchId, tips, $completion) : $super.m9c.call(this, employeePunchId, tips, $completion);
}
initMetadataForInterface(IClockRepository, 'IClockRepository', VOID, VOID, VOID, [5, 2, 1]);
initMetadataForClass(ClockRepository, 'ClockRepository', VOID, VOID, [IClockRepository], [5, 2, 1]);
initMetadataForInterface(ClockRemoteSource, 'ClockRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($clockCOROUTINE$14, CoroutineImpl);
initMetadataForClass(ClockRemoteSourceImpl, 'ClockRemoteSourceImpl', VOID, VOID, [ClockRemoteSource], [1]);
initMetadataForClass(Status, 'Status', VOID, Enum);
initMetadataForClass(ClockUserResponse, 'ClockUserResponse');
initMetadataForClass(Role_1, 'Role');
initMetadataForClass(Department_1, 'Department');
initMetadataForClass(ClockResponse, 'ClockResponse');
initMetadataForCompanion(Companion_5);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Question, 'Question', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForClass(Response_1, 'Response', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
initMetadataForCompanion(Companion_6);
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiHealthCheckQuestionnaire, 'ApiHealthCheckQuestionnaire', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
initMetadataForCompanion(Companion_7);
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(QuestionResponse_0, 'QuestionResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
initMetadataForCompanion(Companion_8);
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_9);
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Request, 'Request', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
initMetadataForClass(Response_2, 'Response', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
initMetadataForCoroutine($getHealthCheckQuestionnaireCOROUTINE$15, CoroutineImpl);
initMetadataForCoroutine($saveHealthCheckQuestionnaireResponsesCOROUTINE$16, CoroutineImpl);
initMetadataForInterface(HealthCheckRepository, 'HealthCheckRepository', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(HealthCheckRepositoryImpl, 'HealthCheckRepositoryImpl', VOID, VOID, [HealthCheckRepository], [0, 1]);
initMetadataForInterface(HealthCheckRemoteSource, 'HealthCheckRemoteSource', VOID, VOID, VOID, [2, 3]);
initMetadataForCoroutine($getHealthCheckQuestionnaireCOROUTINE$17, CoroutineImpl);
initMetadataForCoroutine($saveHealthCheckQuestionnaireResponsesCOROUTINE$18, CoroutineImpl);
initMetadataForClass(HealthCheckRemoteSourceImpl, 'HealthCheckRemoteSourceImpl', VOID, VOID, [HealthCheckRemoteSource], [2, 3]);
initMetadataForClass(Question_0, 'Question');
initMetadataForClass(Response_3, 'Response');
initMetadataForClass(HealthCheckQuestionnaire, 'HealthCheckQuestionnaire');
initMetadataForClass(QuestionResponse_1, 'QuestionResponse');
initMetadataForClass(HealthCheckQuestionnaireResponses, 'HealthCheckQuestionnaireResponses');
initMetadataForInterface(OfflinePunchRepository, 'OfflinePunchRepository', VOID, VOID, VOID, [2]);
initMetadataForClass(OfflinePunchRepositoryImpl, 'OfflinePunchRepositoryImpl', VOID, VOID, [OfflinePunchRepository], [2]);
initMetadataForInterface(OfflinePunchSyncRemoteSource, 'OfflinePunchSyncRemoteSource', VOID, VOID, VOID, [2]);
initMetadataForClass(OfflinePunchSyncRemoteSourceImpl, 'OfflinePunchSyncRemoteSourceImpl', VOID, VOID, [OfflinePunchSyncRemoteSource], [2]);
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AvailableRole, 'AvailableRole', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
initMetadataForCompanion(Companion_10);
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AvailableCustomBreak, 'AvailableCustomBreak', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
initMetadataForCompanion(Companion_11);
initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ClockedOutInfo, 'ClockedOutInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
initMetadataForClass(ClockedInInfo, 'ClockedInInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
initMetadataForClass(OnBreakInfo, 'OnBreakInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
initMetadataForClass(ActiveBreak, 'ActiveBreak', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
initMetadataForClass(ActivePunch, 'ActivePunch', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
initMetadataForClass(UserStatusShift, 'UserStatusShift', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
initMetadataForCompanion(Companion_12);
initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiTimePunchUserInformation, 'ApiTimePunchUserInformation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
initMetadataForCoroutine($getCOROUTINE$20, CoroutineImpl);
initMetadataForInterface(IUserStatusAccessor, 'IUserStatusAccessor', VOID, VOID, VOID, [1]);
initMetadataForClass(UserStatusRepository, 'UserStatusRepository', VOID, VOID, [IUserStatusAccessor], [1]);
initMetadataForInterface(IUserStatusRemoteSource, 'IUserStatusRemoteSource', VOID, VOID, VOID, [3]);
initMetadataForCoroutine($getTimePunchesUserStatusCOROUTINE$21, CoroutineImpl);
initMetadataForClass(UserStatusRemoteSource, 'UserStatusRemoteSource', VOID, VOID, [IUserStatusRemoteSource], [3]);
initMetadataForClass(EndCriteria, 'EndCriteria', VOID, Enum);
initMetadataForClass(ClockedOut, 'ClockedOut');
initMetadataForClass(ClockedIn, 'ClockedIn');
initMetadataForClass(OnBreak, 'OnBreak');
initMetadataForClass(Punch, 'Punch');
initMetadataForClass(Shift, 'Shift');
initMetadataForClass(Break, 'Break');
initMetadataForClass(CustomBreak, 'CustomBreak');
initMetadataForClass(User, 'User');
initMetadataForClass(UserStatus, 'UserStatus');
//endregion
function AssignmentMappers() {
}
protoOf(AssignmentMappers).x8z = function (roleId, roleName, roleColor, departmentId, departmentName, logger) {
  return LdrMapperHelpers_instance.y8z(roleId, roleName, logger) ? new Role(RoleMappers_instance.z8z(roleId, roleName, roleColor, departmentId, departmentName, logger)) : LdrMapperHelpers_instance.y8z(departmentId, departmentName, logger) ? new Department(new Department_0(departmentId, departmentName)) : Location_instance;
};
var AssignmentMappers_instance;
function AssignmentMappers_getInstance() {
  return AssignmentMappers_instance;
}
function isValidId($this, _this__u8e3s4) {
  return !(_this__u8e3s4 == null) && _this__u8e3s4.b1(new Long(0, 0)) > 0;
}
function validNameOrLog($this, _this__u8e3s4, logger) {
  var tmp;
  // Inline function 'kotlin.text.isNullOrBlank' call
  if (_this__u8e3s4 == null || isBlank(_this__u8e3s4)) {
    if (logger == null)
      null;
    else {
      logger.j6e(new InfrastructureIssue(Subsystem_REST_getInstance(), ProcessingPhase_MAPPING_getInstance(), Impact_MEDIUM_getInstance(), '' + getKClass(RoleMappers).pa() + ' | Role/Department name is null or blank'));
    }
    tmp = null;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function LdrMapperHelpers() {
}
protoOf(LdrMapperHelpers).y8z = function (id, name, logger) {
  if (!isValidId(this, id))
    return false;
  if (validNameOrLog(this, name, logger) == null)
    return false;
  return true;
};
var LdrMapperHelpers_instance;
function LdrMapperHelpers_getInstance() {
  return LdrMapperHelpers_instance;
}
function RoleMappers() {
}
protoOf(RoleMappers).z8z = function (id, name, color, departmentId, departmentName, logger) {
  var tmp;
  if (color == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.ifBlank' call
    var tmp_0;
    if (isBlank(color)) {
      tmp_0 = null;
    } else {
      tmp_0 = color;
    }
    tmp = tmp_0;
  }
  var tmp_1 = tmp;
  var tmp_2;
  if (LdrMapperHelpers_instance.y8z(departmentId, departmentName, logger)) {
    tmp_2 = new Department_0(departmentId, departmentName);
  } else {
    tmp_2 = null;
  }
  return new Role_0(id, name, tmp_1, tmp_2);
};
var RoleMappers_instance;
function RoleMappers_getInstance() {
  return RoleMappers_instance;
}
function Location() {
}
protoOf(Location).toString = function () {
  return 'Location';
};
protoOf(Location).hashCode = function () {
  return -370030669;
};
protoOf(Location).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Location))
    return false;
  other instanceof Location || THROW_CCE();
  return true;
};
var Location_instance;
function Location_getInstance() {
  return Location_instance;
}
function Role(role) {
  this.a90_1 = role;
}
protoOf(Role).toString = function () {
  return 'Role(role=' + this.a90_1.toString() + ')';
};
protoOf(Role).hashCode = function () {
  return this.a90_1.hashCode();
};
protoOf(Role).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Role))
    return false;
  var tmp0_other_with_cast = other instanceof Role ? other : THROW_CCE();
  if (!this.a90_1.equals(tmp0_other_with_cast.a90_1))
    return false;
  return true;
};
function Department(department) {
  this.b90_1 = department;
}
protoOf(Department).toString = function () {
  return 'Department(department=' + this.b90_1.toString() + ')';
};
protoOf(Department).hashCode = function () {
  return this.b90_1.hashCode();
};
protoOf(Department).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Department))
    return false;
  var tmp0_other_with_cast = other instanceof Department ? other : THROW_CCE();
  if (!this.b90_1.equals(tmp0_other_with_cast.b90_1))
    return false;
  return true;
};
function Department_0(id, name) {
  this.c90_1 = id;
  this.d90_1 = name;
}
protoOf(Department_0).toString = function () {
  return 'Department(id=' + this.c90_1.toString() + ', name=' + this.d90_1 + ')';
};
protoOf(Department_0).hashCode = function () {
  var result = this.c90_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.d90_1) | 0;
  return result;
};
protoOf(Department_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Department_0))
    return false;
  var tmp0_other_with_cast = other instanceof Department_0 ? other : THROW_CCE();
  if (!this.c90_1.equals(tmp0_other_with_cast.c90_1))
    return false;
  if (!(this.d90_1 === tmp0_other_with_cast.d90_1))
    return false;
  return true;
};
function Role_0(id, name, color, department) {
  this.e90_1 = id;
  this.f90_1 = name;
  this.g90_1 = color;
  this.h90_1 = department;
}
protoOf(Role_0).toString = function () {
  return 'Role(id=' + this.e90_1.toString() + ', name=' + this.f90_1 + ', color=' + this.g90_1 + ', department=' + toString(this.h90_1) + ')';
};
protoOf(Role_0).hashCode = function () {
  var result = this.e90_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.f90_1) | 0;
  result = imul(result, 31) + (this.g90_1 == null ? 0 : getStringHashCode(this.g90_1)) | 0;
  result = imul(result, 31) + (this.h90_1 == null ? 0 : this.h90_1.hashCode()) | 0;
  return result;
};
protoOf(Role_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Role_0))
    return false;
  var tmp0_other_with_cast = other instanceof Role_0 ? other : THROW_CCE();
  if (!this.e90_1.equals(tmp0_other_with_cast.e90_1))
    return false;
  if (!(this.f90_1 === tmp0_other_with_cast.f90_1))
    return false;
  if (!(this.g90_1 == tmp0_other_with_cast.g90_1))
    return false;
  if (!equals(this.h90_1, tmp0_other_with_cast.h90_1))
    return false;
  return true;
};
function toDomain(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.j90_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.o90_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$0 = new Response_0(item_0.p90_1, item_0.q90_1);
      destination_0.e(tmp$ret$0);
    }
    var tmp$ret$3 = new Content_0(item.k90_1, item.l90_1, item.m90_1, item.n90_1, destination_0);
    destination.e(tmp$ret$3);
  }
  return new Attestation(_this__u8e3s4.i90_1, destination);
}
function ApiAttestation$Content$Companion$$childSerializers$_anonymous__my7qht() {
  return new ArrayListSerializer($serializer_getInstance_0());
}
function Companion() {
  Companion_instance_2 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.r90_1 = [null, null, null, null, lazy(tmp_0, ApiAttestation$Content$Companion$$childSerializers$_anonymous__my7qht)];
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 == null)
    new Companion();
  return Companion_instance_2;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.attestation.data.models.ApiAttestation.Content', this, 5);
  tmp0_serialDesc.wy('language', false);
  tmp0_serialDesc.wy('question', false);
  tmp0_serialDesc.wy('policy', false);
  tmp0_serialDesc.wy('button_text', false);
  tmp0_serialDesc.wy('responses', false);
  this.s90_1 = tmp0_serialDesc;
}
protoOf($serializer).t90 = function (encoder, value) {
  var tmp0_desc = this.s90_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_2().r90_1;
  tmp1_output.zs(tmp0_desc, 0, value.k90_1);
  tmp1_output.zs(tmp0_desc, 1, value.l90_1);
  tmp1_output.zs(tmp0_desc, 2, value.m90_1);
  tmp1_output.zs(tmp0_desc, 3, value.n90_1);
  tmp1_output.bt(tmp0_desc, 4, tmp2_cached[4].t(), value.o90_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.t90(encoder, value instanceof Content ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.s90_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.kr(tmp0_desc);
  var tmp10_cached = Companion_getInstance_2().r90_1;
  if (tmp9_input.as()) {
    tmp4_local0 = tmp9_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.ur(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.wr(tmp0_desc, 4, tmp10_cached[4].t(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.ur(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.wr(tmp0_desc, 4, tmp10_cached[4].t(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.lr(tmp0_desc);
  return Content_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer).xn = function () {
  return this.s90_1;
};
protoOf($serializer).pz = function () {
  var tmp0_cached = Companion_getInstance_2().r90_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4].t()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function Content_init_$Init$(seen0, language, question, policy, buttonText, responses, serializationConstructorMarker, $this) {
  if (!(31 === (31 & seen0))) {
    throwMissingFieldException(seen0, 31, $serializer_getInstance().s90_1);
  }
  $this.k90_1 = language;
  $this.l90_1 = question;
  $this.m90_1 = policy;
  $this.n90_1 = buttonText;
  $this.o90_1 = responses;
  return $this;
}
function Content_init_$Create$(seen0, language, question, policy, buttonText, responses, serializationConstructorMarker) {
  return Content_init_$Init$(seen0, language, question, policy, buttonText, responses, serializationConstructorMarker, objectCreate(protoOf(Content)));
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.attestation.data.models.ApiAttestation.Response', this, 2);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('text', false);
  this.u90_1 = tmp0_serialDesc;
}
protoOf($serializer_0).v90 = function (encoder, value) {
  var tmp0_desc = this.u90_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.p90_1);
  tmp1_output.zs(tmp0_desc, 1, value.q90_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.v90(encoder, value instanceof Response ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.u90_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return Response_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_0).xn = function () {
  return this.u90_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function Response_init_$Init$(seen0, id, text, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_0().u90_1);
  }
  $this.p90_1 = id;
  $this.q90_1 = text;
  return $this;
}
function Response_init_$Create$(seen0, id, text, serializationConstructorMarker) {
  return Response_init_$Init$(seen0, id, text, serializationConstructorMarker, objectCreate(protoOf(Response)));
}
function ApiAttestation$Companion$$childSerializers$_anonymous__yjl0ic() {
  return new ArrayListSerializer($serializer_getInstance());
}
function Content() {
}
protoOf(Content).toString = function () {
  return 'Content(language=' + this.k90_1 + ', question=' + this.l90_1 + ', policy=' + this.m90_1 + ', buttonText=' + this.n90_1 + ', responses=' + toString_0(this.o90_1) + ')';
};
protoOf(Content).hashCode = function () {
  var result = getStringHashCode(this.k90_1);
  result = imul(result, 31) + getStringHashCode(this.l90_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.m90_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.n90_1) | 0;
  result = imul(result, 31) + hashCode(this.o90_1) | 0;
  return result;
};
protoOf(Content).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Content))
    return false;
  var tmp0_other_with_cast = other instanceof Content ? other : THROW_CCE();
  if (!(this.k90_1 === tmp0_other_with_cast.k90_1))
    return false;
  if (!(this.l90_1 === tmp0_other_with_cast.l90_1))
    return false;
  if (!(this.m90_1 === tmp0_other_with_cast.m90_1))
    return false;
  if (!(this.n90_1 === tmp0_other_with_cast.n90_1))
    return false;
  if (!equals(this.o90_1, tmp0_other_with_cast.o90_1))
    return false;
  return true;
};
function Response() {
}
protoOf(Response).toString = function () {
  return 'Response(id=' + this.p90_1.toString() + ', text=' + this.q90_1 + ')';
};
protoOf(Response).hashCode = function () {
  var result = this.p90_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.q90_1) | 0;
  return result;
};
protoOf(Response).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Response))
    return false;
  var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
  if (!this.p90_1.equals(tmp0_other_with_cast.p90_1))
    return false;
  if (!(this.q90_1 === tmp0_other_with_cast.q90_1))
    return false;
  return true;
};
function Companion_0() {
  Companion_instance_3 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.w90_1 = [null, lazy(tmp_0, ApiAttestation$Companion$$childSerializers$_anonymous__yjl0ic)];
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 == null)
    new Companion_0();
  return Companion_instance_3;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.attestation.data.models.ApiAttestation', this, 2);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('contents', false);
  this.x90_1 = tmp0_serialDesc;
}
protoOf($serializer_1).y90 = function (encoder, value) {
  var tmp0_desc = this.x90_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_3().w90_1;
  tmp1_output.vs(tmp0_desc, 0, value.i90_1);
  tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1].t(), value.j90_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.y90(encoder, value instanceof ApiAttestation ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.x90_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  var tmp7_cached = Companion_getInstance_3().w90_1;
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ApiAttestation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_1).xn = function () {
  return this.x90_1;
};
protoOf($serializer_1).pz = function () {
  var tmp0_cached = Companion_getInstance_3().w90_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), tmp0_cached[1].t()];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ApiAttestation_init_$Init$(seen0, id, contents, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_1().x90_1);
  }
  $this.i90_1 = id;
  $this.j90_1 = contents;
  return $this;
}
function ApiAttestation_init_$Create$(seen0, id, contents, serializationConstructorMarker) {
  return ApiAttestation_init_$Init$(seen0, id, contents, serializationConstructorMarker, objectCreate(protoOf(ApiAttestation)));
}
function ApiAttestation(id, contents) {
  Companion_getInstance_3();
  this.i90_1 = id;
  this.j90_1 = contents;
}
protoOf(ApiAttestation).toString = function () {
  return 'ApiAttestation(id=' + this.i90_1.toString() + ', contents=' + toString_0(this.j90_1) + ')';
};
protoOf(ApiAttestation).hashCode = function () {
  var result = this.i90_1.hashCode();
  result = imul(result, 31) + hashCode(this.j90_1) | 0;
  return result;
};
protoOf(ApiAttestation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAttestation))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAttestation ? other : THROW_CCE();
  if (!this.i90_1.equals(tmp0_other_with_cast.i90_1))
    return false;
  if (!equals(this.j90_1, tmp0_other_with_cast.j90_1))
    return false;
  return true;
};
function Companion_1() {
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.attestation.data.models.ApiSaveAttestationRequest.QuestionResponse', this, 2);
  tmp0_serialDesc.wy('question_id', false);
  tmp0_serialDesc.wy('response_id', false);
  this.z90_1 = tmp0_serialDesc;
}
protoOf($serializer_2).a91 = function (encoder, value) {
  var tmp0_desc = this.z90_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.b91_1);
  tmp1_output.vs(tmp0_desc, 1, value.c91_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_2).yn = function (encoder, value) {
  return this.a91(encoder, value instanceof QuestionResponse ? value : THROW_CCE());
};
protoOf($serializer_2).zn = function (decoder) {
  var tmp0_desc = this.z90_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = new Long(0, 0);
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.qr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.qr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return QuestionResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_2).xn = function () {
  return this.z90_1;
};
protoOf($serializer_2).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), LongSerializer_getInstance()];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function QuestionResponse_init_$Init$(seen0, questionId, responseId, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_2().z90_1);
  }
  $this.b91_1 = questionId;
  $this.c91_1 = responseId;
  return $this;
}
function QuestionResponse_init_$Create$(seen0, questionId, responseId, serializationConstructorMarker) {
  return QuestionResponse_init_$Init$(seen0, questionId, responseId, serializationConstructorMarker, objectCreate(protoOf(QuestionResponse)));
}
function ApiSaveAttestationRequest$Companion$$childSerializers$_anonymous__tmoocs() {
  return new ArrayListSerializer($serializer_getInstance_2());
}
function QuestionResponse(questionId, responseId) {
  this.b91_1 = questionId;
  this.c91_1 = responseId;
}
protoOf(QuestionResponse).toString = function () {
  return 'QuestionResponse(questionId=' + this.b91_1.toString() + ', responseId=' + this.c91_1.toString() + ')';
};
protoOf(QuestionResponse).hashCode = function () {
  var result = this.b91_1.hashCode();
  result = imul(result, 31) + this.c91_1.hashCode() | 0;
  return result;
};
protoOf(QuestionResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof QuestionResponse))
    return false;
  var tmp0_other_with_cast = other instanceof QuestionResponse ? other : THROW_CCE();
  if (!this.b91_1.equals(tmp0_other_with_cast.b91_1))
    return false;
  if (!this.c91_1.equals(tmp0_other_with_cast.c91_1))
    return false;
  return true;
};
function Companion_2() {
  Companion_instance_5 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.d91_1 = [lazy(tmp_0, ApiSaveAttestationRequest$Companion$$childSerializers$_anonymous__tmoocs)];
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 == null)
    new Companion_2();
  return Companion_instance_5;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.attestation.data.models.ApiSaveAttestationRequest', this, 1);
  tmp0_serialDesc.wy('questions', false);
  this.e91_1 = tmp0_serialDesc;
}
protoOf($serializer_3).f91 = function (encoder, value) {
  var tmp0_desc = this.e91_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_5().d91_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.g91_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_3).yn = function (encoder, value) {
  return this.f91(encoder, value instanceof ApiSaveAttestationRequest ? value : THROW_CCE());
};
protoOf($serializer_3).zn = function (decoder) {
  var tmp0_desc = this.e91_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  var tmp6_cached = Companion_getInstance_5().d91_1;
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.wr(tmp0_desc, 0, tmp6_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiSaveAttestationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_3).xn = function () {
  return this.e91_1;
};
protoOf($serializer_3).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_5().d91_1[0].t()];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function ApiSaveAttestationRequest_init_$Init$(seen0, questionResponses, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_3().e91_1);
  }
  $this.g91_1 = questionResponses;
  return $this;
}
function ApiSaveAttestationRequest_init_$Create$(seen0, questionResponses, serializationConstructorMarker) {
  return ApiSaveAttestationRequest_init_$Init$(seen0, questionResponses, serializationConstructorMarker, objectCreate(protoOf(ApiSaveAttestationRequest)));
}
function ApiSaveAttestationRequest(questionResponses) {
  Companion_getInstance_5();
  this.g91_1 = questionResponses;
}
protoOf(ApiSaveAttestationRequest).toString = function () {
  return 'ApiSaveAttestationRequest(questionResponses=' + toString_0(this.g91_1) + ')';
};
protoOf(ApiSaveAttestationRequest).hashCode = function () {
  return hashCode(this.g91_1);
};
protoOf(ApiSaveAttestationRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiSaveAttestationRequest))
    return false;
  var tmp0_other_with_cast = other instanceof ApiSaveAttestationRequest ? other : THROW_CCE();
  if (!equals(this.g91_1, tmp0_other_with_cast.g91_1))
    return false;
  return true;
};
function AttestationPromptRepository(sessionDataProvider, remoteSource) {
  this.h91_1 = sessionDataProvider;
  this.i91_1 = remoteSource;
}
function $getAttestationCOROUTINE$2(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r91_1 = _this__u8e3s4;
}
protoOf($getAttestationCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.s91_1 = this.r91_1.w91_1;
          this.n8_1 = 1;
          suspendResult = this.r91_1.v91_1.q37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.t91_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.r91_1.v91_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.u91_1 = suspendResult;
          this.n8_1 = 3;
          suspendResult = this.s91_1.x91(this.t91_1, this.u91_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 4;
          continue $sm;
        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $saveAttestationCOROUTINE$3(_this__u8e3s4, punchId, attestationId, attestationResponseId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g92_1 = _this__u8e3s4;
  this.h92_1 = punchId;
  this.i92_1 = attestationId;
  this.j92_1 = attestationResponseId;
}
protoOf($saveAttestationCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.k92_1 = this.g92_1.w91_1;
          this.n8_1 = 1;
          suspendResult = this.g92_1.v91_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.l92_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.k92_1.m92(this.l92_1, this.h92_1, new ApiSaveAttestationRequest(listOf(new QuestionResponse(this.i92_1, this.j92_1))), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          return suspendResult;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function AttestationRepositoryImpl(sessionDataProvider, attestationRemoteSource) {
  this.v91_1 = sessionDataProvider;
  this.w91_1 = attestationRemoteSource;
}
protoOf(AttestationRepositoryImpl).n92 = function ($completion) {
  var tmp = new $getAttestationCOROUTINE$2(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(AttestationRepositoryImpl).o92 = function (punchId, attestationId, attestationResponseId, $completion) {
  var tmp = new $saveAttestationCOROUTINE$3(this, punchId, attestationId, attestationResponseId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function AttestationPromptRemoteSource(apiClient) {
  this.p92_1 = apiClient;
}
function AttestationRemoteSource() {
}
function AttestationRemoteSourceImpl$getAttestation$lambda($locationId) {
  return function ($this$get, it) {
    $this$get.o44_1.r3q('location_id', $locationId.toString());
    return Unit_instance;
  };
}
function AttestationRemoteSourceImpl$getAttestation$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function AttestationRemoteSourceImpl$saveAttestationResponse$lambda($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getAttestationCOROUTINE$6(_this__u8e3s4, locationId, companyId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.y92_1 = _this__u8e3s4;
  this.z92_1 = locationId;
  this.a93_1 = companyId;
}
protoOf($getAttestationCOROUTINE$6).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.b93_1 = this.y92_1.u94_1;
          var tmp_1 = this;
          tmp_1.c93_1 = 'company/' + this.a93_1.toString() + '/attestation';
          var tmp_2 = this;
          tmp_2.d93_1 = ApiVersion_FEBRUARY_2026_getInstance();
          var tmp_3 = this;
          tmp_3.e93_1 = AttestationRemoteSourceImpl$getAttestation$lambda(this.z92_1);
          this.f93_1 = this.b93_1;
          this.g93_1 = this.c93_1;
          this.h93_1 = this.d93_1;
          this.i93_1 = this.e93_1;
          this.o8_1 = 2;
          var tmp_4 = this;
          tmp_4.k93_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.l93_1 = this.f93_1.f6l_1;
          var tmp_6 = this;
          tmp_6.m93_1 = buildV2Path(this.f93_1, this.g93_1);
          this.n93_1 = this.l93_1;
          this.o93_1 = this.m93_1;
          var tmp_7 = this;
          tmp_7.p93_1 = this.n93_1;
          this.q93_1 = this.p93_1;
          var tmp_8 = this;
          tmp_8.r93_1 = this.q93_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.o93_1);
          headers(this_0, AttestationRemoteSourceImpl$getAttestation$lambda_0(this.h93_1));
          this_0.z5n(this.i93_1);
          tmp_9.s93_1 = this_0;
          this.t93_1 = this.r93_1;
          this.u93_1 = this.s93_1;
          this.u93_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.v93_1 = this.t93_1;
          var tmp_11 = this;
          tmp_11.w93_1 = this.u93_1;
          this.x93_1 = this.v93_1;
          this.y93_1 = this.w93_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.y93_1, this.x93_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.z93_1 = suspendResult;
          var tmp_12 = this;
          this.k93_1;
          var value = this.z93_1;
          tmp_12.j93_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.a94_1 = this.q8_1;
            var tmp_14 = this;
            throw this.a94_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.b94_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.b94_1;
              tmp_16.j93_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.c94_1 = this.j93_1;
          this.d94_1 = this.c94_1;
          this.e94_1 = Result__exceptionOrNull_impl_p6xea9(this.d94_1);
          if (this.e94_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.d94_1);
            tmp_17.g94_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.h94_1 = this.g94_1;
            var tmp_19 = this;
            tmp_19.i94_1 = this.h94_1;
            this.j94_1 = this.i94_1;
            this.k94_1 = this.j94_1.c4u().z43_1;
            var containsArg = this.k94_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_20 = this;
              tmp_20.n94_1 = Companion_instance;
              if (getKClass(ApiAttestation).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.p94_1 = this.j94_1;
                this.q94_1 = this.p94_1;
                this.n8_1 = 6;
                var tmp_22 = this.q94_1.y4u();
                var tmp_23 = getKClass(ApiAttestation);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiAttestation), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.r94_1 = this.j94_1;
                this.s94_1 = this.r94_1;
                this.n8_1 = 5;
                var tmp_27 = this.s94_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.t94_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.j94_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.e94_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_32.f94_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.t94_1;
          tmp_33.l94_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiAttestation), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.o94_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_37 = this;
          tmp_37.o94_1 = suspendResult instanceof ApiAttestation ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.o94_1;
          var tmp_38 = this;
          this.n94_1;
          tmp_38.m94_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.m94_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_43 = this;
          var this_2 = this.m94_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.l94_1 = tmp_44.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.f94_1 = new Result(this.l94_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.f94_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $saveAttestationResponseCOROUTINE$7(_this__u8e3s4, companyId, punchId, apiSaveAttestationRequest, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.d95_1 = _this__u8e3s4;
  this.e95_1 = companyId;
  this.f95_1 = punchId;
  this.g95_1 = apiSaveAttestationRequest;
}
protoOf($saveAttestationResponseCOROUTINE$7).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.h95_1 = this.d95_1.u94_1;
          var tmp_1 = this;
          tmp_1.i95_1 = 'company/' + this.e95_1.toString() + '/time_punches/' + this.f95_1.toString() + '/attestation';
          var tmp_2 = this;
          tmp_2.j95_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.k95_1 = this.h95_1;
          this.l95_1 = this.i95_1;
          this.m95_1 = this.j95_1;
          this.o8_1 = 2;
          var tmp_3 = this;
          tmp_3.o95_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.p95_1 = this.k95_1.f6l_1;
          var tmp_5 = this;
          tmp_5.q95_1 = buildV2Path(this.k95_1, this.l95_1);
          this.r95_1 = this.p95_1;
          this.s95_1 = this.q95_1;
          var tmp_6 = this;
          tmp_6.t95_1 = this.r95_1;
          this.u95_1 = this.t95_1;
          var tmp_7 = this;
          tmp_7.v95_1 = this.u95_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.s95_1);
          contentType(this_0, Application_getInstance().c3v_1);
          headers(this_0, AttestationRemoteSourceImpl$saveAttestationResponse$lambda(this.m95_1));
          var body = this.g95_1;
          if (body == null) {
            this_0.s4r_1 = NullBody_instance;
            var tmp_9 = getKClass(ApiSaveAttestationRequest);
            var tmp_10;
            try {
              tmp_10 = createKType(getKClass(ApiSaveAttestationRequest), arrayOf([]), false);
            } catch ($p) {
              var tmp_11;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_11 = null;
              } else {
                throw $p;
              }
              tmp_10 = tmp_11;
            }
            this_0.n4x(new TypeInfo(tmp_9, tmp_10));
          } else {
            if (body instanceof OutgoingContent) {
              this_0.s4r_1 = body;
              this_0.n4x(null);
            } else {
              this_0.s4r_1 = body;
              var tmp_12 = getKClass(ApiSaveAttestationRequest);
              var tmp_13;
              try {
                tmp_13 = createKType(getKClass(ApiSaveAttestationRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_14;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3_0 = $p;
                  tmp_14 = null;
                } else {
                  throw $p;
                }
                tmp_13 = tmp_14;
              }
              this_0.n4x(new TypeInfo(tmp_12, tmp_13));
            }
          }

          tmp_8.w95_1 = this_0;
          this.x95_1 = this.v95_1;
          this.y95_1 = this.w95_1;
          this.y95_1.q4r_1 = Companion_getInstance_0().g41_1;
          var tmp_15 = this;
          tmp_15.z95_1 = this.x95_1;
          var tmp_16 = this;
          tmp_16.a96_1 = this.y95_1;
          this.b96_1 = this.z95_1;
          this.c96_1 = this.a96_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.c96_1, this.b96_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.d96_1 = suspendResult;
          var tmp_17 = this;
          this.o95_1;
          var value = this.d96_1;
          tmp_17.n95_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_18 = this.q8_1;
          if (tmp_18 instanceof CancellationException) {
            this.e96_1 = this.q8_1;
            var tmp_19 = this;
            throw this.e96_1;
          } else {
            var tmp_20 = this.q8_1;
            if (tmp_20 instanceof Error) {
              this.f96_1 = this.q8_1;
              var tmp_21 = this;
              var exception = this.f96_1;
              tmp_21.n95_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.g96_1 = this.n95_1;
          this.h96_1 = this.g96_1;
          this.i96_1 = Result__exceptionOrNull_impl_p6xea9(this.h96_1);
          if (this.i96_1 == null) {
            var tmp_22 = this;
            var tmp_23 = _Result___get_value__impl__bjfvqg(this.h96_1);
            tmp_22.k96_1 = (tmp_23 == null ? true : !(tmp_23 == null)) ? tmp_23 : THROW_CCE();
            this.l96_1 = this.k96_1;
            var tmp_24 = this;
            tmp_24.m96_1 = this.l96_1;
            this.n96_1 = this.m96_1;
            this.o96_1 = this.n96_1.c4u().z43_1;
            var containsArg = this.o96_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_25 = this;
              tmp_25.r96_1 = Companion_instance;
              if (getKClass(Unit).equals(getKClass(Unit))) {
                var tmp_26 = this;
                tmp_26.s96_1 = this.n96_1;
                this.t96_1 = this.s96_1;
                this.n8_1 = 6;
                var tmp_27 = this.t96_1.y4u();
                var tmp_28 = getKClass(Unit);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(Unit), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_1 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_31 = this;
                tmp_31.u96_1 = this.n96_1;
                this.v96_1 = this.u96_1;
                this.n8_1 = 5;
                var tmp_32 = this.v96_1.y4u();
                var tmp_33 = getKClass(JsonElement);
                var tmp_34;
                try {
                  tmp_34 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_35;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_2 = $p;
                    tmp_35 = null;
                  } else {
                    throw $p;
                  }
                  tmp_34 = tmp_35;
                }
                suspendResult = tmp_32.a4u(new TypeInfo(tmp_33, tmp_34), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_36 = this;
              tmp_36.w96_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.n96_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_37 = this;
            var it = this.i96_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_37.j96_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_38 = this;
          this.w96_1;
          tmp_38.p96_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(Unit), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_39;
            if (tmp2 instanceof JsonObject) {
              tmp_39 = tmp2.c3p('data');
            } else {
              tmp_39 = false;
            }
            if (tmp_39) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_40;
              if (dataValue instanceof JsonObject) {
                tmp_40 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_40 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_40 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_40;
              if (shouldAttemptUnwrap) {
                try {
                  json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            json.s5z(serializer_0, tmp2);
          }
           while (false);
          this.n8_1 = 7;
          continue $sm;
        case 6:
          if (!(suspendResult instanceof Unit))
            THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp_41 = this;
          this.r96_1;
          tmp_41.q96_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_42 = this.q8_1;
          if (tmp_42 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_43 = this;
            throw e_0;
          } else {
            var tmp_44 = this.q8_1;
            if (tmp_44 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_45 = this;
              tmp_45.q96_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_46 = this;
          var this_2 = this.q96_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_47;
          if (exception_1 == null) {
            var tmp_48 = _Result___get_value__impl__bjfvqg(this_2);
            (tmp_48 == null ? true : !(tmp_48 == null)) || THROW_CCE();
            tmp_47 = new Result(_Result___init__impl__xyqfz8(Unit_instance));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_47 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_46.p96_1 = tmp_47.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.j96_1 = new Result(this.p96_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.j96_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function AttestationRemoteSourceImpl(apiClient) {
  this.u94_1 = apiClient;
}
protoOf(AttestationRemoteSourceImpl).x91 = function (locationId, companyId, $completion) {
  var tmp = new $getAttestationCOROUTINE$6(this, locationId, companyId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(AttestationRemoteSourceImpl).m92 = function (companyId, punchId, apiSaveAttestationRequest, $completion) {
  var tmp = new $saveAttestationResponseCOROUTINE$7(this, companyId, punchId, apiSaveAttestationRequest, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function IAttestationPromptRemoteSource() {
}
function Content_0(language, question, policy, buttonText, responses) {
  this.x96_1 = language;
  this.y96_1 = question;
  this.z96_1 = policy;
  this.a97_1 = buttonText;
  this.b97_1 = responses;
}
protoOf(Content_0).toString = function () {
  return 'Content(language=' + this.x96_1 + ', question=' + this.y96_1 + ', policy=' + this.z96_1 + ', buttonText=' + this.a97_1 + ', responses=' + toString_0(this.b97_1) + ')';
};
protoOf(Content_0).hashCode = function () {
  var result = getStringHashCode(this.x96_1);
  result = imul(result, 31) + getStringHashCode(this.y96_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.z96_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.a97_1) | 0;
  result = imul(result, 31) + hashCode(this.b97_1) | 0;
  return result;
};
protoOf(Content_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Content_0))
    return false;
  var tmp0_other_with_cast = other instanceof Content_0 ? other : THROW_CCE();
  if (!(this.x96_1 === tmp0_other_with_cast.x96_1))
    return false;
  if (!(this.y96_1 === tmp0_other_with_cast.y96_1))
    return false;
  if (!(this.z96_1 === tmp0_other_with_cast.z96_1))
    return false;
  if (!(this.a97_1 === tmp0_other_with_cast.a97_1))
    return false;
  if (!equals(this.b97_1, tmp0_other_with_cast.b97_1))
    return false;
  return true;
};
function Response_0(id, text) {
  this.c97_1 = id;
  this.d97_1 = text;
}
protoOf(Response_0).toString = function () {
  return 'Response(id=' + this.c97_1.toString() + ', text=' + this.d97_1 + ')';
};
protoOf(Response_0).hashCode = function () {
  var result = this.c97_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.d97_1) | 0;
  return result;
};
protoOf(Response_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Response_0))
    return false;
  var tmp0_other_with_cast = other instanceof Response_0 ? other : THROW_CCE();
  if (!this.c97_1.equals(tmp0_other_with_cast.c97_1))
    return false;
  if (!(this.d97_1 === tmp0_other_with_cast.d97_1))
    return false;
  return true;
};
function Attestation(id, contents) {
  this.e97_1 = id;
  this.f97_1 = contents;
}
protoOf(Attestation).toString = function () {
  return 'Attestation(id=' + this.e97_1.toString() + ', contents=' + toString_0(this.f97_1) + ')';
};
protoOf(Attestation).hashCode = function () {
  var result = this.e97_1.hashCode();
  result = imul(result, 31) + hashCode(this.f97_1) | 0;
  return result;
};
protoOf(Attestation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Attestation))
    return false;
  var tmp0_other_with_cast = other instanceof Attestation ? other : THROW_CCE();
  if (!this.e97_1.equals(tmp0_other_with_cast.e97_1))
    return false;
  if (!equals(this.f97_1, tmp0_other_with_cast.f97_1))
    return false;
  return true;
};
function AttestationRepository() {
}
function IAttestationPromptAccessor() {
}
function IAttestationPromptMutator() {
}
function toDomain_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.j97_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
    var _iterator__ex2g4s = tmp0_safe_receiver.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      var tmp$ret$0 = toDomain_1(item);
      destination.e(tmp$ret$0);
    }
    tmp = destination;
  }
  var tmp_0 = tmp;
  var tmp_1;
  switch (_this__u8e3s4.q97_1) {
    case 'in':
      tmp_1 = Status_IN_getInstance();
      break;
    case 'out':
      tmp_1 = Status_OUT_getInstance();
      break;
    default:
      tmp_1 = Status_INTERMEDIATE_getInstance();
      break;
  }
  var tmp2_safe_receiver = _this__u8e3s4.r97_1;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp2_safe_receiver, 10));
    var _iterator__ex2g4s_0 = tmp2_safe_receiver.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$3 = toDomain_2(item_0);
      destination_0.e(tmp$ret$3);
    }
    tmp_2 = destination_0;
  }
  var tmp_3 = tmp_2;
  var tmp3_safe_receiver = _this__u8e3s4.v97_1;
  return new ClockResponse(_this__u8e3s4.g97_1, _this__u8e3s4.h97_1, _this__u8e3s4.i97_1, tmp_0, _this__u8e3s4.k97_1, _this__u8e3s4.l97_1, _this__u8e3s4.m97_1, _this__u8e3s4.n97_1, _this__u8e3s4.o97_1, _this__u8e3s4.p97_1, tmp_1, tmp_3, _this__u8e3s4.s97_1, _this__u8e3s4.t97_1, _this__u8e3s4.u97_1, tmp3_safe_receiver == null ? null : toDomain_3(tmp3_safe_receiver), _this__u8e3s4.w97_1);
}
function toDomain_1(_this__u8e3s4) {
  return new Department_1(_this__u8e3s4.x97_1, _this__u8e3s4.y97_1);
}
function toDomain_2(_this__u8e3s4) {
  var tmp0_id = _this__u8e3s4.z97_1;
  var tmp1_name = _this__u8e3s4.a98_1;
  var tmp2_color = _this__u8e3s4.b98_1;
  var tmp3_departmentId = _this__u8e3s4.c98_1;
  var tmp4_departmentName = _this__u8e3s4.d98_1;
  return new Role_1(tmp0_id, tmp1_name, tmp3_departmentId, tmp4_departmentName, tmp2_color);
}
function toDomain_3(_this__u8e3s4) {
  return new ClockUserResponse(_this__u8e3s4.e98_1);
}
function ApiClockRequest$Companion$$childSerializers$_anonymous__rkwrjl() {
  var tmp = values();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = ['clock_in', 'clock_out', 'start_paid_break', 'start_unpaid_break', 'start_custom_break', 'end_break'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null, null, null, null, null];
  return createAnnotatedEnumSerializer('com.sevenshifts.shared.data.punch.clock.data.models.TimePunchUserAction', tmp, tmp_0, tmp$ret$5, null);
}
function ApiClockRequest_init_$Init$(action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, $this) {
  departmentId = departmentId === VOID ? null : departmentId;
  roleId = roleId === VOID ? null : roleId;
  selectedRoleId = selectedRoleId === VOID ? null : selectedRoleId;
  customBreakId = customBreakId === VOID ? null : customBreakId;
  healthCheckResponseId = healthCheckResponseId === VOID ? null : healthCheckResponseId;
  tips = tips === VOID ? null : tips;
  // Inline function 'kotlin.takeIf' call
  var this_0 = action.equals(TimePunchUserAction_CLOCK_OUT_getInstance());
  var tmp;
  if (this_0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp_0 = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_1 = setOf([TimePunchUserAction_START_PAID_BREAK_getInstance(), TimePunchUserAction_START_UNPAID_BREAK_getInstance(), TimePunchUserAction_START_CUSTOM_BREAK_getInstance()]).u1(action);
  var tmp_1;
  if (this_1) {
    tmp_1 = this_1;
  } else {
    tmp_1 = null;
  }
  var tmp$ret$3 = tmp_1;
  ApiClockRequest.call($this, action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, tmp_0, tmp$ret$3);
  return $this;
}
function ApiClockRequest_init_$Create$(action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips) {
  return ApiClockRequest_init_$Init$(action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, objectCreate(protoOf(ApiClockRequest)));
}
function Companion_3() {
  Companion_instance_6 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.f98_1 = [lazy(tmp_0, ApiClockRequest$Companion$$childSerializers$_anonymous__rkwrjl), null, null, null, null, null, null, null, null, null, null];
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 == null)
    new Companion_3();
  return Companion_instance_6;
}
function $serializer_4() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.clock.data.models.ApiClockRequest', this, 11);
  tmp0_serialDesc.wy('time_punch_user_action', false);
  tmp0_serialDesc.wy('employee_id', false);
  tmp0_serialDesc.wy('location_hash', false);
  tmp0_serialDesc.wy('department_id', true);
  tmp0_serialDesc.wy('role_id', true);
  tmp0_serialDesc.wy('selected_role_id', true);
  tmp0_serialDesc.wy('custom_break_id', true);
  tmp0_serialDesc.wy('health_check_response_id', true);
  tmp0_serialDesc.wy('tips', true);
  tmp0_serialDesc.wy('punch_out', true);
  tmp0_serialDesc.wy('break', true);
  this.g98_1 = tmp0_serialDesc;
}
protoOf($serializer_4).h98 = function (encoder, value) {
  var tmp0_desc = this.g98_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_6().f98_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.i98_1);
  tmp1_output.zs(tmp0_desc, 1, value.j98_1);
  tmp1_output.zs(tmp0_desc, 2, value.k98_1);
  if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.l98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 3, LongSerializer_getInstance(), value.l98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.m98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 4, LongSerializer_getInstance(), value.m98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.n98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 5, LongSerializer_getInstance(), value.n98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.o98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 6, LongSerializer_getInstance(), value.o98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.p98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 7, StringSerializer_getInstance(), value.p98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.q98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 8, DoubleSerializer_getInstance(), value.q98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 9) ? true : !(value.r98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 9, BooleanSerializer_getInstance(), value.r98_1);
  }
  if (tmp1_output.ht(tmp0_desc, 10) ? true : !(value.s98_1 == null)) {
    tmp1_output.dt(tmp0_desc, 10, BooleanSerializer_getInstance(), value.s98_1);
  }
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_4).yn = function (encoder, value) {
  return this.h98(encoder, value instanceof ApiClockRequest ? value : THROW_CCE());
};
protoOf($serializer_4).zn = function (decoder) {
  var tmp0_desc = this.g98_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_input = decoder.kr(tmp0_desc);
  var tmp16_cached = Companion_getInstance_6().f98_1;
  if (tmp15_input.as()) {
    tmp4_local0 = tmp15_input.wr(tmp0_desc, 0, tmp16_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp15_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp15_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp15_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp15_input.yr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp15_input.yr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp15_input.yr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp15_input.yr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp15_input.yr(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp15_input.yr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp15_input.yr(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp15_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp15_input.wr(tmp0_desc, 0, tmp16_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp15_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp15_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp15_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp15_input.yr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp15_input.yr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp15_input.yr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp15_input.yr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp15_input.yr(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp15_input.yr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp15_input.yr(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp15_input.lr(tmp0_desc);
  return ApiClockRequest_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
};
protoOf($serializer_4).xn = function () {
  return this.g98_1;
};
protoOf($serializer_4).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_6().f98_1[0].t(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
};
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 == null)
    new $serializer_4();
  return $serializer_instance_4;
}
function ApiClockRequest_init_$Init$_0(seen0, action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, punchOut, isBreak, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_4().g98_1);
  }
  $this.i98_1 = action;
  $this.j98_1 = employeePunchId;
  $this.k98_1 = locationHash;
  if (0 === (seen0 & 8))
    $this.l98_1 = null;
  else
    $this.l98_1 = departmentId;
  if (0 === (seen0 & 16))
    $this.m98_1 = null;
  else
    $this.m98_1 = roleId;
  if (0 === (seen0 & 32))
    $this.n98_1 = null;
  else
    $this.n98_1 = selectedRoleId;
  if (0 === (seen0 & 64))
    $this.o98_1 = null;
  else
    $this.o98_1 = customBreakId;
  if (0 === (seen0 & 128))
    $this.p98_1 = null;
  else
    $this.p98_1 = healthCheckResponseId;
  if (0 === (seen0 & 256))
    $this.q98_1 = null;
  else
    $this.q98_1 = tips;
  if (0 === (seen0 & 512))
    $this.r98_1 = null;
  else
    $this.r98_1 = punchOut;
  if (0 === (seen0 & 1024))
    $this.s98_1 = null;
  else
    $this.s98_1 = isBreak;
  return $this;
}
function ApiClockRequest_init_$Create$_0(seen0, action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, punchOut, isBreak, serializationConstructorMarker) {
  return ApiClockRequest_init_$Init$_0(seen0, action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, punchOut, isBreak, serializationConstructorMarker, objectCreate(protoOf(ApiClockRequest)));
}
function ApiClockRequest(action, employeePunchId, locationHash, departmentId, roleId, selectedRoleId, customBreakId, healthCheckResponseId, tips, punchOut, isBreak) {
  Companion_getInstance_6();
  departmentId = departmentId === VOID ? null : departmentId;
  roleId = roleId === VOID ? null : roleId;
  selectedRoleId = selectedRoleId === VOID ? null : selectedRoleId;
  customBreakId = customBreakId === VOID ? null : customBreakId;
  healthCheckResponseId = healthCheckResponseId === VOID ? null : healthCheckResponseId;
  tips = tips === VOID ? null : tips;
  punchOut = punchOut === VOID ? null : punchOut;
  isBreak = isBreak === VOID ? null : isBreak;
  this.i98_1 = action;
  this.j98_1 = employeePunchId;
  this.k98_1 = locationHash;
  this.l98_1 = departmentId;
  this.m98_1 = roleId;
  this.n98_1 = selectedRoleId;
  this.o98_1 = customBreakId;
  this.p98_1 = healthCheckResponseId;
  this.q98_1 = tips;
  this.r98_1 = punchOut;
  this.s98_1 = isBreak;
}
protoOf(ApiClockRequest).toString = function () {
  return 'ApiClockRequest(action=' + this.i98_1.toString() + ', employeePunchId=' + this.j98_1 + ', locationHash=' + this.k98_1 + ', departmentId=' + toString(this.l98_1) + ', roleId=' + toString(this.m98_1) + ', selectedRoleId=' + toString(this.n98_1) + ', customBreakId=' + toString(this.o98_1) + ', healthCheckResponseId=' + this.p98_1 + ', tips=' + this.q98_1 + ', punchOut=' + this.r98_1 + ', isBreak=' + this.s98_1 + ')';
};
protoOf(ApiClockRequest).hashCode = function () {
  var result = this.i98_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.j98_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.k98_1) | 0;
  result = imul(result, 31) + (this.l98_1 == null ? 0 : this.l98_1.hashCode()) | 0;
  result = imul(result, 31) + (this.m98_1 == null ? 0 : this.m98_1.hashCode()) | 0;
  result = imul(result, 31) + (this.n98_1 == null ? 0 : this.n98_1.hashCode()) | 0;
  result = imul(result, 31) + (this.o98_1 == null ? 0 : this.o98_1.hashCode()) | 0;
  result = imul(result, 31) + (this.p98_1 == null ? 0 : getStringHashCode(this.p98_1)) | 0;
  result = imul(result, 31) + (this.q98_1 == null ? 0 : getNumberHashCode(this.q98_1)) | 0;
  result = imul(result, 31) + (this.r98_1 == null ? 0 : getBooleanHashCode(this.r98_1)) | 0;
  result = imul(result, 31) + (this.s98_1 == null ? 0 : getBooleanHashCode(this.s98_1)) | 0;
  return result;
};
protoOf(ApiClockRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiClockRequest))
    return false;
  var tmp0_other_with_cast = other instanceof ApiClockRequest ? other : THROW_CCE();
  if (!this.i98_1.equals(tmp0_other_with_cast.i98_1))
    return false;
  if (!(this.j98_1 === tmp0_other_with_cast.j98_1))
    return false;
  if (!(this.k98_1 === tmp0_other_with_cast.k98_1))
    return false;
  if (!equals(this.l98_1, tmp0_other_with_cast.l98_1))
    return false;
  if (!equals(this.m98_1, tmp0_other_with_cast.m98_1))
    return false;
  if (!equals(this.n98_1, tmp0_other_with_cast.n98_1))
    return false;
  if (!equals(this.o98_1, tmp0_other_with_cast.o98_1))
    return false;
  if (!(this.p98_1 == tmp0_other_with_cast.p98_1))
    return false;
  if (!equals(this.q98_1, tmp0_other_with_cast.q98_1))
    return false;
  if (!(this.r98_1 == tmp0_other_with_cast.r98_1))
    return false;
  if (!(this.s98_1 == tmp0_other_with_cast.s98_1))
    return false;
  return true;
};
function $serializer_5() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.clock.data.models.ApiClockResponse.ApiClockUserResponse', this, 1);
  tmp0_serialDesc.wy('photo_url', false);
  this.t98_1 = tmp0_serialDesc;
}
protoOf($serializer_5).u98 = function (encoder, value) {
  var tmp0_desc = this.t98_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.e98_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_5).yn = function (encoder, value) {
  return this.u98(encoder, value instanceof ApiClockUserResponse ? value : THROW_CCE());
};
protoOf($serializer_5).zn = function (decoder) {
  var tmp0_desc = this.t98_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiClockUserResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_5).xn = function () {
  return this.t98_1;
};
protoOf($serializer_5).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 == null)
    new $serializer_5();
  return $serializer_instance_5;
}
function ApiClockUserResponse_init_$Init$(seen0, photoUrl, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_5().t98_1);
  }
  $this.e98_1 = photoUrl;
  return $this;
}
function ApiClockUserResponse_init_$Create$(seen0, photoUrl, serializationConstructorMarker) {
  return ApiClockUserResponse_init_$Init$(seen0, photoUrl, serializationConstructorMarker, objectCreate(protoOf(ApiClockUserResponse)));
}
function $serializer_6() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.clock.data.models.ApiClockResponse.ApiRole', this, 5);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('color', false);
  tmp0_serialDesc.wy('department_id', false);
  tmp0_serialDesc.wy('department_name', false);
  this.v98_1 = tmp0_serialDesc;
}
protoOf($serializer_6).w98 = function (encoder, value) {
  var tmp0_desc = this.v98_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.z97_1);
  tmp1_output.zs(tmp0_desc, 1, value.a98_1);
  tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.b98_1);
  tmp1_output.dt(tmp0_desc, 3, LongSerializer_getInstance(), value.c98_1);
  tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.d98_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_6).yn = function (encoder, value) {
  return this.w98(encoder, value instanceof ApiRole ? value : THROW_CCE());
};
protoOf($serializer_6).zn = function (decoder) {
  var tmp0_desc = this.v98_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.kr(tmp0_desc);
  if (tmp9_input.as()) {
    tmp4_local0 = tmp9_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.lr(tmp0_desc);
  return ApiRole_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_6).xn = function () {
  return this.v98_1;
};
protoOf($serializer_6).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 == null)
    new $serializer_6();
  return $serializer_instance_6;
}
function ApiRole_init_$Init$(seen0, id, name, color, departmentId, departmentName, serializationConstructorMarker, $this) {
  if (!(31 === (31 & seen0))) {
    throwMissingFieldException(seen0, 31, $serializer_getInstance_6().v98_1);
  }
  $this.z97_1 = id;
  $this.a98_1 = name;
  $this.b98_1 = color;
  $this.c98_1 = departmentId;
  $this.d98_1 = departmentName;
  return $this;
}
function ApiRole_init_$Create$(seen0, id, name, color, departmentId, departmentName, serializationConstructorMarker) {
  return ApiRole_init_$Init$(seen0, id, name, color, departmentId, departmentName, serializationConstructorMarker, objectCreate(protoOf(ApiRole)));
}
function $serializer_7() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.clock.data.models.ApiClockResponse.ApiDepartment', this, 2);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('name', false);
  this.x98_1 = tmp0_serialDesc;
}
protoOf($serializer_7).y98 = function (encoder, value) {
  var tmp0_desc = this.x98_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.x97_1);
  tmp1_output.zs(tmp0_desc, 1, value.y97_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_7).yn = function (encoder, value) {
  return this.y98(encoder, value instanceof ApiDepartment ? value : THROW_CCE());
};
protoOf($serializer_7).zn = function (decoder) {
  var tmp0_desc = this.x98_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ApiDepartment_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_7).xn = function () {
  return this.x98_1;
};
protoOf($serializer_7).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 == null)
    new $serializer_7();
  return $serializer_instance_7;
}
function ApiDepartment_init_$Init$(seen0, id, name, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_7().x98_1);
  }
  $this.x97_1 = id;
  $this.y97_1 = name;
  return $this;
}
function ApiDepartment_init_$Create$(seen0, id, name, serializationConstructorMarker) {
  return ApiDepartment_init_$Init$(seen0, id, name, serializationConstructorMarker, objectCreate(protoOf(ApiDepartment)));
}
function ApiClockResponse$Companion$$childSerializers$_anonymous__ipp2kr() {
  return new ArrayListSerializer($serializer_getInstance_7());
}
function ApiClockResponse$Companion$$childSerializers$_anonymous__ipp2kr_0() {
  return new ArrayListSerializer($serializer_getInstance_6());
}
function ApiClockUserResponse() {
}
protoOf(ApiClockUserResponse).toString = function () {
  return 'ApiClockUserResponse(photoUrl=' + this.e98_1 + ')';
};
protoOf(ApiClockUserResponse).hashCode = function () {
  return getStringHashCode(this.e98_1);
};
protoOf(ApiClockUserResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiClockUserResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ApiClockUserResponse ? other : THROW_CCE();
  if (!(this.e98_1 === tmp0_other_with_cast.e98_1))
    return false;
  return true;
};
function ApiRole() {
}
protoOf(ApiRole).toString = function () {
  return 'ApiRole(id=' + this.z97_1.toString() + ', name=' + this.a98_1 + ', color=' + this.b98_1 + ', departmentId=' + toString(this.c98_1) + ', departmentName=' + this.d98_1 + ')';
};
protoOf(ApiRole).hashCode = function () {
  var result = this.z97_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.a98_1) | 0;
  result = imul(result, 31) + (this.b98_1 == null ? 0 : getStringHashCode(this.b98_1)) | 0;
  result = imul(result, 31) + (this.c98_1 == null ? 0 : this.c98_1.hashCode()) | 0;
  result = imul(result, 31) + (this.d98_1 == null ? 0 : getStringHashCode(this.d98_1)) | 0;
  return result;
};
protoOf(ApiRole).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiRole))
    return false;
  var tmp0_other_with_cast = other instanceof ApiRole ? other : THROW_CCE();
  if (!this.z97_1.equals(tmp0_other_with_cast.z97_1))
    return false;
  if (!(this.a98_1 === tmp0_other_with_cast.a98_1))
    return false;
  if (!(this.b98_1 == tmp0_other_with_cast.b98_1))
    return false;
  if (!equals(this.c98_1, tmp0_other_with_cast.c98_1))
    return false;
  if (!(this.d98_1 == tmp0_other_with_cast.d98_1))
    return false;
  return true;
};
function ApiDepartment() {
}
protoOf(ApiDepartment).toString = function () {
  return 'ApiDepartment(id=' + this.x97_1.toString() + ', name=' + this.y97_1 + ')';
};
protoOf(ApiDepartment).hashCode = function () {
  var result = this.x97_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.y97_1) | 0;
  return result;
};
protoOf(ApiDepartment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiDepartment))
    return false;
  var tmp0_other_with_cast = other instanceof ApiDepartment ? other : THROW_CCE();
  if (!this.x97_1.equals(tmp0_other_with_cast.x97_1))
    return false;
  if (!(this.y97_1 === tmp0_other_with_cast.y97_1))
    return false;
  return true;
};
function Companion_4() {
  Companion_instance_7 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, ApiClockResponse$Companion$$childSerializers$_anonymous__ipp2kr);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.z98_1 = [null, null, null, tmp_1, null, null, null, null, null, null, null, lazy(tmp_2, ApiClockResponse$Companion$$childSerializers$_anonymous__ipp2kr_0), null, null, null, null, null];
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 == null)
    new Companion_4();
  return Companion_instance_7;
}
function $serializer_8() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.clock.data.models.ApiClockResponse', this, 17);
  tmp0_serialDesc.wy('attestation_needed', false);
  tmp0_serialDesc.wy('break_minutes', false);
  tmp0_serialDesc.wy('break_started', false);
  tmp0_serialDesc.wy('departments', false);
  tmp0_serialDesc.wy('error_message', false);
  tmp0_serialDesc.wy('health_check_failed', false);
  tmp0_serialDesc.wy('health_check_required', false);
  tmp0_serialDesc.wy('message', false);
  tmp0_serialDesc.wy('not_allowed_punch_in_break_too_short', false);
  tmp0_serialDesc.wy('picture_punch_required', false);
  tmp0_serialDesc.wy('punched', false);
  tmp0_serialDesc.wy('roles', false);
  tmp0_serialDesc.wy('time_punch_break_id', false);
  tmp0_serialDesc.wy('time_punch_id', false);
  tmp0_serialDesc.wy('tips_needed', false);
  tmp0_serialDesc.wy('user', false);
  tmp0_serialDesc.wy('welcome_back', false);
  this.a99_1 = tmp0_serialDesc;
}
protoOf($serializer_8).b99 = function (encoder, value) {
  var tmp0_desc = this.a99_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_7().z98_1;
  tmp1_output.dt(tmp0_desc, 0, BooleanSerializer_getInstance(), value.g97_1);
  tmp1_output.dt(tmp0_desc, 1, IntSerializer_getInstance(), value.h97_1);
  tmp1_output.dt(tmp0_desc, 2, IntSerializer_getInstance(), value.i97_1);
  tmp1_output.dt(tmp0_desc, 3, tmp2_cached[3].t(), value.j97_1);
  tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.k97_1);
  tmp1_output.dt(tmp0_desc, 5, BooleanSerializer_getInstance(), value.l97_1);
  tmp1_output.dt(tmp0_desc, 6, BooleanSerializer_getInstance(), value.m97_1);
  tmp1_output.dt(tmp0_desc, 7, StringSerializer_getInstance(), value.n97_1);
  tmp1_output.dt(tmp0_desc, 8, BooleanSerializer_getInstance(), value.o97_1);
  tmp1_output.dt(tmp0_desc, 9, BooleanSerializer_getInstance(), value.p97_1);
  tmp1_output.dt(tmp0_desc, 10, StringSerializer_getInstance(), value.q97_1);
  tmp1_output.dt(tmp0_desc, 11, tmp2_cached[11].t(), value.r97_1);
  tmp1_output.dt(tmp0_desc, 12, LongSerializer_getInstance(), value.s97_1);
  tmp1_output.dt(tmp0_desc, 13, LongSerializer_getInstance(), value.t97_1);
  tmp1_output.dt(tmp0_desc, 14, BooleanSerializer_getInstance(), value.u97_1);
  tmp1_output.dt(tmp0_desc, 15, $serializer_getInstance_5(), value.v97_1);
  tmp1_output.dt(tmp0_desc, 16, IntSerializer_getInstance(), value.w97_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_8).yn = function (encoder, value) {
  return this.b99(encoder, value instanceof ApiClockResponse ? value : THROW_CCE());
};
protoOf($serializer_8).zn = function (decoder) {
  var tmp0_desc = this.a99_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_local12 = null;
  var tmp17_local13 = null;
  var tmp18_local14 = null;
  var tmp19_local15 = null;
  var tmp20_local16 = null;
  var tmp21_input = decoder.kr(tmp0_desc);
  var tmp22_cached = Companion_getInstance_7().z98_1;
  if (tmp21_input.as()) {
    tmp4_local0 = tmp21_input.yr(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp21_input.yr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp21_input.yr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp21_input.yr(tmp0_desc, 3, tmp22_cached[3].t(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp21_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp21_input.yr(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp21_input.yr(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp21_input.yr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp21_input.yr(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp21_input.yr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp21_input.yr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp21_input.yr(tmp0_desc, 11, tmp22_cached[11].t(), tmp15_local11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp16_local12 = tmp21_input.yr(tmp0_desc, 12, LongSerializer_getInstance(), tmp16_local12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp17_local13 = tmp21_input.yr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp18_local14 = tmp21_input.yr(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp18_local14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp19_local15 = tmp21_input.yr(tmp0_desc, 15, $serializer_getInstance_5(), tmp19_local15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp20_local16 = tmp21_input.yr(tmp0_desc, 16, IntSerializer_getInstance(), tmp20_local16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp21_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp21_input.yr(tmp0_desc, 0, BooleanSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp21_input.yr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp21_input.yr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp21_input.yr(tmp0_desc, 3, tmp22_cached[3].t(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp21_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp21_input.yr(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp21_input.yr(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp21_input.yr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp21_input.yr(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp21_input.yr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp21_input.yr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp21_input.yr(tmp0_desc, 11, tmp22_cached[11].t(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp16_local12 = tmp21_input.yr(tmp0_desc, 12, LongSerializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp17_local13 = tmp21_input.yr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp18_local14 = tmp21_input.yr(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp19_local15 = tmp21_input.yr(tmp0_desc, 15, $serializer_getInstance_5(), tmp19_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp20_local16 = tmp21_input.yr(tmp0_desc, 16, IntSerializer_getInstance(), tmp20_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp21_input.lr(tmp0_desc);
  return ApiClockResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
};
protoOf($serializer_8).xn = function () {
  return this.a99_1;
};
protoOf($serializer_8).pz = function () {
  var tmp0_cached = Companion_getInstance_7().z98_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(BooleanSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(tmp0_cached[3].t()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[11].t()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_5()), get_nullable(IntSerializer_getInstance())];
};
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 == null)
    new $serializer_8();
  return $serializer_instance_8;
}
function ApiClockResponse_init_$Init$(seen0, attestationRequired, breakMinutes, breakStarted, departments, errorMessage, healthCheckFailed, healthCheckRequired, message, breakTooShort, picturePunchRequired, punched, roles, timePunchBreakId, timePunchId, tipsNeeded, user, welcomeBack, serializationConstructorMarker, $this) {
  if (!(131071 === (131071 & seen0))) {
    throwMissingFieldException(seen0, 131071, $serializer_getInstance_8().a99_1);
  }
  $this.g97_1 = attestationRequired;
  $this.h97_1 = breakMinutes;
  $this.i97_1 = breakStarted;
  $this.j97_1 = departments;
  $this.k97_1 = errorMessage;
  $this.l97_1 = healthCheckFailed;
  $this.m97_1 = healthCheckRequired;
  $this.n97_1 = message;
  $this.o97_1 = breakTooShort;
  $this.p97_1 = picturePunchRequired;
  $this.q97_1 = punched;
  $this.r97_1 = roles;
  $this.s97_1 = timePunchBreakId;
  $this.t97_1 = timePunchId;
  $this.u97_1 = tipsNeeded;
  $this.v97_1 = user;
  $this.w97_1 = welcomeBack;
  return $this;
}
function ApiClockResponse_init_$Create$(seen0, attestationRequired, breakMinutes, breakStarted, departments, errorMessage, healthCheckFailed, healthCheckRequired, message, breakTooShort, picturePunchRequired, punched, roles, timePunchBreakId, timePunchId, tipsNeeded, user, welcomeBack, serializationConstructorMarker) {
  return ApiClockResponse_init_$Init$(seen0, attestationRequired, breakMinutes, breakStarted, departments, errorMessage, healthCheckFailed, healthCheckRequired, message, breakTooShort, picturePunchRequired, punched, roles, timePunchBreakId, timePunchId, tipsNeeded, user, welcomeBack, serializationConstructorMarker, objectCreate(protoOf(ApiClockResponse)));
}
function ApiClockResponse(attestationRequired, breakMinutes, breakStarted, departments, errorMessage, healthCheckFailed, healthCheckRequired, message, breakTooShort, picturePunchRequired, punched, roles, timePunchBreakId, timePunchId, tipsNeeded, user, welcomeBack) {
  Companion_getInstance_7();
  this.g97_1 = attestationRequired;
  this.h97_1 = breakMinutes;
  this.i97_1 = breakStarted;
  this.j97_1 = departments;
  this.k97_1 = errorMessage;
  this.l97_1 = healthCheckFailed;
  this.m97_1 = healthCheckRequired;
  this.n97_1 = message;
  this.o97_1 = breakTooShort;
  this.p97_1 = picturePunchRequired;
  this.q97_1 = punched;
  this.r97_1 = roles;
  this.s97_1 = timePunchBreakId;
  this.t97_1 = timePunchId;
  this.u97_1 = tipsNeeded;
  this.v97_1 = user;
  this.w97_1 = welcomeBack;
}
protoOf(ApiClockResponse).toString = function () {
  return 'ApiClockResponse(attestationRequired=' + this.g97_1 + ', breakMinutes=' + this.h97_1 + ', breakStarted=' + this.i97_1 + ', departments=' + toString(this.j97_1) + ', errorMessage=' + this.k97_1 + ', healthCheckFailed=' + this.l97_1 + ', healthCheckRequired=' + this.m97_1 + ', message=' + this.n97_1 + ', breakTooShort=' + this.o97_1 + ', picturePunchRequired=' + this.p97_1 + ', punched=' + this.q97_1 + ', roles=' + toString(this.r97_1) + ', timePunchBreakId=' + toString(this.s97_1) + ', timePunchId=' + toString(this.t97_1) + ', tipsNeeded=' + this.u97_1 + ', user=' + toString(this.v97_1) + ', welcomeBack=' + this.w97_1 + ')';
};
protoOf(ApiClockResponse).hashCode = function () {
  var result = this.g97_1 == null ? 0 : getBooleanHashCode(this.g97_1);
  result = imul(result, 31) + (this.h97_1 == null ? 0 : this.h97_1) | 0;
  result = imul(result, 31) + (this.i97_1 == null ? 0 : this.i97_1) | 0;
  result = imul(result, 31) + (this.j97_1 == null ? 0 : hashCode(this.j97_1)) | 0;
  result = imul(result, 31) + (this.k97_1 == null ? 0 : getStringHashCode(this.k97_1)) | 0;
  result = imul(result, 31) + (this.l97_1 == null ? 0 : getBooleanHashCode(this.l97_1)) | 0;
  result = imul(result, 31) + (this.m97_1 == null ? 0 : getBooleanHashCode(this.m97_1)) | 0;
  result = imul(result, 31) + (this.n97_1 == null ? 0 : getStringHashCode(this.n97_1)) | 0;
  result = imul(result, 31) + (this.o97_1 == null ? 0 : getBooleanHashCode(this.o97_1)) | 0;
  result = imul(result, 31) + (this.p97_1 == null ? 0 : getBooleanHashCode(this.p97_1)) | 0;
  result = imul(result, 31) + (this.q97_1 == null ? 0 : getStringHashCode(this.q97_1)) | 0;
  result = imul(result, 31) + (this.r97_1 == null ? 0 : hashCode(this.r97_1)) | 0;
  result = imul(result, 31) + (this.s97_1 == null ? 0 : this.s97_1.hashCode()) | 0;
  result = imul(result, 31) + (this.t97_1 == null ? 0 : this.t97_1.hashCode()) | 0;
  result = imul(result, 31) + (this.u97_1 == null ? 0 : getBooleanHashCode(this.u97_1)) | 0;
  result = imul(result, 31) + (this.v97_1 == null ? 0 : this.v97_1.hashCode()) | 0;
  result = imul(result, 31) + (this.w97_1 == null ? 0 : this.w97_1) | 0;
  return result;
};
protoOf(ApiClockResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiClockResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ApiClockResponse ? other : THROW_CCE();
  if (!(this.g97_1 == tmp0_other_with_cast.g97_1))
    return false;
  if (!(this.h97_1 == tmp0_other_with_cast.h97_1))
    return false;
  if (!(this.i97_1 == tmp0_other_with_cast.i97_1))
    return false;
  if (!equals(this.j97_1, tmp0_other_with_cast.j97_1))
    return false;
  if (!(this.k97_1 == tmp0_other_with_cast.k97_1))
    return false;
  if (!(this.l97_1 == tmp0_other_with_cast.l97_1))
    return false;
  if (!(this.m97_1 == tmp0_other_with_cast.m97_1))
    return false;
  if (!(this.n97_1 == tmp0_other_with_cast.n97_1))
    return false;
  if (!(this.o97_1 == tmp0_other_with_cast.o97_1))
    return false;
  if (!(this.p97_1 == tmp0_other_with_cast.p97_1))
    return false;
  if (!(this.q97_1 == tmp0_other_with_cast.q97_1))
    return false;
  if (!equals(this.r97_1, tmp0_other_with_cast.r97_1))
    return false;
  if (!equals(this.s97_1, tmp0_other_with_cast.s97_1))
    return false;
  if (!equals(this.t97_1, tmp0_other_with_cast.t97_1))
    return false;
  if (!(this.u97_1 == tmp0_other_with_cast.u97_1))
    return false;
  if (!equals(this.v97_1, tmp0_other_with_cast.v97_1))
    return false;
  if (!(this.w97_1 == tmp0_other_with_cast.w97_1))
    return false;
  return true;
};
var TimePunchUserAction_CLOCK_IN_instance;
var TimePunchUserAction_CLOCK_OUT_instance;
var TimePunchUserAction_START_PAID_BREAK_instance;
var TimePunchUserAction_START_UNPAID_BREAK_instance;
var TimePunchUserAction_START_CUSTOM_BREAK_instance;
var TimePunchUserAction_END_BREAK_instance;
function values() {
  return [TimePunchUserAction_CLOCK_IN_getInstance(), TimePunchUserAction_CLOCK_OUT_getInstance(), TimePunchUserAction_START_PAID_BREAK_getInstance(), TimePunchUserAction_START_UNPAID_BREAK_getInstance(), TimePunchUserAction_START_CUSTOM_BREAK_getInstance(), TimePunchUserAction_END_BREAK_getInstance()];
}
var TimePunchUserAction_entriesInitialized;
function TimePunchUserAction_initEntries() {
  if (TimePunchUserAction_entriesInitialized)
    return Unit_instance;
  TimePunchUserAction_entriesInitialized = true;
  TimePunchUserAction_CLOCK_IN_instance = new TimePunchUserAction('CLOCK_IN', 0);
  TimePunchUserAction_CLOCK_OUT_instance = new TimePunchUserAction('CLOCK_OUT', 1);
  TimePunchUserAction_START_PAID_BREAK_instance = new TimePunchUserAction('START_PAID_BREAK', 2);
  TimePunchUserAction_START_UNPAID_BREAK_instance = new TimePunchUserAction('START_UNPAID_BREAK', 3);
  TimePunchUserAction_START_CUSTOM_BREAK_instance = new TimePunchUserAction('START_CUSTOM_BREAK', 4);
  TimePunchUserAction_END_BREAK_instance = new TimePunchUserAction('END_BREAK', 5);
}
function TimePunchUserAction(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TimePunchUserAction_CLOCK_IN_getInstance() {
  TimePunchUserAction_initEntries();
  return TimePunchUserAction_CLOCK_IN_instance;
}
function TimePunchUserAction_CLOCK_OUT_getInstance() {
  TimePunchUserAction_initEntries();
  return TimePunchUserAction_CLOCK_OUT_instance;
}
function TimePunchUserAction_START_PAID_BREAK_getInstance() {
  TimePunchUserAction_initEntries();
  return TimePunchUserAction_START_PAID_BREAK_instance;
}
function TimePunchUserAction_START_UNPAID_BREAK_getInstance() {
  TimePunchUserAction_initEntries();
  return TimePunchUserAction_START_UNPAID_BREAK_instance;
}
function TimePunchUserAction_START_CUSTOM_BREAK_getInstance() {
  TimePunchUserAction_initEntries();
  return TimePunchUserAction_START_CUSTOM_BREAK_instance;
}
function TimePunchUserAction_END_BREAK_getInstance() {
  TimePunchUserAction_initEntries();
  return TimePunchUserAction_END_BREAK_instance;
}
function requireEmployeePunchIdNotEmpty($this, employeePunchId) {
  if (isBlank(employeePunchId))
    throw new BadRequest('You need a Punch ID to proceed. Please enter your ID and try again.');
}
function $clockInCOROUTINE$8(_this__u8e3s4, employeePunchId, roleId, departmentId, confirmedRoleId, healthCheckResponseId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.k99_1 = _this__u8e3s4;
  this.l99_1 = employeePunchId;
  this.m99_1 = roleId;
  this.n99_1 = departmentId;
  this.o99_1 = confirmedRoleId;
  this.p99_1 = healthCheckResponseId;
}
protoOf($clockInCOROUTINE$8).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          requireEmployeePunchIdNotEmpty(this.k99_1, this.l99_1);
          this.q99_1 = TimePunchUserAction_CLOCK_IN_getInstance();
          this.n8_1 = 1;
          suspendResult = this.k99_1.t99_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.r99_1 = suspendResult;
          this.s99_1 = ApiClockRequest_init_$Create$(this.q99_1, this.l99_1, this.r99_1, this.n99_1, this.m99_1, this.o99_1, VOID, this.p99_1);
          this.n8_1 = 2;
          suspendResult = this.k99_1.u99_1.v99(this.s99_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain_0(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $clockOutCOROUTINE$9(_this__u8e3s4, employeePunchId, tips, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.e9a_1 = _this__u8e3s4;
  this.f9a_1 = employeePunchId;
  this.g9a_1 = tips;
}
protoOf($clockOutCOROUTINE$9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          requireEmployeePunchIdNotEmpty(this.e9a_1, this.f9a_1);
          this.h9a_1 = TimePunchUserAction_CLOCK_OUT_getInstance();
          this.n8_1 = 1;
          suspendResult = this.e9a_1.t99_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.i9a_1 = suspendResult;
          this.j9a_1 = ApiClockRequest_init_$Create$(this.h9a_1, this.f9a_1, this.i9a_1, VOID, VOID, VOID, VOID, VOID, this.g9a_1);
          this.n8_1 = 2;
          suspendResult = this.e9a_1.u99_1.v99(this.j9a_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain_0(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $startPaidBreakCOROUTINE$10(_this__u8e3s4, employeePunchId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s9a_1 = _this__u8e3s4;
  this.t9a_1 = employeePunchId;
}
protoOf($startPaidBreakCOROUTINE$10).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          requireEmployeePunchIdNotEmpty(this.s9a_1, this.t9a_1);
          this.n8_1 = 1;
          suspendResult = this.s9a_1.t99_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.u9a_1 = suspendResult;
          this.v9a_1 = TimePunchUserAction_START_PAID_BREAK_getInstance();
          this.w9a_1 = ApiClockRequest_init_$Create$(this.v9a_1, this.t9a_1, this.u9a_1);
          this.n8_1 = 2;
          suspendResult = this.s9a_1.u99_1.v99(this.w9a_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain_0(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $startUnpaidBreakCOROUTINE$11(_this__u8e3s4, employeePunchId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f9b_1 = _this__u8e3s4;
  this.g9b_1 = employeePunchId;
}
protoOf($startUnpaidBreakCOROUTINE$11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          requireEmployeePunchIdNotEmpty(this.f9b_1, this.g9b_1);
          this.n8_1 = 1;
          suspendResult = this.f9b_1.t99_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.h9b_1 = suspendResult;
          this.i9b_1 = TimePunchUserAction_START_UNPAID_BREAK_getInstance();
          this.j9b_1 = ApiClockRequest_init_$Create$(this.i9b_1, this.g9b_1, this.h9b_1);
          this.n8_1 = 2;
          suspendResult = this.f9b_1.u99_1.v99(this.j9b_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain_0(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $startCustomBreakCOROUTINE$12(_this__u8e3s4, employeePunchId, customBreakId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s9b_1 = _this__u8e3s4;
  this.t9b_1 = employeePunchId;
  this.u9b_1 = customBreakId;
}
protoOf($startCustomBreakCOROUTINE$12).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          requireEmployeePunchIdNotEmpty(this.s9b_1, this.t9b_1);
          this.n8_1 = 1;
          suspendResult = this.s9b_1.t99_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.v9b_1 = suspendResult;
          this.w9b_1 = TimePunchUserAction_START_CUSTOM_BREAK_getInstance();
          this.x9b_1 = ApiClockRequest_init_$Create$(this.w9b_1, this.t9b_1, this.v9b_1, VOID, VOID, VOID, this.u9b_1);
          this.n8_1 = 2;
          suspendResult = this.s9b_1.u99_1.v99(this.x9b_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain_0(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $endBreakCOROUTINE$13(_this__u8e3s4, employeePunchId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g9c_1 = _this__u8e3s4;
  this.h9c_1 = employeePunchId;
}
protoOf($endBreakCOROUTINE$13).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          requireEmployeePunchIdNotEmpty(this.g9c_1, this.h9c_1);
          this.n8_1 = 1;
          suspendResult = this.g9c_1.t99_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.i9c_1 = suspendResult;
          this.j9c_1 = TimePunchUserAction_END_BREAK_getInstance();
          this.k9c_1 = ApiClockRequest_init_$Create$(this.j9c_1, this.h9c_1, this.i9c_1);
          this.n8_1 = 2;
          suspendResult = this.g9c_1.u99_1.v99(this.k9c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain_0(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function ClockRepository(sessionDataProvider, clockRemoteSource) {
  this.t99_1 = sessionDataProvider;
  this.u99_1 = clockRemoteSource;
}
protoOf(ClockRepository).l9c = function (employeePunchId, roleId, departmentId, confirmedRoleId, healthCheckResponseId, $completion) {
  var tmp = new $clockInCOROUTINE$8(this, employeePunchId, roleId, departmentId, confirmedRoleId, healthCheckResponseId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ClockRepository).m9c = function (employeePunchId, tips, $completion) {
  var tmp = new $clockOutCOROUTINE$9(this, employeePunchId, tips, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ClockRepository).o9c = function (employeePunchId, $completion) {
  var tmp = new $startPaidBreakCOROUTINE$10(this, employeePunchId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ClockRepository).p9c = function (employeePunchId, $completion) {
  var tmp = new $startUnpaidBreakCOROUTINE$11(this, employeePunchId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ClockRepository).q9c = function (employeePunchId, customBreakId, $completion) {
  var tmp = new $startCustomBreakCOROUTINE$12(this, employeePunchId, customBreakId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(ClockRepository).r9c = function (employeePunchId, $completion) {
  var tmp = new $endBreakCOROUTINE$13(this, employeePunchId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function ClockRemoteSource() {
}
function ClockRemoteSourceImpl$clock$lambda($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $clockCOROUTINE$14(_this__u8e3s4, apiClockRequest, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a9d_1 = _this__u8e3s4;
  this.b9d_1 = apiClockRequest;
}
protoOf($clockCOROUTINE$14).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.c9d_1 = this.a9d_1.t9e_1;
          var tmp_1 = this;
          tmp_1.d9d_1 = 'time_punch_clock';
          var tmp_2 = this;
          tmp_2.e9d_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.f9d_1 = this.c9d_1;
          this.g9d_1 = this.d9d_1;
          this.h9d_1 = this.e9d_1;
          this.o8_1 = 2;
          var tmp_3 = this;
          tmp_3.j9d_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.k9d_1 = this.f9d_1.f6l_1;
          var tmp_5 = this;
          tmp_5.l9d_1 = buildV2Path(this.f9d_1, this.g9d_1);
          this.m9d_1 = this.k9d_1;
          this.n9d_1 = this.l9d_1;
          var tmp_6 = this;
          tmp_6.o9d_1 = this.m9d_1;
          this.p9d_1 = this.o9d_1;
          var tmp_7 = this;
          tmp_7.q9d_1 = this.p9d_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.n9d_1);
          contentType(this_0, Application_getInstance().c3v_1);
          headers(this_0, ClockRemoteSourceImpl$clock$lambda(this.h9d_1));
          var body = this.b9d_1;
          if (body == null) {
            this_0.s4r_1 = NullBody_instance;
            var tmp_9 = getKClass(ApiClockRequest);
            var tmp_10;
            try {
              tmp_10 = createKType(getKClass(ApiClockRequest), arrayOf([]), false);
            } catch ($p) {
              var tmp_11;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_11 = null;
              } else {
                throw $p;
              }
              tmp_10 = tmp_11;
            }
            this_0.n4x(new TypeInfo(tmp_9, tmp_10));
          } else {
            if (body instanceof OutgoingContent) {
              this_0.s4r_1 = body;
              this_0.n4x(null);
            } else {
              this_0.s4r_1 = body;
              var tmp_12 = getKClass(ApiClockRequest);
              var tmp_13;
              try {
                tmp_13 = createKType(getKClass(ApiClockRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_14;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3_0 = $p;
                  tmp_14 = null;
                } else {
                  throw $p;
                }
                tmp_13 = tmp_14;
              }
              this_0.n4x(new TypeInfo(tmp_12, tmp_13));
            }
          }

          tmp_8.r9d_1 = this_0;
          this.s9d_1 = this.q9d_1;
          this.t9d_1 = this.r9d_1;
          this.t9d_1.q4r_1 = Companion_getInstance_0().g41_1;
          var tmp_15 = this;
          tmp_15.u9d_1 = this.s9d_1;
          var tmp_16 = this;
          tmp_16.v9d_1 = this.t9d_1;
          this.w9d_1 = this.u9d_1;
          this.x9d_1 = this.v9d_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.x9d_1, this.w9d_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.y9d_1 = suspendResult;
          var tmp_17 = this;
          this.j9d_1;
          var value = this.y9d_1;
          tmp_17.i9d_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_18 = this.q8_1;
          if (tmp_18 instanceof CancellationException) {
            this.z9d_1 = this.q8_1;
            var tmp_19 = this;
            throw this.z9d_1;
          } else {
            var tmp_20 = this.q8_1;
            if (tmp_20 instanceof Error) {
              this.a9e_1 = this.q8_1;
              var tmp_21 = this;
              var exception = this.a9e_1;
              tmp_21.i9d_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.b9e_1 = this.i9d_1;
          this.c9e_1 = this.b9e_1;
          this.d9e_1 = Result__exceptionOrNull_impl_p6xea9(this.c9e_1);
          if (this.d9e_1 == null) {
            var tmp_22 = this;
            var tmp_23 = _Result___get_value__impl__bjfvqg(this.c9e_1);
            tmp_22.f9e_1 = (tmp_23 == null ? true : !(tmp_23 == null)) ? tmp_23 : THROW_CCE();
            this.g9e_1 = this.f9e_1;
            var tmp_24 = this;
            tmp_24.h9e_1 = this.g9e_1;
            this.i9e_1 = this.h9e_1;
            this.j9e_1 = this.i9e_1.c4u().z43_1;
            var containsArg = this.j9e_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_25 = this;
              tmp_25.m9e_1 = Companion_instance;
              if (getKClass(ApiClockResponse).equals(getKClass(Unit))) {
                var tmp_26 = this;
                tmp_26.o9e_1 = this.i9e_1;
                this.p9e_1 = this.o9e_1;
                this.n8_1 = 6;
                var tmp_27 = this.p9e_1.y4u();
                var tmp_28 = getKClass(ApiClockResponse);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(ApiClockResponse), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_1 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_31 = this;
                tmp_31.q9e_1 = this.i9e_1;
                this.r9e_1 = this.q9e_1;
                this.n8_1 = 5;
                var tmp_32 = this.r9e_1.y4u();
                var tmp_33 = getKClass(JsonElement);
                var tmp_34;
                try {
                  tmp_34 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_35;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_2 = $p;
                    tmp_35 = null;
                  } else {
                    throw $p;
                  }
                  tmp_34 = tmp_35;
                }
                suspendResult = tmp_32.a4u(new TypeInfo(tmp_33, tmp_34), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_36 = this;
              tmp_36.s9e_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.i9e_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_37 = this;
            var it = this.d9e_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_37.e9e_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_38 = this;
          this.s9e_1;
          tmp_38.k9e_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_39 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiClockResponse), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_40;
            if (tmp2 instanceof JsonObject) {
              tmp_40 = tmp2.c3p('data');
            } else {
              tmp_40 = false;
            }
            if (tmp_40) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_41;
              if (dataValue instanceof JsonObject) {
                tmp_41 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_41 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_41 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_41;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_39.n9e_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_42 = this;
          tmp_42.n9e_1 = suspendResult instanceof ApiClockResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.n9e_1;
          var tmp_43 = this;
          this.m9e_1;
          tmp_43.l9e_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_44 = this.q8_1;
          if (tmp_44 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_45 = this;
            throw e_0;
          } else {
            var tmp_46 = this.q8_1;
            if (tmp_46 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_47 = this;
              tmp_47.l9e_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_48 = this;
          var this_2 = this.l9e_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_49;
          if (exception_1 == null) {
            var tmp_50 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_50 == null ? true : !(tmp_50 == null)) ? tmp_50 : THROW_CCE();
            tmp_49 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_49 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_48.k9e_1 = tmp_49.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.e9e_1 = new Result(this.k9e_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.e9e_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function ClockRemoteSourceImpl(apiClient) {
  this.t9e_1 = apiClient;
}
protoOf(ClockRemoteSourceImpl).v99 = function (apiClockRequest, $completion) {
  var tmp = new $clockCOROUTINE$14(this, apiClockRequest, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
var Status_IN_instance;
var Status_OUT_instance;
var Status_INTERMEDIATE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_IN_instance = new Status('IN', 0);
  Status_OUT_instance = new Status('OUT', 1);
  Status_INTERMEDIATE_instance = new Status('INTERMEDIATE', 2);
}
function Status(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ClockUserResponse(photoUrl) {
  this.u9e_1 = photoUrl;
}
protoOf(ClockUserResponse).toString = function () {
  return 'ClockUserResponse(photoUrl=' + this.u9e_1 + ')';
};
protoOf(ClockUserResponse).hashCode = function () {
  return getStringHashCode(this.u9e_1);
};
protoOf(ClockUserResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockUserResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ClockUserResponse ? other : THROW_CCE();
  if (!(this.u9e_1 === tmp0_other_with_cast.u9e_1))
    return false;
  return true;
};
function Role_1(id, name, departmentId, departmentName, color) {
  this.v9e_1 = id;
  this.w9e_1 = name;
  this.x9e_1 = departmentId;
  this.y9e_1 = departmentName;
  this.z9e_1 = color;
}
protoOf(Role_1).toString = function () {
  return 'Role(id=' + this.v9e_1.toString() + ', name=' + this.w9e_1 + ', departmentId=' + toString(this.x9e_1) + ', departmentName=' + this.y9e_1 + ', color=' + this.z9e_1 + ')';
};
protoOf(Role_1).hashCode = function () {
  var result = this.v9e_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.w9e_1) | 0;
  result = imul(result, 31) + (this.x9e_1 == null ? 0 : this.x9e_1.hashCode()) | 0;
  result = imul(result, 31) + (this.y9e_1 == null ? 0 : getStringHashCode(this.y9e_1)) | 0;
  result = imul(result, 31) + (this.z9e_1 == null ? 0 : getStringHashCode(this.z9e_1)) | 0;
  return result;
};
protoOf(Role_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Role_1))
    return false;
  var tmp0_other_with_cast = other instanceof Role_1 ? other : THROW_CCE();
  if (!this.v9e_1.equals(tmp0_other_with_cast.v9e_1))
    return false;
  if (!(this.w9e_1 === tmp0_other_with_cast.w9e_1))
    return false;
  if (!equals(this.x9e_1, tmp0_other_with_cast.x9e_1))
    return false;
  if (!(this.y9e_1 == tmp0_other_with_cast.y9e_1))
    return false;
  if (!(this.z9e_1 == tmp0_other_with_cast.z9e_1))
    return false;
  return true;
};
function Department_1(id, name) {
  this.a9f_1 = id;
  this.b9f_1 = name;
}
protoOf(Department_1).toString = function () {
  return 'Department(id=' + this.a9f_1.toString() + ', name=' + this.b9f_1 + ')';
};
protoOf(Department_1).hashCode = function () {
  var result = this.a9f_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.b9f_1) | 0;
  return result;
};
protoOf(Department_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Department_1))
    return false;
  var tmp0_other_with_cast = other instanceof Department_1 ? other : THROW_CCE();
  if (!this.a9f_1.equals(tmp0_other_with_cast.a9f_1))
    return false;
  if (!(this.b9f_1 === tmp0_other_with_cast.b9f_1))
    return false;
  return true;
};
function Status_IN_getInstance() {
  Status_initEntries();
  return Status_IN_instance;
}
function Status_OUT_getInstance() {
  Status_initEntries();
  return Status_OUT_instance;
}
function Status_INTERMEDIATE_getInstance() {
  Status_initEntries();
  return Status_INTERMEDIATE_instance;
}
function ClockResponse(attestationRequired, breakMinutes, breakStarted, departments, errorMessage, healthCheckFailed, healthCheckRequired, message, breakTooShort, picturePunchRequired, punched, roles, timePunchBreakId, timePunchId, tipsNeeded, user, welcomeBack) {
  this.c9f_1 = attestationRequired;
  this.d9f_1 = breakMinutes;
  this.e9f_1 = breakStarted;
  this.f9f_1 = departments;
  this.g9f_1 = errorMessage;
  this.h9f_1 = healthCheckFailed;
  this.i9f_1 = healthCheckRequired;
  this.j9f_1 = message;
  this.k9f_1 = breakTooShort;
  this.l9f_1 = picturePunchRequired;
  this.m9f_1 = punched;
  this.n9f_1 = roles;
  this.o9f_1 = timePunchBreakId;
  this.p9f_1 = timePunchId;
  this.q9f_1 = tipsNeeded;
  this.r9f_1 = user;
  this.s9f_1 = welcomeBack;
}
protoOf(ClockResponse).toString = function () {
  return 'ClockResponse(attestationRequired=' + this.c9f_1 + ', breakMinutes=' + this.d9f_1 + ', breakStarted=' + this.e9f_1 + ', departments=' + toString(this.f9f_1) + ', errorMessage=' + this.g9f_1 + ', healthCheckFailed=' + this.h9f_1 + ', healthCheckRequired=' + this.i9f_1 + ', message=' + this.j9f_1 + ', breakTooShort=' + this.k9f_1 + ', picturePunchRequired=' + this.l9f_1 + ', punched=' + this.m9f_1.toString() + ', roles=' + toString(this.n9f_1) + ', timePunchBreakId=' + toString(this.o9f_1) + ', timePunchId=' + toString(this.p9f_1) + ', tipsNeeded=' + this.q9f_1 + ', user=' + toString(this.r9f_1) + ', welcomeBack=' + this.s9f_1 + ')';
};
protoOf(ClockResponse).hashCode = function () {
  var result = this.c9f_1 == null ? 0 : getBooleanHashCode(this.c9f_1);
  result = imul(result, 31) + (this.d9f_1 == null ? 0 : this.d9f_1) | 0;
  result = imul(result, 31) + (this.e9f_1 == null ? 0 : this.e9f_1) | 0;
  result = imul(result, 31) + (this.f9f_1 == null ? 0 : hashCode(this.f9f_1)) | 0;
  result = imul(result, 31) + (this.g9f_1 == null ? 0 : getStringHashCode(this.g9f_1)) | 0;
  result = imul(result, 31) + (this.h9f_1 == null ? 0 : getBooleanHashCode(this.h9f_1)) | 0;
  result = imul(result, 31) + (this.i9f_1 == null ? 0 : getBooleanHashCode(this.i9f_1)) | 0;
  result = imul(result, 31) + (this.j9f_1 == null ? 0 : getStringHashCode(this.j9f_1)) | 0;
  result = imul(result, 31) + (this.k9f_1 == null ? 0 : getBooleanHashCode(this.k9f_1)) | 0;
  result = imul(result, 31) + (this.l9f_1 == null ? 0 : getBooleanHashCode(this.l9f_1)) | 0;
  result = imul(result, 31) + this.m9f_1.hashCode() | 0;
  result = imul(result, 31) + (this.n9f_1 == null ? 0 : hashCode(this.n9f_1)) | 0;
  result = imul(result, 31) + (this.o9f_1 == null ? 0 : this.o9f_1.hashCode()) | 0;
  result = imul(result, 31) + (this.p9f_1 == null ? 0 : this.p9f_1.hashCode()) | 0;
  result = imul(result, 31) + (this.q9f_1 == null ? 0 : getBooleanHashCode(this.q9f_1)) | 0;
  result = imul(result, 31) + (this.r9f_1 == null ? 0 : this.r9f_1.hashCode()) | 0;
  result = imul(result, 31) + (this.s9f_1 == null ? 0 : this.s9f_1) | 0;
  return result;
};
protoOf(ClockResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ClockResponse ? other : THROW_CCE();
  if (!(this.c9f_1 == tmp0_other_with_cast.c9f_1))
    return false;
  if (!(this.d9f_1 == tmp0_other_with_cast.d9f_1))
    return false;
  if (!(this.e9f_1 == tmp0_other_with_cast.e9f_1))
    return false;
  if (!equals(this.f9f_1, tmp0_other_with_cast.f9f_1))
    return false;
  if (!(this.g9f_1 == tmp0_other_with_cast.g9f_1))
    return false;
  if (!(this.h9f_1 == tmp0_other_with_cast.h9f_1))
    return false;
  if (!(this.i9f_1 == tmp0_other_with_cast.i9f_1))
    return false;
  if (!(this.j9f_1 == tmp0_other_with_cast.j9f_1))
    return false;
  if (!(this.k9f_1 == tmp0_other_with_cast.k9f_1))
    return false;
  if (!(this.l9f_1 == tmp0_other_with_cast.l9f_1))
    return false;
  if (!this.m9f_1.equals(tmp0_other_with_cast.m9f_1))
    return false;
  if (!equals(this.n9f_1, tmp0_other_with_cast.n9f_1))
    return false;
  if (!equals(this.o9f_1, tmp0_other_with_cast.o9f_1))
    return false;
  if (!equals(this.p9f_1, tmp0_other_with_cast.p9f_1))
    return false;
  if (!(this.q9f_1 == tmp0_other_with_cast.q9f_1))
    return false;
  if (!equals(this.r9f_1, tmp0_other_with_cast.r9f_1))
    return false;
  if (!(this.s9f_1 == tmp0_other_with_cast.s9f_1))
    return false;
  return true;
};
function IClockRepository() {
}
function get_punchModule() {
  _init_properties_PunchModule_kt__5z0tx4();
  return punchModule;
}
var punchModule;
function punchModule$lambda($this$module) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = punchModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(AttestationRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = punchModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(AttestationRepository), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = punchModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IAttestationPromptRemoteSource), null, tmp2_1, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = punchModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(AttestationPromptRepository), null, tmp2_2, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  var tmp = new KoinDefinition($this$module, factory_2);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$18 = [getKClass(IAttestationPromptAccessor), getKClass(IAttestationPromptMutator)];
  binds(tmp, tmp$ret$18);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = punchModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(ClockRemoteSource), null, tmp2_3, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_4 = punchModule$lambda$lambda_4;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_4 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Factory_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(HealthCheckRemoteSource), null, tmp2_4, kind_4, secondaryTypes_4);
  var factory_4 = new FactoryInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  new KoinDefinition($this$module, factory_4);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_5 = punchModule$lambda$lambda_5;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_5 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Factory_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(HealthCheckRepository), null, tmp2_5, kind_5, secondaryTypes_5);
  var factory_5 = new FactoryInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  new KoinDefinition($this$module, factory_5);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_6 = punchModule$lambda$lambda_6;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_6 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_6 = Kind_Factory_getInstance();
  var secondaryTypes_6 = emptyList();
  var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(IClockRepository), null, tmp2_6, kind_6, secondaryTypes_6);
  var factory_6 = new FactoryInstanceFactory(def_6);
  $this$module.p1c(factory_6);
  new KoinDefinition($this$module, factory_6);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_7 = punchModule$lambda$lambda_7;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_7 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_7 = Kind_Factory_getInstance();
  var secondaryTypes_7 = emptyList();
  var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(IUserStatusAccessor), null, tmp2_7, kind_7, secondaryTypes_7);
  var factory_7 = new FactoryInstanceFactory(def_7);
  $this$module.p1c(factory_7);
  new KoinDefinition($this$module, factory_7);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_8 = punchModule$lambda$lambda_8;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_8 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_8 = Kind_Factory_getInstance();
  var secondaryTypes_8 = emptyList();
  var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(IUserStatusRemoteSource), null, tmp2_8, kind_8, secondaryTypes_8);
  var factory_8 = new FactoryInstanceFactory(def_8);
  $this$module.p1c(factory_8);
  new KoinDefinition($this$module, factory_8);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_9 = punchModule$lambda$lambda_9;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_9 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_9 = Kind_Factory_getInstance();
  var secondaryTypes_9 = emptyList();
  var def_9 = new BeanDefinition(scopeQualifier_9, getKClass(OfflinePunchRepository), null, tmp2_9, kind_9, secondaryTypes_9);
  var factory_9 = new FactoryInstanceFactory(def_9);
  $this$module.p1c(factory_9);
  new KoinDefinition($this$module, factory_9);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_10 = punchModule$lambda$lambda_10;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_10 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_10 = Kind_Factory_getInstance();
  var secondaryTypes_10 = emptyList();
  var def_10 = new BeanDefinition(scopeQualifier_10, getKClass(OfflinePunchSyncRemoteSource), null, tmp2_10, kind_10, secondaryTypes_10);
  var factory_10 = new FactoryInstanceFactory(def_10);
  $this$module.p1c(factory_10);
  new KoinDefinition($this$module, factory_10);
  return Unit_instance;
}
function punchModule$lambda$lambda($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new AttestationRemoteSourceImpl(tmp$ret$0);
}
function punchModule$lambda$lambda_0($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(AttestationRemoteSource), null, null);
  return new AttestationRepositoryImpl(tmp, tmp$ret$1);
}
function punchModule$lambda$lambda_1($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new AttestationPromptRemoteSource(tmp$ret$0);
}
function punchModule$lambda$lambda_2($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(IAttestationPromptRemoteSource), null, null);
  return new AttestationPromptRepository(tmp, tmp$ret$1);
}
function punchModule$lambda$lambda_3($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new ClockRemoteSourceImpl(tmp$ret$0);
}
function punchModule$lambda$lambda_4($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new HealthCheckRemoteSourceImpl(tmp$ret$0);
}
function punchModule$lambda$lambda_5($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(HealthCheckRemoteSource), null, null);
  return new HealthCheckRepositoryImpl(tmp, tmp$ret$1);
}
function punchModule$lambda$lambda_6($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ClockRemoteSource), null, null);
  return new ClockRepository(tmp, tmp$ret$1);
}
function punchModule$lambda$lambda_7($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IUserStatusRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new UserStatusRepository(tmp, tmp_0, tmp$ret$2);
}
function punchModule$lambda$lambda_8($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new UserStatusRemoteSource(tmp$ret$0);
}
function punchModule$lambda$lambda_9($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(OfflinePunchSyncRemoteSource), null, null);
  return new OfflinePunchRepositoryImpl(tmp$ret$0);
}
function punchModule$lambda$lambda_10($this$factory, it) {
  _init_properties_PunchModule_kt__5z0tx4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new OfflinePunchSyncRemoteSourceImpl(tmp$ret$0);
}
var properties_initialized_PunchModule_kt_qrbi3u;
function _init_properties_PunchModule_kt__5z0tx4() {
  if (!properties_initialized_PunchModule_kt_qrbi3u) {
    properties_initialized_PunchModule_kt_qrbi3u = true;
    punchModule = module_0(VOID, punchModule$lambda);
  }
}
function toDomain_4(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.w9f_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = toDomain_5(item);
    destination.e(tmp$ret$0);
  }
  return new HealthCheckQuestionnaire(_this__u8e3s4.t9f_1, _this__u8e3s4.u9f_1, _this__u8e3s4.v9f_1, destination);
}
function toApiSaveHealthCheckQuestionnaireRequest(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.y9f_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = new QuestionResponse_0(item.z9f_1, item.a9g_1);
    destination.e(tmp$ret$0);
  }
  return new Request(_this__u8e3s4.x9f_1, destination);
}
function toDomain_5(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = _this__u8e3s4.d9g_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = toDomain_6(item);
    destination.e(tmp$ret$0);
  }
  return new Question_0(_this__u8e3s4.b9g_1, _this__u8e3s4.c9g_1, destination);
}
function toDomain_6(_this__u8e3s4) {
  return new Response_3(_this__u8e3s4.e9g_1, _this__u8e3s4.f9g_1);
}
function ApiHealthCheckQuestionnaire$Question$Companion$$childSerializers$_anonymous__l09srz() {
  return new ArrayListSerializer($serializer_getInstance_10());
}
function Companion_5() {
  Companion_instance_8 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.g9g_1 = [null, null, lazy(tmp_0, ApiHealthCheckQuestionnaire$Question$Companion$$childSerializers$_anonymous__l09srz)];
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 == null)
    new Companion_5();
  return Companion_instance_8;
}
function $serializer_9() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.healthcheck.data.models.ApiHealthCheckQuestionnaire.Question', this, 3);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('question', false);
  tmp0_serialDesc.wy('responses', false);
  this.h9g_1 = tmp0_serialDesc;
}
protoOf($serializer_9).i9g = function (encoder, value) {
  var tmp0_desc = this.h9g_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_8().g9g_1;
  tmp1_output.vs(tmp0_desc, 0, value.b9g_1);
  tmp1_output.zs(tmp0_desc, 1, value.c9g_1);
  tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2].t(), value.d9g_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_9).yn = function (encoder, value) {
  return this.i9g(encoder, value instanceof Question ? value : THROW_CCE());
};
protoOf($serializer_9).zn = function (decoder) {
  var tmp0_desc = this.h9g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.kr(tmp0_desc);
  var tmp8_cached = Companion_getInstance_8().g9g_1;
  if (tmp7_input.as()) {
    tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.wr(tmp0_desc, 2, tmp8_cached[2].t(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.wr(tmp0_desc, 2, tmp8_cached[2].t(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.lr(tmp0_desc);
  return Question_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_9).xn = function () {
  return this.h9g_1;
};
protoOf($serializer_9).pz = function () {
  var tmp0_cached = Companion_getInstance_8().g9g_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].t()];
};
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 == null)
    new $serializer_9();
  return $serializer_instance_9;
}
function Question_init_$Init$(seen0, id, question, responses, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_9().h9g_1);
  }
  $this.b9g_1 = id;
  $this.c9g_1 = question;
  $this.d9g_1 = responses;
  return $this;
}
function Question_init_$Create$(seen0, id, question, responses, serializationConstructorMarker) {
  return Question_init_$Init$(seen0, id, question, responses, serializationConstructorMarker, objectCreate(protoOf(Question)));
}
function $serializer_10() {
  $serializer_instance_10 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.healthcheck.data.models.ApiHealthCheckQuestionnaire.Response', this, 2);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('text', false);
  this.j9g_1 = tmp0_serialDesc;
}
protoOf($serializer_10).k9g = function (encoder, value) {
  var tmp0_desc = this.j9g_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.e9g_1);
  tmp1_output.zs(tmp0_desc, 1, value.f9g_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_10).yn = function (encoder, value) {
  return this.k9g(encoder, value instanceof Response_1 ? value : THROW_CCE());
};
protoOf($serializer_10).zn = function (decoder) {
  var tmp0_desc = this.j9g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return Response_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_10).xn = function () {
  return this.j9g_1;
};
protoOf($serializer_10).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 == null)
    new $serializer_10();
  return $serializer_instance_10;
}
function Response_init_$Init$_0(seen0, id, text, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_10().j9g_1);
  }
  $this.e9g_1 = id;
  $this.f9g_1 = text;
  return $this;
}
function Response_init_$Create$_0(seen0, id, text, serializationConstructorMarker) {
  return Response_init_$Init$_0(seen0, id, text, serializationConstructorMarker, objectCreate(protoOf(Response_1)));
}
function ApiHealthCheckQuestionnaire$Companion$$childSerializers$_anonymous__r7ap53() {
  return new ArrayListSerializer($serializer_getInstance_9());
}
function Question() {
}
protoOf(Question).toString = function () {
  return 'Question(id=' + this.b9g_1.toString() + ', question=' + this.c9g_1 + ', responses=' + toString_0(this.d9g_1) + ')';
};
protoOf(Question).hashCode = function () {
  var result = this.b9g_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.c9g_1) | 0;
  result = imul(result, 31) + hashCode(this.d9g_1) | 0;
  return result;
};
protoOf(Question).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Question))
    return false;
  var tmp0_other_with_cast = other instanceof Question ? other : THROW_CCE();
  if (!this.b9g_1.equals(tmp0_other_with_cast.b9g_1))
    return false;
  if (!(this.c9g_1 === tmp0_other_with_cast.c9g_1))
    return false;
  if (!equals(this.d9g_1, tmp0_other_with_cast.d9g_1))
    return false;
  return true;
};
function Response_1() {
}
protoOf(Response_1).toString = function () {
  return 'Response(id=' + this.e9g_1.toString() + ', text=' + this.f9g_1 + ')';
};
protoOf(Response_1).hashCode = function () {
  var result = this.e9g_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.f9g_1) | 0;
  return result;
};
protoOf(Response_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Response_1))
    return false;
  var tmp0_other_with_cast = other instanceof Response_1 ? other : THROW_CCE();
  if (!this.e9g_1.equals(tmp0_other_with_cast.e9g_1))
    return false;
  if (!(this.f9g_1 === tmp0_other_with_cast.f9g_1))
    return false;
  return true;
};
function Companion_6() {
  Companion_instance_9 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.l9g_1 = [null, null, null, lazy(tmp_0, ApiHealthCheckQuestionnaire$Companion$$childSerializers$_anonymous__r7ap53)];
}
var Companion_instance_9;
function Companion_getInstance_9() {
  if (Companion_instance_9 == null)
    new Companion_6();
  return Companion_instance_9;
}
function $serializer_11() {
  $serializer_instance_11 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.healthcheck.data.models.ApiHealthCheckQuestionnaire', this, 4);
  tmp0_serialDesc.wy('language', false);
  tmp0_serialDesc.wy('title', false);
  tmp0_serialDesc.wy('button_text', false);
  tmp0_serialDesc.wy('questions', false);
  this.m9g_1 = tmp0_serialDesc;
}
protoOf($serializer_11).n9g = function (encoder, value) {
  var tmp0_desc = this.m9g_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_9().l9g_1;
  tmp1_output.zs(tmp0_desc, 0, value.t9f_1);
  tmp1_output.zs(tmp0_desc, 1, value.u9f_1);
  tmp1_output.zs(tmp0_desc, 2, value.v9f_1);
  tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3].t(), value.w9f_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_11).yn = function (encoder, value) {
  return this.n9g(encoder, value instanceof ApiHealthCheckQuestionnaire ? value : THROW_CCE());
};
protoOf($serializer_11).zn = function (decoder) {
  var tmp0_desc = this.m9g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.kr(tmp0_desc);
  var tmp9_cached = Companion_getInstance_9().l9g_1;
  if (tmp8_input.as()) {
    tmp4_local0 = tmp8_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.wr(tmp0_desc, 3, tmp9_cached[3].t(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.wr(tmp0_desc, 3, tmp9_cached[3].t(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.lr(tmp0_desc);
  return ApiHealthCheckQuestionnaire_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_11).xn = function () {
  return this.m9g_1;
};
protoOf($serializer_11).pz = function () {
  var tmp0_cached = Companion_getInstance_9().l9g_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].t()];
};
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 == null)
    new $serializer_11();
  return $serializer_instance_11;
}
function ApiHealthCheckQuestionnaire_init_$Init$(seen0, language, title, buttonText, questions, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_11().m9g_1);
  }
  $this.t9f_1 = language;
  $this.u9f_1 = title;
  $this.v9f_1 = buttonText;
  $this.w9f_1 = questions;
  return $this;
}
function ApiHealthCheckQuestionnaire_init_$Create$(seen0, language, title, buttonText, questions, serializationConstructorMarker) {
  return ApiHealthCheckQuestionnaire_init_$Init$(seen0, language, title, buttonText, questions, serializationConstructorMarker, objectCreate(protoOf(ApiHealthCheckQuestionnaire)));
}
function ApiHealthCheckQuestionnaire(language, title, buttonText, questions) {
  Companion_getInstance_9();
  this.t9f_1 = language;
  this.u9f_1 = title;
  this.v9f_1 = buttonText;
  this.w9f_1 = questions;
}
protoOf(ApiHealthCheckQuestionnaire).toString = function () {
  return 'ApiHealthCheckQuestionnaire(language=' + this.t9f_1 + ', title=' + this.u9f_1 + ', buttonText=' + this.v9f_1 + ', questions=' + toString_0(this.w9f_1) + ')';
};
protoOf(ApiHealthCheckQuestionnaire).hashCode = function () {
  var result = getStringHashCode(this.t9f_1);
  result = imul(result, 31) + getStringHashCode(this.u9f_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.v9f_1) | 0;
  result = imul(result, 31) + hashCode(this.w9f_1) | 0;
  return result;
};
protoOf(ApiHealthCheckQuestionnaire).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiHealthCheckQuestionnaire))
    return false;
  var tmp0_other_with_cast = other instanceof ApiHealthCheckQuestionnaire ? other : THROW_CCE();
  if (!(this.t9f_1 === tmp0_other_with_cast.t9f_1))
    return false;
  if (!(this.u9f_1 === tmp0_other_with_cast.u9f_1))
    return false;
  if (!(this.v9f_1 === tmp0_other_with_cast.v9f_1))
    return false;
  if (!equals(this.w9f_1, tmp0_other_with_cast.w9f_1))
    return false;
  return true;
};
function Companion_7() {
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function $serializer_12() {
  $serializer_instance_12 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.healthcheck.data.models.ApiSaveHealthCheckQuestionnaire.Request.QuestionResponse', this, 2);
  tmp0_serialDesc.wy('question_id', false);
  tmp0_serialDesc.wy('response_id', false);
  this.o9g_1 = tmp0_serialDesc;
}
protoOf($serializer_12).p9g = function (encoder, value) {
  var tmp0_desc = this.o9g_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.q9g_1);
  tmp1_output.vs(tmp0_desc, 1, value.r9g_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_12).yn = function (encoder, value) {
  return this.p9g(encoder, value instanceof QuestionResponse_0 ? value : THROW_CCE());
};
protoOf($serializer_12).zn = function (decoder) {
  var tmp0_desc = this.o9g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = new Long(0, 0);
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.qr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.qr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return QuestionResponse_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_12).xn = function () {
  return this.o9g_1;
};
protoOf($serializer_12).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), LongSerializer_getInstance()];
};
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 == null)
    new $serializer_12();
  return $serializer_instance_12;
}
function QuestionResponse_init_$Init$_0(seen0, questionId, responseId, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_12().o9g_1);
  }
  $this.q9g_1 = questionId;
  $this.r9g_1 = responseId;
  return $this;
}
function QuestionResponse_init_$Create$_0(seen0, questionId, responseId, serializationConstructorMarker) {
  return QuestionResponse_init_$Init$_0(seen0, questionId, responseId, serializationConstructorMarker, objectCreate(protoOf(QuestionResponse_0)));
}
function ApiSaveHealthCheckQuestionnaire$Request$Companion$$childSerializers$_anonymous__6ft5u9() {
  return new ArrayListSerializer($serializer_getInstance_12());
}
function QuestionResponse_0(questionId, responseId) {
  this.q9g_1 = questionId;
  this.r9g_1 = responseId;
}
protoOf(QuestionResponse_0).toString = function () {
  return 'QuestionResponse(questionId=' + this.q9g_1.toString() + ', responseId=' + this.r9g_1.toString() + ')';
};
protoOf(QuestionResponse_0).hashCode = function () {
  var result = this.q9g_1.hashCode();
  result = imul(result, 31) + this.r9g_1.hashCode() | 0;
  return result;
};
protoOf(QuestionResponse_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof QuestionResponse_0))
    return false;
  var tmp0_other_with_cast = other instanceof QuestionResponse_0 ? other : THROW_CCE();
  if (!this.q9g_1.equals(tmp0_other_with_cast.q9g_1))
    return false;
  if (!this.r9g_1.equals(tmp0_other_with_cast.r9g_1))
    return false;
  return true;
};
function Companion_8() {
  Companion_instance_11 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.s9g_1 = [null, lazy(tmp_0, ApiSaveHealthCheckQuestionnaire$Request$Companion$$childSerializers$_anonymous__6ft5u9)];
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 == null)
    new Companion_8();
  return Companion_instance_11;
}
function $serializer_13() {
  $serializer_instance_13 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.healthcheck.data.models.ApiSaveHealthCheckQuestionnaire.Request', this, 2);
  tmp0_serialDesc.wy('employee_id', false);
  tmp0_serialDesc.wy('questions', false);
  this.t9g_1 = tmp0_serialDesc;
}
protoOf($serializer_13).u9g = function (encoder, value) {
  var tmp0_desc = this.t9g_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_11().s9g_1;
  tmp1_output.zs(tmp0_desc, 0, value.v9g_1);
  tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1].t(), value.w9g_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_13).yn = function (encoder, value) {
  return this.u9g(encoder, value instanceof Request ? value : THROW_CCE());
};
protoOf($serializer_13).zn = function (decoder) {
  var tmp0_desc = this.t9g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  var tmp7_cached = Companion_getInstance_11().s9g_1;
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return Request_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_13).xn = function () {
  return this.t9g_1;
};
protoOf($serializer_13).pz = function () {
  var tmp0_cached = Companion_getInstance_11().s9g_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), tmp0_cached[1].t()];
};
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 == null)
    new $serializer_13();
  return $serializer_instance_13;
}
function Request_init_$Init$(seen0, employeeId, questions, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_13().t9g_1);
  }
  $this.v9g_1 = employeeId;
  $this.w9g_1 = questions;
  return $this;
}
function Request_init_$Create$(seen0, employeeId, questions, serializationConstructorMarker) {
  return Request_init_$Init$(seen0, employeeId, questions, serializationConstructorMarker, objectCreate(protoOf(Request)));
}
function Companion_9() {
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
function $serializer_14() {
  $serializer_instance_14 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.healthcheck.data.models.ApiSaveHealthCheckQuestionnaire.Response', this, 1);
  tmp0_serialDesc.wy('health_check_response_id', false);
  this.x9g_1 = tmp0_serialDesc;
}
protoOf($serializer_14).y9g = function (encoder, value) {
  var tmp0_desc = this.x9g_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.z9g_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_14).yn = function (encoder, value) {
  return this.y9g(encoder, value instanceof Response_2 ? value : THROW_CCE());
};
protoOf($serializer_14).zn = function (decoder) {
  var tmp0_desc = this.x9g_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return Response_init_$Create$_1(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_14).xn = function () {
  return this.x9g_1;
};
protoOf($serializer_14).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 == null)
    new $serializer_14();
  return $serializer_instance_14;
}
function Response_init_$Init$_1(seen0, healthCheckResponseId, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_14().x9g_1);
  }
  $this.z9g_1 = healthCheckResponseId;
  return $this;
}
function Response_init_$Create$_1(seen0, healthCheckResponseId, serializationConstructorMarker) {
  return Response_init_$Init$_1(seen0, healthCheckResponseId, serializationConstructorMarker, objectCreate(protoOf(Response_2)));
}
function Request(employeeId, questions) {
  Companion_getInstance_11();
  this.v9g_1 = employeeId;
  this.w9g_1 = questions;
}
protoOf(Request).toString = function () {
  return 'Request(employeeId=' + this.v9g_1 + ', questions=' + toString_0(this.w9g_1) + ')';
};
protoOf(Request).hashCode = function () {
  var result = getStringHashCode(this.v9g_1);
  result = imul(result, 31) + hashCode(this.w9g_1) | 0;
  return result;
};
protoOf(Request).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Request))
    return false;
  var tmp0_other_with_cast = other instanceof Request ? other : THROW_CCE();
  if (!(this.v9g_1 === tmp0_other_with_cast.v9g_1))
    return false;
  if (!equals(this.w9g_1, tmp0_other_with_cast.w9g_1))
    return false;
  return true;
};
function Response_2(healthCheckResponseId) {
  this.z9g_1 = healthCheckResponseId;
}
protoOf(Response_2).toString = function () {
  return 'Response(healthCheckResponseId=' + this.z9g_1 + ')';
};
protoOf(Response_2).hashCode = function () {
  return getStringHashCode(this.z9g_1);
};
protoOf(Response_2).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Response_2))
    return false;
  var tmp0_other_with_cast = other instanceof Response_2 ? other : THROW_CCE();
  if (!(this.z9g_1 === tmp0_other_with_cast.z9g_1))
    return false;
  return true;
};
function $getHealthCheckQuestionnaireCOROUTINE$15(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i9h_1 = _this__u8e3s4;
}
protoOf($getHealthCheckQuestionnaireCOROUTINE$15).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.j9h_1 = this.i9h_1.n9h_1;
          this.n8_1 = 1;
          suspendResult = this.i9h_1.m9h_1.q37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.k9h_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.i9h_1.m9h_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.l9h_1 = suspendResult;
          this.n8_1 = 3;
          suspendResult = this.j9h_1.o9h(this.k9h_1, this.l9h_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 4;
          continue $sm;
        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var this_1 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.j();
            while (_iterator__ex2g4s.k()) {
              var item = _iterator__ex2g4s.l();
              destination.e(toDomain_4(item));
            }
            tmp_0 = _Result___init__impl__xyqfz8(destination);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $saveHealthCheckQuestionnaireResponsesCOROUTINE$16(_this__u8e3s4, healthCheckQuestionnaireResponses, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.x9h_1 = _this__u8e3s4;
  this.y9h_1 = healthCheckQuestionnaireResponses;
}
protoOf($saveHealthCheckQuestionnaireResponsesCOROUTINE$16).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.z9h_1 = toApiSaveHealthCheckQuestionnaireRequest(this.y9h_1);
          this.a9i_1 = this.x9h_1.n9h_1;
          this.n8_1 = 1;
          suspendResult = this.x9h_1.m9h_1.q37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.b9i_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.x9h_1.m9h_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.c9i_1 = suspendResult;
          this.n8_1 = 3;
          suspendResult = this.a9i_1.d9i(this.b9i_1, this.c9i_1, this.z9h_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 4;
          continue $sm;
        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var value = ((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE()).z9g_1;
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function HealthCheckRepositoryImpl(sessionDataProvider, healthCheckRemoteSource) {
  this.m9h_1 = sessionDataProvider;
  this.n9h_1 = healthCheckRemoteSource;
}
protoOf(HealthCheckRepositoryImpl).e9i = function ($completion) {
  var tmp = new $getHealthCheckQuestionnaireCOROUTINE$15(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(HealthCheckRepositoryImpl).f9i = function (healthCheckQuestionnaireResponses, $completion) {
  var tmp = new $saveHealthCheckQuestionnaireResponsesCOROUTINE$16(this, healthCheckQuestionnaireResponses, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function HealthCheckRemoteSource() {
}
function HealthCheckRemoteSourceImpl$getHealthCheckQuestionnaire$lambda($locationHash) {
  return function ($this$get, it) {
    $this$get.o44_1.r3q('group_hash', $locationHash);
    return Unit_instance;
  };
}
function HealthCheckRemoteSourceImpl$getHealthCheckQuestionnaire$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function HealthCheckRemoteSourceImpl$saveHealthCheckQuestionnaireResponses$lambda($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function HealthCheckRemoteSourceImpl$saveHealthCheckQuestionnaireResponses$lambda_0($locationHash) {
  return function ($this$url, it) {
    $this$url.o44_1.r3q('group_hash', $locationHash);
    return Unit_instance;
  };
}
function $getHealthCheckQuestionnaireCOROUTINE$17(_this__u8e3s4, locationId, locationHash, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.o9i_1 = _this__u8e3s4;
  this.p9i_1 = locationId;
  this.q9i_1 = locationHash;
}
protoOf($getHealthCheckQuestionnaireCOROUTINE$17).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.r9i_1 = this.o9i_1.k9k_1;
          var tmp_1 = this;
          tmp_1.s9i_1 = 'time_clocking/health_check/' + this.p9i_1.toString();
          var tmp_2 = this;
          tmp_2.t9i_1 = ApiVersion_FEBRUARY_2026_getInstance();
          var tmp_3 = this;
          tmp_3.u9i_1 = HealthCheckRemoteSourceImpl$getHealthCheckQuestionnaire$lambda(this.q9i_1);
          this.v9i_1 = this.r9i_1;
          this.w9i_1 = this.s9i_1;
          this.x9i_1 = this.t9i_1;
          this.y9i_1 = this.u9i_1;
          this.o8_1 = 2;
          var tmp_4 = this;
          tmp_4.a9j_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.b9j_1 = this.v9i_1.f6l_1;
          var tmp_6 = this;
          tmp_6.c9j_1 = buildV2Path(this.v9i_1, this.w9i_1);
          this.d9j_1 = this.b9j_1;
          this.e9j_1 = this.c9j_1;
          var tmp_7 = this;
          tmp_7.f9j_1 = this.d9j_1;
          this.g9j_1 = this.f9j_1;
          var tmp_8 = this;
          tmp_8.h9j_1 = this.g9j_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.e9j_1);
          headers(this_0, HealthCheckRemoteSourceImpl$getHealthCheckQuestionnaire$lambda_0(this.x9i_1));
          this_0.z5n(this.y9i_1);
          tmp_9.i9j_1 = this_0;
          this.j9j_1 = this.h9j_1;
          this.k9j_1 = this.i9j_1;
          this.k9j_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.l9j_1 = this.j9j_1;
          var tmp_11 = this;
          tmp_11.m9j_1 = this.k9j_1;
          this.n9j_1 = this.l9j_1;
          this.o9j_1 = this.m9j_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.o9j_1, this.n9j_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.p9j_1 = suspendResult;
          var tmp_12 = this;
          this.a9j_1;
          var value = this.p9j_1;
          tmp_12.z9i_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.q9j_1 = this.q8_1;
            var tmp_14 = this;
            throw this.q9j_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.r9j_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.r9j_1;
              tmp_16.z9i_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.s9j_1 = this.z9i_1;
          this.t9j_1 = this.s9j_1;
          this.u9j_1 = Result__exceptionOrNull_impl_p6xea9(this.t9j_1);
          if (this.u9j_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.t9j_1);
            tmp_17.w9j_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.x9j_1 = this.w9j_1;
            var tmp_19 = this;
            tmp_19.y9j_1 = this.x9j_1;
            this.z9j_1 = this.y9j_1;
            this.a9k_1 = this.z9j_1.c4u().z43_1;
            var containsArg = this.a9k_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_20 = this;
              tmp_20.d9k_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.f9k_1 = this.z9j_1;
                this.g9k_1 = this.f9k_1;
                this.n8_1 = 6;
                var tmp_22 = this.g9k_1.y4u();
                var tmp_23 = getKClass(KtList);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiHealthCheckQuestionnaire), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.h9k_1 = this.z9j_1;
                this.i9k_1 = this.h9k_1;
                this.n8_1 = 5;
                var tmp_27 = this.i9k_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.j9k_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.z9j_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.u9j_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_32.v9j_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.j9k_1;
          tmp_33.b9k_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiHealthCheckQuestionnaire), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.e9k_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_37 = this;
          tmp_37.e9k_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.e9k_1;
          var tmp_38 = this;
          this.d9k_1;
          tmp_38.c9k_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.c9k_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_43 = this;
          var this_2 = this.c9k_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.b9k_1 = tmp_44.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.v9j_1 = new Result(this.b9k_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.v9j_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $saveHealthCheckQuestionnaireResponsesCOROUTINE$18(_this__u8e3s4, locationId, locationHash, request, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t9k_1 = _this__u8e3s4;
  this.u9k_1 = locationId;
  this.v9k_1 = locationHash;
  this.w9k_1 = request;
}
protoOf($saveHealthCheckQuestionnaireResponsesCOROUTINE$18).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.x9k_1 = this.t9k_1.k9k_1;
          var tmp_1 = this;
          tmp_1.y9k_1 = 'time_clocking/health_check/' + this.u9k_1.toString();
          var tmp_2 = this;
          tmp_2.z9k_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.a9l_1 = this.x9k_1;
          this.b9l_1 = this.y9k_1;
          this.c9l_1 = this.z9k_1;
          this.o8_1 = 2;
          var tmp_3 = this;
          tmp_3.e9l_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.f9l_1 = this.a9l_1.f6l_1;
          var tmp_5 = this;
          tmp_5.g9l_1 = buildV2Path(this.a9l_1, this.b9l_1);
          this.h9l_1 = this.f9l_1;
          this.i9l_1 = this.g9l_1;
          var tmp_6 = this;
          tmp_6.j9l_1 = this.h9l_1;
          this.k9l_1 = this.j9l_1;
          var tmp_7 = this;
          tmp_7.l9l_1 = this.k9l_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.i9l_1);
          contentType(this_0, Application_getInstance().c3v_1);
          headers(this_0, HealthCheckRemoteSourceImpl$saveHealthCheckQuestionnaireResponses$lambda(this.c9l_1));
          this_0.z5n(HealthCheckRemoteSourceImpl$saveHealthCheckQuestionnaireResponses$lambda_0(this.v9k_1));
          var body = this.w9k_1;
          if (body == null) {
            this_0.s4r_1 = NullBody_instance;
            var tmp_9 = getKClass(Request);
            var tmp_10;
            try {
              tmp_10 = createKType(getKClass(Request), arrayOf([]), false);
            } catch ($p) {
              var tmp_11;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_11 = null;
              } else {
                throw $p;
              }
              tmp_10 = tmp_11;
            }
            this_0.n4x(new TypeInfo(tmp_9, tmp_10));
          } else {
            if (body instanceof OutgoingContent) {
              this_0.s4r_1 = body;
              this_0.n4x(null);
            } else {
              this_0.s4r_1 = body;
              var tmp_12 = getKClass(Request);
              var tmp_13;
              try {
                tmp_13 = createKType(getKClass(Request), arrayOf([]), false);
              } catch ($p) {
                var tmp_14;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3_0 = $p;
                  tmp_14 = null;
                } else {
                  throw $p;
                }
                tmp_13 = tmp_14;
              }
              this_0.n4x(new TypeInfo(tmp_12, tmp_13));
            }
          }

          tmp_8.m9l_1 = this_0;
          this.n9l_1 = this.l9l_1;
          this.o9l_1 = this.m9l_1;
          this.o9l_1.q4r_1 = Companion_getInstance_0().g41_1;
          var tmp_15 = this;
          tmp_15.p9l_1 = this.n9l_1;
          var tmp_16 = this;
          tmp_16.q9l_1 = this.o9l_1;
          this.r9l_1 = this.p9l_1;
          this.s9l_1 = this.q9l_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.s9l_1, this.r9l_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.t9l_1 = suspendResult;
          var tmp_17 = this;
          this.e9l_1;
          var value = this.t9l_1;
          tmp_17.d9l_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_18 = this.q8_1;
          if (tmp_18 instanceof CancellationException) {
            this.u9l_1 = this.q8_1;
            var tmp_19 = this;
            throw this.u9l_1;
          } else {
            var tmp_20 = this.q8_1;
            if (tmp_20 instanceof Error) {
              this.v9l_1 = this.q8_1;
              var tmp_21 = this;
              var exception = this.v9l_1;
              tmp_21.d9l_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.w9l_1 = this.d9l_1;
          this.x9l_1 = this.w9l_1;
          this.y9l_1 = Result__exceptionOrNull_impl_p6xea9(this.x9l_1);
          if (this.y9l_1 == null) {
            var tmp_22 = this;
            var tmp_23 = _Result___get_value__impl__bjfvqg(this.x9l_1);
            tmp_22.a9m_1 = (tmp_23 == null ? true : !(tmp_23 == null)) ? tmp_23 : THROW_CCE();
            this.b9m_1 = this.a9m_1;
            var tmp_24 = this;
            tmp_24.c9m_1 = this.b9m_1;
            this.d9m_1 = this.c9m_1;
            this.e9m_1 = this.d9m_1.c4u().z43_1;
            var containsArg = this.e9m_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_25 = this;
              tmp_25.h9m_1 = Companion_instance;
              if (getKClass(Response_2).equals(getKClass(Unit))) {
                var tmp_26 = this;
                tmp_26.j9m_1 = this.d9m_1;
                this.k9m_1 = this.j9m_1;
                this.n8_1 = 6;
                var tmp_27 = this.k9m_1.y4u();
                var tmp_28 = getKClass(Response_2);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(Response_2), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_1 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_31 = this;
                tmp_31.l9m_1 = this.d9m_1;
                this.m9m_1 = this.l9m_1;
                this.n8_1 = 5;
                var tmp_32 = this.m9m_1.y4u();
                var tmp_33 = getKClass(JsonElement);
                var tmp_34;
                try {
                  tmp_34 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_35;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_2 = $p;
                    tmp_35 = null;
                  } else {
                    throw $p;
                  }
                  tmp_34 = tmp_35;
                }
                suspendResult = tmp_32.a4u(new TypeInfo(tmp_33, tmp_34), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_36 = this;
              tmp_36.n9m_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.d9m_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_37 = this;
            var it = this.y9l_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_37.z9l_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_38 = this;
          this.n9m_1;
          tmp_38.f9m_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_39 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(Response_2), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_40;
            if (tmp2 instanceof JsonObject) {
              tmp_40 = tmp2.c3p('data');
            } else {
              tmp_40 = false;
            }
            if (tmp_40) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_41;
              if (dataValue instanceof JsonObject) {
                tmp_41 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_41 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_41 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_41;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_39.i9m_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_42 = this;
          tmp_42.i9m_1 = suspendResult instanceof Response_2 ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.i9m_1;
          var tmp_43 = this;
          this.h9m_1;
          tmp_43.g9m_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_44 = this.q8_1;
          if (tmp_44 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_45 = this;
            throw e_0;
          } else {
            var tmp_46 = this.q8_1;
            if (tmp_46 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_47 = this;
              tmp_47.g9m_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_48 = this;
          var this_2 = this.g9m_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_49;
          if (exception_1 == null) {
            var tmp_50 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_50 == null ? true : !(tmp_50 == null)) ? tmp_50 : THROW_CCE();
            tmp_49 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_49 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_48.f9m_1 = tmp_49.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.z9l_1 = new Result(this.f9m_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.z9l_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function HealthCheckRemoteSourceImpl(apiClient) {
  this.k9k_1 = apiClient;
}
protoOf(HealthCheckRemoteSourceImpl).o9h = function (locationId, locationHash, $completion) {
  var tmp = new $getHealthCheckQuestionnaireCOROUTINE$17(this, locationId, locationHash, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(HealthCheckRemoteSourceImpl).d9i = function (locationId, locationHash, request, $completion) {
  var tmp = new $saveHealthCheckQuestionnaireResponsesCOROUTINE$18(this, locationId, locationHash, request, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function Question_0(id, text, responses) {
  this.o9m_1 = id;
  this.p9m_1 = text;
  this.q9m_1 = responses;
}
protoOf(Question_0).toString = function () {
  return 'Question(id=' + this.o9m_1.toString() + ', text=' + this.p9m_1 + ', responses=' + toString_0(this.q9m_1) + ')';
};
protoOf(Question_0).hashCode = function () {
  var result = this.o9m_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.p9m_1) | 0;
  result = imul(result, 31) + hashCode(this.q9m_1) | 0;
  return result;
};
protoOf(Question_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Question_0))
    return false;
  var tmp0_other_with_cast = other instanceof Question_0 ? other : THROW_CCE();
  if (!this.o9m_1.equals(tmp0_other_with_cast.o9m_1))
    return false;
  if (!(this.p9m_1 === tmp0_other_with_cast.p9m_1))
    return false;
  if (!equals(this.q9m_1, tmp0_other_with_cast.q9m_1))
    return false;
  return true;
};
function Response_3(id, text) {
  this.r9m_1 = id;
  this.s9m_1 = text;
}
protoOf(Response_3).toString = function () {
  return 'Response(id=' + this.r9m_1.toString() + ', text=' + this.s9m_1 + ')';
};
protoOf(Response_3).hashCode = function () {
  var result = this.r9m_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.s9m_1) | 0;
  return result;
};
protoOf(Response_3).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Response_3))
    return false;
  var tmp0_other_with_cast = other instanceof Response_3 ? other : THROW_CCE();
  if (!this.r9m_1.equals(tmp0_other_with_cast.r9m_1))
    return false;
  if (!(this.s9m_1 === tmp0_other_with_cast.s9m_1))
    return false;
  return true;
};
function HealthCheckQuestionnaire(language, title, buttonText, questions) {
  this.t9m_1 = language;
  this.u9m_1 = title;
  this.v9m_1 = buttonText;
  this.w9m_1 = questions;
}
protoOf(HealthCheckQuestionnaire).toString = function () {
  return 'HealthCheckQuestionnaire(language=' + this.t9m_1 + ', title=' + this.u9m_1 + ', buttonText=' + this.v9m_1 + ', questions=' + toString_0(this.w9m_1) + ')';
};
protoOf(HealthCheckQuestionnaire).hashCode = function () {
  var result = getStringHashCode(this.t9m_1);
  result = imul(result, 31) + getStringHashCode(this.u9m_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.v9m_1) | 0;
  result = imul(result, 31) + hashCode(this.w9m_1) | 0;
  return result;
};
protoOf(HealthCheckQuestionnaire).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HealthCheckQuestionnaire))
    return false;
  var tmp0_other_with_cast = other instanceof HealthCheckQuestionnaire ? other : THROW_CCE();
  if (!(this.t9m_1 === tmp0_other_with_cast.t9m_1))
    return false;
  if (!(this.u9m_1 === tmp0_other_with_cast.u9m_1))
    return false;
  if (!(this.v9m_1 === tmp0_other_with_cast.v9m_1))
    return false;
  if (!equals(this.w9m_1, tmp0_other_with_cast.w9m_1))
    return false;
  return true;
};
function QuestionResponse_1(questionId, responseId) {
  this.z9f_1 = questionId;
  this.a9g_1 = responseId;
}
protoOf(QuestionResponse_1).toString = function () {
  return 'QuestionResponse(questionId=' + this.z9f_1.toString() + ', responseId=' + this.a9g_1.toString() + ')';
};
protoOf(QuestionResponse_1).hashCode = function () {
  var result = this.z9f_1.hashCode();
  result = imul(result, 31) + this.a9g_1.hashCode() | 0;
  return result;
};
protoOf(QuestionResponse_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof QuestionResponse_1))
    return false;
  var tmp0_other_with_cast = other instanceof QuestionResponse_1 ? other : THROW_CCE();
  if (!this.z9f_1.equals(tmp0_other_with_cast.z9f_1))
    return false;
  if (!this.a9g_1.equals(tmp0_other_with_cast.a9g_1))
    return false;
  return true;
};
function HealthCheckQuestionnaireResponses(employeePunchId, questionResponses) {
  this.x9f_1 = employeePunchId;
  this.y9f_1 = questionResponses;
}
protoOf(HealthCheckQuestionnaireResponses).toString = function () {
  return 'HealthCheckQuestionnaireResponses(employeePunchId=' + this.x9f_1 + ', questionResponses=' + toString_0(this.y9f_1) + ')';
};
protoOf(HealthCheckQuestionnaireResponses).hashCode = function () {
  var result = getStringHashCode(this.x9f_1);
  result = imul(result, 31) + hashCode(this.y9f_1) | 0;
  return result;
};
protoOf(HealthCheckQuestionnaireResponses).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof HealthCheckQuestionnaireResponses))
    return false;
  var tmp0_other_with_cast = other instanceof HealthCheckQuestionnaireResponses ? other : THROW_CCE();
  if (!(this.x9f_1 === tmp0_other_with_cast.x9f_1))
    return false;
  if (!equals(this.y9f_1, tmp0_other_with_cast.y9f_1))
    return false;
  return true;
};
function HealthCheckRepository() {
}
function OfflinePunchRepositoryImpl(offlinePunchSyncRemoteSource) {
  this.x9m_1 = offlinePunchSyncRemoteSource;
}
function OfflinePunchSyncRemoteSource() {
}
function OfflinePunchSyncRemoteSourceImpl(apiClient) {
  this.y9m_1 = apiClient;
}
function OfflinePunchRepository() {
}
function toDomain_7(_this__u8e3s4, logger) {
  var tmp = new User(_this__u8e3s4.z9m_1, _this__u8e3s4.b9n_1, _this__u8e3s4.c9n_1, _this__u8e3s4.d9n_1);
  var tmp_0 = getStatusInformation(_this__u8e3s4, logger);
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = _this__u8e3s4.j9n_1;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.runCatching' call
    var tmp_1;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = apiValueToAvailableAction(element, logger);
      tmp_1 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_1;
    var tmp_3;
    if (_Result___get_isFailure__impl__jpiriv(this_0)) {
      tmp_3 = null;
    } else {
      var tmp_4 = _Result___get_value__impl__bjfvqg(this_0);
      tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
    }
    var tmp0_safe_receiver = tmp_3;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.e(tmp0_safe_receiver);
    }
  }
  return new UserStatus(tmp, tmp_0, toSet(destination), _this__u8e3s4.k9n_1);
}
function getStatusInformation(_this__u8e3s4, logger) {
  var tmp;
  switch (_this__u8e3s4.f9n_1) {
    case 'clocked_in':
      logger.i6e(Companion_instance_0.s6e('TimePunchUserInformationMappers | State = clocked_in'));
      if (_this__u8e3s4.h9n_1 == null) {
        reportInfrastructureIssueAndThrow(logger, new InfrastructureIssue(Subsystem_REST_getInstance(), ProcessingPhase_MAPPING_getInstance(), Impact_HIGH_getInstance(), 'TimePunchUserInformationMappers | ClockedInInfo is null', mapOf(to('state', _this__u8e3s4.f9n_1))), IllegalArgumentException_init_$Create$('TimePunchUserInformationMappers | ClockedInInfo is null for state ' + _this__u8e3s4.f9n_1));
      }

      tmp = mapClockedInStatusInformation(_this__u8e3s4.h9n_1, logger);
      break;
    case 'clocked_out':
      logger.i6e(Companion_instance_0.s6e('TimePunchUserInformationMappers | State = clocked_out'));
      if (_this__u8e3s4.g9n_1 == null) {
        reportInfrastructureIssueAndThrow(logger, new InfrastructureIssue(Subsystem_REST_getInstance(), ProcessingPhase_MAPPING_getInstance(), Impact_HIGH_getInstance(), 'TimePunchUserInformationMappers | ClockedOutInfo is null', mapOf(to('state', _this__u8e3s4.f9n_1))), IllegalArgumentException_init_$Create$('TimePunchUserInformationMappers | ClockedOutInfo is null for state ' + _this__u8e3s4.f9n_1));
      }

      tmp = mapClockedOutStatusInformation(_this__u8e3s4.g9n_1, logger);
      break;
    case 'on_break':
      logger.i6e(Companion_instance_0.s6e('TimePunchUserInformationMappers | State = on_break'));
      if (_this__u8e3s4.i9n_1 == null) {
        reportInfrastructureIssueAndThrow(logger, new InfrastructureIssue(Subsystem_REST_getInstance(), ProcessingPhase_MAPPING_getInstance(), Impact_HIGH_getInstance(), 'TimePunchUserInformationMappers | OnBreakInfo is null', mapOf(to('state', _this__u8e3s4.f9n_1))), IllegalArgumentException_init_$Create$('TimePunchUserInformationMappers | OnBreakInfo is null for state ' + _this__u8e3s4.f9n_1));
      }

      tmp = mapOnBreakStatusInformation(_this__u8e3s4.i9n_1, logger);
      break;
    default:
      reportInfrastructureIssueAndThrow(logger, new InfrastructureIssue(Subsystem_REST_getInstance(), ProcessingPhase_MAPPING_getInstance(), Impact_HIGH_getInstance(), 'TimePunchUserInformationMappers | Unknown user state value', mapOf(to('state_raw', _this__u8e3s4.f9n_1))), IllegalArgumentException_init_$Create$('TimePunchUserInformationMappers | Unknown user state value: ' + _this__u8e3s4.f9n_1));
      break;
  }
  return tmp;
}
function apiValueToAvailableAction(value, logger) {
  var tmp;
  switch (value) {
    case 'clock_in':
      tmp = TimePunchUserAction_CLOCK_IN_getInstance();
      break;
    case 'clock_out':
      tmp = TimePunchUserAction_CLOCK_OUT_getInstance();
      break;
    case 'start_paid_break':
      tmp = TimePunchUserAction_START_PAID_BREAK_getInstance();
      break;
    case 'start_unpaid_break':
      tmp = TimePunchUserAction_START_UNPAID_BREAK_getInstance();
      break;
    case 'start_custom_break':
      tmp = TimePunchUserAction_START_CUSTOM_BREAK_getInstance();
      break;
    case 'end_break':
      tmp = TimePunchUserAction_END_BREAK_getInstance();
      break;
    default:
      reportInfrastructureIssueAndThrow(logger, new InfrastructureIssue(Subsystem_REST_getInstance(), ProcessingPhase_MAPPING_getInstance(), Impact_HIGH_getInstance(), 'TimePunchUserInformationMappers | Unknown available action value', mapOf(to('available_action_raw', value))), IllegalArgumentException_init_$Create$('TimePunchUserInformationMappers | Unknown available action value: ' + value));
      break;
  }
  return tmp;
}
function mapClockedInStatusInformation(clockedIn, logger) {
  // Inline function 'kotlin.with' call
  var $this$with = clockedIn.l9n_1;
  var tmp = toPunch($this$with, logger);
  var tmp0_safe_receiver = $this$with.t9n_1;
  var tmp_0 = tmp0_safe_receiver == null ? null : toShift(tmp0_safe_receiver, logger);
  var tmp1_safe_receiver = clockedIn.m9n_1;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
    var _iterator__ex2g4s = tmp1_safe_receiver.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      var tmp$ret$0 = new CustomBreak(item.u9n_1, item.v9n_1, item.w9n_1);
      destination.e(tmp$ret$0);
    }
    tmp_1 = destination;
  }
  return new ClockedIn(tmp, tmp_0, tmp_1);
}
function mapClockedOutStatusInformation(clockedOut, logger) {
  // Inline function 'kotlin.with' call
  var tmp0 = clockedOut.x9n_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.i9o_1) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var currentShift = tmp0_safe_receiver == null ? null : toShift(tmp0_safe_receiver, logger);
  var scheduledAssignment = currentShift == null ? null : currentShift.m9o_1;
  var tmp;
  if (scheduledAssignment == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = clockedOut.y9n_1;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.filterNot' call
      // Inline function 'kotlin.collections.filterNotTo' call
      var destination = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_0 = tmp0_safe_receiver_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        var tmp0_safe_receiver_1 = scheduledAssignment instanceof Role ? scheduledAssignment : null;
        var tmp1_safe_receiver = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.a90_1;
        if (!element_0.q9o_1.equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e90_1)) {
          destination.e(element_0);
        }
      }
      tmp_0 = destination;
    }
    var tmp1_safe_receiver_0 = tmp_0;
    var tmp_1;
    if (tmp1_safe_receiver_0 == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_safe_receiver_0, 10));
      var _iterator__ex2g4s_1 = tmp1_safe_receiver_0.j();
      while (_iterator__ex2g4s_1.k()) {
        var item = _iterator__ex2g4s_1.l();
        var tmp$ret$5 = toAssignedRole(item, logger);
        destination_0.e(tmp$ret$5);
      }
      tmp_1 = destination_0;
    }
    tmp = tmp_1;
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = tmp;
  var tmp_2;
  var tmp_3;
  if (this_0 == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_3 = !this_0.p();
  }
  if (tmp_3 === true) {
    tmp_2 = this_0;
  } else {
    tmp_2 = null;
  }
  var tmp$ret$12 = tmp_2;
  return new ClockedOut(currentShift, tmp$ret$12);
}
function mapOnBreakStatusInformation(onBreakInfo, logger) {
  // Inline function 'kotlin.with' call
  var tmp = toPunch(onBreakInfo.v9o_1, logger);
  var tmp0_safe_receiver = onBreakInfo.v9o_1.t9n_1;
  return new OnBreak(tmp, tmp0_safe_receiver == null ? null : toShift(tmp0_safe_receiver, logger), new Break(onBreakInfo.w9o_1.a9p_1, mapCustomBreakIfValid(onBreakInfo.w9o_1)));
}
function toPunch(_this__u8e3s4, logger) {
  logger.i6e(Companion_instance_0.s6e('TimePunchUserInformationMappers | Mapping ActivePunch to Punch'));
  return new Punch(_this__u8e3s4.n9n_1, AssignmentMappers_instance.x8z(_this__u8e3s4.q9n_1, _this__u8e3s4.r9n_1, _this__u8e3s4.s9n_1, _this__u8e3s4.o9n_1, _this__u8e3s4.p9n_1, logger));
}
function toShift(_this__u8e3s4, logger) {
  logger.i6e(Companion_instance_0.s6e('TimePunchUserInformationMappers | Mapping Shift'));
  return new Shift(_this__u8e3s4.z9n_1, AssignmentMappers_instance.x8z(_this__u8e3s4.d9o_1, _this__u8e3s4.e9o_1, _this__u8e3s4.f9o_1, _this__u8e3s4.a9o_1, _this__u8e3s4.b9o_1, logger), _this__u8e3s4.g9o_1, _this__u8e3s4.h9o_1, _this__u8e3s4.j9o_1 ? EndCriteria_CLOSE_getInstance() : _this__u8e3s4.k9o_1 ? EndCriteria_BUSINESS_DECLINE_getInstance() : null);
}
function toAssignedRole(_this__u8e3s4, logger) {
  logger.i6e(Companion_instance_0.s6e('TimePunchUserInformationMappers | Mapping AvailableRole'));
  return new Role(RoleMappers_instance.z8z(_this__u8e3s4.q9o_1, _this__u8e3s4.r9o_1, _this__u8e3s4.s9o_1, _this__u8e3s4.t9o_1, _this__u8e3s4.u9o_1, logger));
}
function mapCustomBreakIfValid(activeBreak) {
  var tmp;
  if (!(activeBreak.x9o_1 == null) && !(activeBreak.y9o_1 == null) && !(activeBreak.z9o_1 == null)) {
    tmp = new CustomBreak(activeBreak.x9o_1, activeBreak.y9o_1, activeBreak.z9o_1);
  } else {
    tmp = null;
  }
  return tmp;
}
function $serializer_15() {
  $serializer_instance_15 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.ClockedOutInfo.AvailableRole', this, 5);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('color', false);
  tmp0_serialDesc.wy('department_id', false);
  tmp0_serialDesc.wy('department_name', false);
  this.b9p_1 = tmp0_serialDesc;
}
protoOf($serializer_15).c9p = function (encoder, value) {
  var tmp0_desc = this.b9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.q9o_1);
  tmp1_output.zs(tmp0_desc, 1, value.r9o_1);
  tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.s9o_1);
  tmp1_output.dt(tmp0_desc, 3, LongSerializer_getInstance(), value.t9o_1);
  tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.u9o_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_15).yn = function (encoder, value) {
  return this.c9p(encoder, value instanceof AvailableRole ? value : THROW_CCE());
};
protoOf($serializer_15).zn = function (decoder) {
  var tmp0_desc = this.b9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.kr(tmp0_desc);
  if (tmp9_input.as()) {
    tmp4_local0 = tmp9_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.lr(tmp0_desc);
  return AvailableRole_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_15).xn = function () {
  return this.b9p_1;
};
protoOf($serializer_15).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 == null)
    new $serializer_15();
  return $serializer_instance_15;
}
function AvailableRole_init_$Init$(seen0, id, name, color, departmentId, departmentName, serializationConstructorMarker, $this) {
  if (!(31 === (31 & seen0))) {
    throwMissingFieldException(seen0, 31, $serializer_getInstance_15().b9p_1);
  }
  $this.q9o_1 = id;
  $this.r9o_1 = name;
  $this.s9o_1 = color;
  $this.t9o_1 = departmentId;
  $this.u9o_1 = departmentName;
  return $this;
}
function AvailableRole_init_$Create$(seen0, id, name, color, departmentId, departmentName, serializationConstructorMarker) {
  return AvailableRole_init_$Init$(seen0, id, name, color, departmentId, departmentName, serializationConstructorMarker, objectCreate(protoOf(AvailableRole)));
}
function ApiTimePunchUserInformation$ClockedOutInfo$Companion$$childSerializers$_anonymous__n0c6q7() {
  return new ArrayListSerializer($serializer_getInstance_22());
}
function ApiTimePunchUserInformation$ClockedOutInfo$Companion$$childSerializers$_anonymous__n0c6q7_0() {
  return new ArrayListSerializer($serializer_getInstance_15());
}
function AvailableRole() {
}
protoOf(AvailableRole).toString = function () {
  return 'AvailableRole(id=' + this.q9o_1.toString() + ', name=' + this.r9o_1 + ', color=' + this.s9o_1 + ', departmentId=' + toString(this.t9o_1) + ', departmentName=' + this.u9o_1 + ')';
};
protoOf(AvailableRole).hashCode = function () {
  var result = this.q9o_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.r9o_1) | 0;
  result = imul(result, 31) + (this.s9o_1 == null ? 0 : getStringHashCode(this.s9o_1)) | 0;
  result = imul(result, 31) + (this.t9o_1 == null ? 0 : this.t9o_1.hashCode()) | 0;
  result = imul(result, 31) + (this.u9o_1 == null ? 0 : getStringHashCode(this.u9o_1)) | 0;
  return result;
};
protoOf(AvailableRole).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AvailableRole))
    return false;
  var tmp0_other_with_cast = other instanceof AvailableRole ? other : THROW_CCE();
  if (!this.q9o_1.equals(tmp0_other_with_cast.q9o_1))
    return false;
  if (!(this.r9o_1 === tmp0_other_with_cast.r9o_1))
    return false;
  if (!(this.s9o_1 == tmp0_other_with_cast.s9o_1))
    return false;
  if (!equals(this.t9o_1, tmp0_other_with_cast.t9o_1))
    return false;
  if (!(this.u9o_1 == tmp0_other_with_cast.u9o_1))
    return false;
  return true;
};
function Companion_10() {
  Companion_instance_13 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, ApiTimePunchUserInformation$ClockedOutInfo$Companion$$childSerializers$_anonymous__n0c6q7);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.d9p_1 = [tmp_1, lazy(tmp_2, ApiTimePunchUserInformation$ClockedOutInfo$Companion$$childSerializers$_anonymous__n0c6q7_0)];
}
var Companion_instance_13;
function Companion_getInstance_13() {
  if (Companion_instance_13 == null)
    new Companion_10();
  return Companion_instance_13;
}
function $serializer_16() {
  $serializer_instance_16 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.ClockedOutInfo', this, 2);
  tmp0_serialDesc.wy('today_shifts', false);
  tmp0_serialDesc.wy('available_roles_for_punch', false);
  this.e9p_1 = tmp0_serialDesc;
}
protoOf($serializer_16).f9p = function (encoder, value) {
  var tmp0_desc = this.e9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_13().d9p_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.x9n_1);
  tmp1_output.dt(tmp0_desc, 1, tmp2_cached[1].t(), value.y9n_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_16).yn = function (encoder, value) {
  return this.f9p(encoder, value instanceof ClockedOutInfo ? value : THROW_CCE());
};
protoOf($serializer_16).zn = function (decoder) {
  var tmp0_desc = this.e9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  var tmp7_cached = Companion_getInstance_13().d9p_1;
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, tmp7_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.yr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, tmp7_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.yr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ClockedOutInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_16).xn = function () {
  return this.e9p_1;
};
protoOf($serializer_16).pz = function () {
  var tmp0_cached = Companion_getInstance_13().d9p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [tmp0_cached[0].t(), get_nullable(tmp0_cached[1].t())];
};
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 == null)
    new $serializer_16();
  return $serializer_instance_16;
}
function ClockedOutInfo_init_$Init$(seen0, todayShifts, availableRoles, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_16().e9p_1);
  }
  $this.x9n_1 = todayShifts;
  $this.y9n_1 = availableRoles;
  return $this;
}
function ClockedOutInfo_init_$Create$(seen0, todayShifts, availableRoles, serializationConstructorMarker) {
  return ClockedOutInfo_init_$Init$(seen0, todayShifts, availableRoles, serializationConstructorMarker, objectCreate(protoOf(ClockedOutInfo)));
}
function $serializer_17() {
  $serializer_instance_17 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.ClockedInInfo.AvailableCustomBreak', this, 3);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('min_length', false);
  this.g9p_1 = tmp0_serialDesc;
}
protoOf($serializer_17).h9p = function (encoder, value) {
  var tmp0_desc = this.g9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.u9n_1);
  tmp1_output.zs(tmp0_desc, 1, value.v9n_1);
  tmp1_output.us(tmp0_desc, 2, value.w9n_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_17).yn = function (encoder, value) {
  return this.h9p(encoder, value instanceof AvailableCustomBreak ? value : THROW_CCE());
};
protoOf($serializer_17).zn = function (decoder) {
  var tmp0_desc = this.g9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = 0;
  var tmp7_input = decoder.kr(tmp0_desc);
  if (tmp7_input.as()) {
    tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pr(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.pr(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.lr(tmp0_desc);
  return AvailableCustomBreak_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_17).xn = function () {
  return this.g9p_1;
};
protoOf($serializer_17).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 == null)
    new $serializer_17();
  return $serializer_instance_17;
}
function AvailableCustomBreak_init_$Init$(seen0, id, name, minLengthInMinutes, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_17().g9p_1);
  }
  $this.u9n_1 = id;
  $this.v9n_1 = name;
  $this.w9n_1 = minLengthInMinutes;
  return $this;
}
function AvailableCustomBreak_init_$Create$(seen0, id, name, minLengthInMinutes, serializationConstructorMarker) {
  return AvailableCustomBreak_init_$Init$(seen0, id, name, minLengthInMinutes, serializationConstructorMarker, objectCreate(protoOf(AvailableCustomBreak)));
}
function ApiTimePunchUserInformation$ClockedInInfo$Companion$$childSerializers$_anonymous__akf0wc() {
  return new ArrayListSerializer($serializer_getInstance_17());
}
function AvailableCustomBreak() {
}
protoOf(AvailableCustomBreak).toString = function () {
  return 'AvailableCustomBreak(id=' + this.u9n_1.toString() + ', name=' + this.v9n_1 + ', minLengthInMinutes=' + this.w9n_1 + ')';
};
protoOf(AvailableCustomBreak).hashCode = function () {
  var result = this.u9n_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.v9n_1) | 0;
  result = imul(result, 31) + this.w9n_1 | 0;
  return result;
};
protoOf(AvailableCustomBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AvailableCustomBreak))
    return false;
  var tmp0_other_with_cast = other instanceof AvailableCustomBreak ? other : THROW_CCE();
  if (!this.u9n_1.equals(tmp0_other_with_cast.u9n_1))
    return false;
  if (!(this.v9n_1 === tmp0_other_with_cast.v9n_1))
    return false;
  if (!(this.w9n_1 === tmp0_other_with_cast.w9n_1))
    return false;
  return true;
};
function Companion_11() {
  Companion_instance_14 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.i9p_1 = [null, lazy(tmp_0, ApiTimePunchUserInformation$ClockedInInfo$Companion$$childSerializers$_anonymous__akf0wc)];
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 == null)
    new Companion_11();
  return Companion_instance_14;
}
function $serializer_18() {
  $serializer_instance_18 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.ClockedInInfo', this, 2);
  tmp0_serialDesc.wy('active_punch', false);
  tmp0_serialDesc.wy('available_custom_breaks', false);
  this.j9p_1 = tmp0_serialDesc;
}
protoOf($serializer_18).k9p = function (encoder, value) {
  var tmp0_desc = this.j9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_14().i9p_1;
  tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_21(), value.l9n_1);
  tmp1_output.dt(tmp0_desc, 1, tmp2_cached[1].t(), value.m9n_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_18).yn = function (encoder, value) {
  return this.k9p(encoder, value instanceof ClockedInInfo ? value : THROW_CCE());
};
protoOf($serializer_18).zn = function (decoder) {
  var tmp0_desc = this.j9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  var tmp7_cached = Companion_getInstance_14().i9p_1;
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, $serializer_getInstance_21(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.yr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, $serializer_getInstance_21(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.yr(tmp0_desc, 1, tmp7_cached[1].t(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ClockedInInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_18).xn = function () {
  return this.j9p_1;
};
protoOf($serializer_18).pz = function () {
  var tmp0_cached = Companion_getInstance_14().i9p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_21(), get_nullable(tmp0_cached[1].t())];
};
var $serializer_instance_18;
function $serializer_getInstance_18() {
  if ($serializer_instance_18 == null)
    new $serializer_18();
  return $serializer_instance_18;
}
function ClockedInInfo_init_$Init$(seen0, activePunch, availableCustomBreaks, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_18().j9p_1);
  }
  $this.l9n_1 = activePunch;
  $this.m9n_1 = availableCustomBreaks;
  return $this;
}
function ClockedInInfo_init_$Create$(seen0, activePunch, availableCustomBreaks, serializationConstructorMarker) {
  return ClockedInInfo_init_$Init$(seen0, activePunch, availableCustomBreaks, serializationConstructorMarker, objectCreate(protoOf(ClockedInInfo)));
}
function $serializer_19() {
  $serializer_instance_19 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.OnBreakInfo', this, 2);
  tmp0_serialDesc.wy('active_punch', false);
  tmp0_serialDesc.wy('active_break', false);
  this.l9p_1 = tmp0_serialDesc;
}
protoOf($serializer_19).m9p = function (encoder, value) {
  var tmp0_desc = this.l9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_21(), value.v9o_1);
  tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_20(), value.w9o_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_19).yn = function (encoder, value) {
  return this.m9p(encoder, value instanceof OnBreakInfo ? value : THROW_CCE());
};
protoOf($serializer_19).zn = function (decoder) {
  var tmp0_desc = this.l9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, $serializer_getInstance_21(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.wr(tmp0_desc, 0, $serializer_getInstance_21(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return OnBreakInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_19).xn = function () {
  return this.l9p_1;
};
protoOf($serializer_19).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_21(), $serializer_getInstance_20()];
};
var $serializer_instance_19;
function $serializer_getInstance_19() {
  if ($serializer_instance_19 == null)
    new $serializer_19();
  return $serializer_instance_19;
}
function OnBreakInfo_init_$Init$(seen0, activePunch, activeBreak, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_19().l9p_1);
  }
  $this.v9o_1 = activePunch;
  $this.w9o_1 = activeBreak;
  return $this;
}
function OnBreakInfo_init_$Create$(seen0, activePunch, activeBreak, serializationConstructorMarker) {
  return OnBreakInfo_init_$Init$(seen0, activePunch, activeBreak, serializationConstructorMarker, objectCreate(protoOf(OnBreakInfo)));
}
function $serializer_20() {
  $serializer_instance_20 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.ActiveBreak', this, 4);
  tmp0_serialDesc.wy('custom_break_id', false);
  tmp0_serialDesc.wy('custom_break_name', false);
  tmp0_serialDesc.wy('custom_break_min_length', false);
  tmp0_serialDesc.wy('in', false);
  this.n9p_1 = tmp0_serialDesc;
}
protoOf($serializer_20).o9p = function (encoder, value) {
  var tmp0_desc = this.n9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.dt(tmp0_desc, 0, LongSerializer_getInstance(), value.x9o_1);
  tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.y9o_1);
  tmp1_output.dt(tmp0_desc, 2, IntSerializer_getInstance(), value.z9o_1);
  tmp1_output.bt(tmp0_desc, 3, InstantIso8601Serializer_getInstance(), value.a9p_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_20).yn = function (encoder, value) {
  return this.o9p(encoder, value instanceof ActiveBreak ? value : THROW_CCE());
};
protoOf($serializer_20).zn = function (decoder) {
  var tmp0_desc = this.n9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.kr(tmp0_desc);
  if (tmp8_input.as()) {
    tmp4_local0 = tmp8_input.yr(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.yr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.wr(tmp0_desc, 3, InstantIso8601Serializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.yr(tmp0_desc, 0, LongSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.yr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.wr(tmp0_desc, 3, InstantIso8601Serializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.lr(tmp0_desc);
  return ActiveBreak_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_20).xn = function () {
  return this.n9p_1;
};
protoOf($serializer_20).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), InstantIso8601Serializer_getInstance()];
};
var $serializer_instance_20;
function $serializer_getInstance_20() {
  if ($serializer_instance_20 == null)
    new $serializer_20();
  return $serializer_instance_20;
}
function ActiveBreak_init_$Init$(seen0, customBreakId, customBreakName, customBreakLengthInMinutes, startTime, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_20().n9p_1);
  }
  $this.x9o_1 = customBreakId;
  $this.y9o_1 = customBreakName;
  $this.z9o_1 = customBreakLengthInMinutes;
  $this.a9p_1 = startTime;
  return $this;
}
function ActiveBreak_init_$Create$(seen0, customBreakId, customBreakName, customBreakLengthInMinutes, startTime, serializationConstructorMarker) {
  return ActiveBreak_init_$Init$(seen0, customBreakId, customBreakName, customBreakLengthInMinutes, startTime, serializationConstructorMarker, objectCreate(protoOf(ActiveBreak)));
}
function $serializer_21() {
  $serializer_instance_21 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.ActivePunch', this, 7);
  tmp0_serialDesc.wy('clocked_in_utc', false);
  tmp0_serialDesc.wy('department_id', false);
  tmp0_serialDesc.wy('department', false);
  tmp0_serialDesc.wy('role_id', false);
  tmp0_serialDesc.wy('role', false);
  tmp0_serialDesc.wy('role_color', false);
  tmp0_serialDesc.wy('scheduled_shift', false);
  this.p9p_1 = tmp0_serialDesc;
}
protoOf($serializer_21).q9p = function (encoder, value) {
  var tmp0_desc = this.p9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.bt(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), value.n9n_1);
  tmp1_output.dt(tmp0_desc, 1, LongSerializer_getInstance(), value.o9n_1);
  tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.p9n_1);
  tmp1_output.dt(tmp0_desc, 3, LongSerializer_getInstance(), value.q9n_1);
  tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.r9n_1);
  tmp1_output.dt(tmp0_desc, 5, StringSerializer_getInstance(), value.s9n_1);
  tmp1_output.dt(tmp0_desc, 6, $serializer_getInstance_22(), value.t9n_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_21).yn = function (encoder, value) {
  return this.q9p(encoder, value instanceof ActivePunch ? value : THROW_CCE());
};
protoOf($serializer_21).zn = function (decoder) {
  var tmp0_desc = this.p9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.kr(tmp0_desc);
  if (tmp11_input.as()) {
    tmp4_local0 = tmp11_input.wr(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.yr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.yr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.yr(tmp0_desc, 6, $serializer_getInstance_22(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.wr(tmp0_desc, 0, InstantIso8601Serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.yr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.yr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.yr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.yr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.yr(tmp0_desc, 6, $serializer_getInstance_22(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.lr(tmp0_desc);
  return ActivePunch_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_21).xn = function () {
  return this.p9p_1;
};
protoOf($serializer_21).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [InstantIso8601Serializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_22())];
};
var $serializer_instance_21;
function $serializer_getInstance_21() {
  if ($serializer_instance_21 == null)
    new $serializer_21();
  return $serializer_instance_21;
}
function ActivePunch_init_$Init$(seen0, clockedIn, departmentId, departmentName, roleId, roleName, roleColor, shift, serializationConstructorMarker, $this) {
  if (!(127 === (127 & seen0))) {
    throwMissingFieldException(seen0, 127, $serializer_getInstance_21().p9p_1);
  }
  $this.n9n_1 = clockedIn;
  $this.o9n_1 = departmentId;
  $this.p9n_1 = departmentName;
  $this.q9n_1 = roleId;
  $this.r9n_1 = roleName;
  $this.s9n_1 = roleColor;
  $this.t9n_1 = shift;
  return $this;
}
function ActivePunch_init_$Create$(seen0, clockedIn, departmentId, departmentName, roleId, roleName, roleColor, shift, serializationConstructorMarker) {
  return ActivePunch_init_$Init$(seen0, clockedIn, departmentId, departmentName, roleId, roleName, roleColor, shift, serializationConstructorMarker, objectCreate(protoOf(ActivePunch)));
}
function $serializer_22() {
  $serializer_instance_22 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation.UserStatusShift', this, 12);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('department_id', false);
  tmp0_serialDesc.wy('department_name', false);
  tmp0_serialDesc.wy('location_id', false);
  tmp0_serialDesc.wy('role_id', false);
  tmp0_serialDesc.wy('role_name', false);
  tmp0_serialDesc.wy('role_color', false);
  tmp0_serialDesc.wy('start_local', false);
  tmp0_serialDesc.wy('end_local', false);
  tmp0_serialDesc.wy('is_current', false);
  tmp0_serialDesc.wy('to_close', false);
  tmp0_serialDesc.wy('to_bd', false);
  this.r9p_1 = tmp0_serialDesc;
}
protoOf($serializer_22).s9p = function (encoder, value) {
  var tmp0_desc = this.r9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.z9n_1);
  tmp1_output.dt(tmp0_desc, 1, LongSerializer_getInstance(), value.a9o_1);
  tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.b9o_1);
  tmp1_output.vs(tmp0_desc, 3, value.c9o_1);
  tmp1_output.dt(tmp0_desc, 4, LongSerializer_getInstance(), value.d9o_1);
  tmp1_output.dt(tmp0_desc, 5, StringSerializer_getInstance(), value.e9o_1);
  tmp1_output.dt(tmp0_desc, 6, StringSerializer_getInstance(), value.f9o_1);
  tmp1_output.bt(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.g9o_1);
  tmp1_output.bt(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), value.h9o_1);
  tmp1_output.rs(tmp0_desc, 9, value.i9o_1);
  tmp1_output.rs(tmp0_desc, 10, value.j9o_1);
  tmp1_output.rs(tmp0_desc, 11, value.k9o_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_22).yn = function (encoder, value) {
  return this.s9p(encoder, value instanceof UserStatusShift ? value : THROW_CCE());
};
protoOf($serializer_22).zn = function (decoder) {
  var tmp0_desc = this.r9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = new Long(0, 0);
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = false;
  var tmp14_local10 = false;
  var tmp15_local11 = false;
  var tmp16_input = decoder.kr(tmp0_desc);
  if (tmp16_input.as()) {
    tmp4_local0 = tmp16_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp16_input.yr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp16_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp16_input.qr(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp16_input.yr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp16_input.yr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp16_input.yr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp16_input.wr(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp16_input.wr(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp16_input.mr(tmp0_desc, 9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp16_input.mr(tmp0_desc, 10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp16_input.mr(tmp0_desc, 11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp16_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp16_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp16_input.yr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp16_input.yr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp16_input.qr(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp16_input.yr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp16_input.yr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp16_input.yr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp16_input.wr(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp16_input.wr(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp16_input.mr(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp16_input.mr(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp16_input.mr(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp16_input.lr(tmp0_desc);
  return UserStatusShift_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
};
protoOf($serializer_22).xn = function () {
  return this.r9p_1;
};
protoOf($serializer_22).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), InstantIso8601Serializer_getInstance(), InstantIso8601Serializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance_22;
function $serializer_getInstance_22() {
  if ($serializer_instance_22 == null)
    new $serializer_22();
  return $serializer_instance_22;
}
function UserStatusShift_init_$Init$(seen0, id, departmentId, departmentName, locationId, roleId, roleName, roleColor, startTime, endTime, isCurrent, isClose, isBusinessDecline, serializationConstructorMarker, $this) {
  if (!(4095 === (4095 & seen0))) {
    throwMissingFieldException(seen0, 4095, $serializer_getInstance_22().r9p_1);
  }
  $this.z9n_1 = id;
  $this.a9o_1 = departmentId;
  $this.b9o_1 = departmentName;
  $this.c9o_1 = locationId;
  $this.d9o_1 = roleId;
  $this.e9o_1 = roleName;
  $this.f9o_1 = roleColor;
  $this.g9o_1 = startTime;
  $this.h9o_1 = endTime;
  $this.i9o_1 = isCurrent;
  $this.j9o_1 = isClose;
  $this.k9o_1 = isBusinessDecline;
  return $this;
}
function UserStatusShift_init_$Create$(seen0, id, departmentId, departmentName, locationId, roleId, roleName, roleColor, startTime, endTime, isCurrent, isClose, isBusinessDecline, serializationConstructorMarker) {
  return UserStatusShift_init_$Init$(seen0, id, departmentId, departmentName, locationId, roleId, roleName, roleColor, startTime, endTime, isCurrent, isClose, isBusinessDecline, serializationConstructorMarker, objectCreate(protoOf(UserStatusShift)));
}
function ApiTimePunchUserInformation$Companion$$childSerializers$_anonymous__pyu45s() {
  return new ArrayListSerializer(StringSerializer_getInstance());
}
function ClockedOutInfo() {
}
protoOf(ClockedOutInfo).toString = function () {
  return 'ClockedOutInfo(todayShifts=' + toString_0(this.x9n_1) + ', availableRoles=' + toString(this.y9n_1) + ')';
};
protoOf(ClockedOutInfo).hashCode = function () {
  var result = hashCode(this.x9n_1);
  result = imul(result, 31) + (this.y9n_1 == null ? 0 : hashCode(this.y9n_1)) | 0;
  return result;
};
protoOf(ClockedOutInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedOutInfo))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedOutInfo ? other : THROW_CCE();
  if (!equals(this.x9n_1, tmp0_other_with_cast.x9n_1))
    return false;
  if (!equals(this.y9n_1, tmp0_other_with_cast.y9n_1))
    return false;
  return true;
};
function ClockedInInfo() {
}
protoOf(ClockedInInfo).toString = function () {
  return 'ClockedInInfo(activePunch=' + this.l9n_1.toString() + ', availableCustomBreaks=' + toString(this.m9n_1) + ')';
};
protoOf(ClockedInInfo).hashCode = function () {
  var result = this.l9n_1.hashCode();
  result = imul(result, 31) + (this.m9n_1 == null ? 0 : hashCode(this.m9n_1)) | 0;
  return result;
};
protoOf(ClockedInInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedInInfo))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedInInfo ? other : THROW_CCE();
  if (!this.l9n_1.equals(tmp0_other_with_cast.l9n_1))
    return false;
  if (!equals(this.m9n_1, tmp0_other_with_cast.m9n_1))
    return false;
  return true;
};
function OnBreakInfo() {
}
protoOf(OnBreakInfo).toString = function () {
  return 'OnBreakInfo(activePunch=' + this.v9o_1.toString() + ', activeBreak=' + this.w9o_1.toString() + ')';
};
protoOf(OnBreakInfo).hashCode = function () {
  var result = this.v9o_1.hashCode();
  result = imul(result, 31) + this.w9o_1.hashCode() | 0;
  return result;
};
protoOf(OnBreakInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof OnBreakInfo))
    return false;
  var tmp0_other_with_cast = other instanceof OnBreakInfo ? other : THROW_CCE();
  if (!this.v9o_1.equals(tmp0_other_with_cast.v9o_1))
    return false;
  if (!this.w9o_1.equals(tmp0_other_with_cast.w9o_1))
    return false;
  return true;
};
function ActiveBreak() {
}
protoOf(ActiveBreak).toString = function () {
  return 'ActiveBreak(customBreakId=' + toString(this.x9o_1) + ', customBreakName=' + this.y9o_1 + ', customBreakLengthInMinutes=' + this.z9o_1 + ', startTime=' + this.a9p_1.toString() + ')';
};
protoOf(ActiveBreak).hashCode = function () {
  var result = this.x9o_1 == null ? 0 : this.x9o_1.hashCode();
  result = imul(result, 31) + (this.y9o_1 == null ? 0 : getStringHashCode(this.y9o_1)) | 0;
  result = imul(result, 31) + (this.z9o_1 == null ? 0 : this.z9o_1) | 0;
  result = imul(result, 31) + this.a9p_1.hashCode() | 0;
  return result;
};
protoOf(ActiveBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ActiveBreak))
    return false;
  var tmp0_other_with_cast = other instanceof ActiveBreak ? other : THROW_CCE();
  if (!equals(this.x9o_1, tmp0_other_with_cast.x9o_1))
    return false;
  if (!(this.y9o_1 == tmp0_other_with_cast.y9o_1))
    return false;
  if (!(this.z9o_1 == tmp0_other_with_cast.z9o_1))
    return false;
  if (!this.a9p_1.equals(tmp0_other_with_cast.a9p_1))
    return false;
  return true;
};
function ActivePunch() {
}
protoOf(ActivePunch).toString = function () {
  return 'ActivePunch(clockedIn=' + this.n9n_1.toString() + ', departmentId=' + toString(this.o9n_1) + ', departmentName=' + this.p9n_1 + ', roleId=' + toString(this.q9n_1) + ', roleName=' + this.r9n_1 + ', roleColor=' + this.s9n_1 + ', shift=' + toString(this.t9n_1) + ')';
};
protoOf(ActivePunch).hashCode = function () {
  var result = this.n9n_1.hashCode();
  result = imul(result, 31) + (this.o9n_1 == null ? 0 : this.o9n_1.hashCode()) | 0;
  result = imul(result, 31) + (this.p9n_1 == null ? 0 : getStringHashCode(this.p9n_1)) | 0;
  result = imul(result, 31) + (this.q9n_1 == null ? 0 : this.q9n_1.hashCode()) | 0;
  result = imul(result, 31) + (this.r9n_1 == null ? 0 : getStringHashCode(this.r9n_1)) | 0;
  result = imul(result, 31) + (this.s9n_1 == null ? 0 : getStringHashCode(this.s9n_1)) | 0;
  result = imul(result, 31) + (this.t9n_1 == null ? 0 : this.t9n_1.hashCode()) | 0;
  return result;
};
protoOf(ActivePunch).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ActivePunch))
    return false;
  var tmp0_other_with_cast = other instanceof ActivePunch ? other : THROW_CCE();
  if (!this.n9n_1.equals(tmp0_other_with_cast.n9n_1))
    return false;
  if (!equals(this.o9n_1, tmp0_other_with_cast.o9n_1))
    return false;
  if (!(this.p9n_1 == tmp0_other_with_cast.p9n_1))
    return false;
  if (!equals(this.q9n_1, tmp0_other_with_cast.q9n_1))
    return false;
  if (!(this.r9n_1 == tmp0_other_with_cast.r9n_1))
    return false;
  if (!(this.s9n_1 == tmp0_other_with_cast.s9n_1))
    return false;
  if (!equals(this.t9n_1, tmp0_other_with_cast.t9n_1))
    return false;
  return true;
};
function UserStatusShift() {
}
protoOf(UserStatusShift).toString = function () {
  return 'UserStatusShift(id=' + this.z9n_1.toString() + ', departmentId=' + toString(this.a9o_1) + ', departmentName=' + this.b9o_1 + ', locationId=' + this.c9o_1.toString() + ', roleId=' + toString(this.d9o_1) + ', roleName=' + this.e9o_1 + ', roleColor=' + this.f9o_1 + ', startTime=' + this.g9o_1.toString() + ', endTime=' + this.h9o_1.toString() + ', isCurrent=' + this.i9o_1 + ', isClose=' + this.j9o_1 + ', isBusinessDecline=' + this.k9o_1 + ')';
};
protoOf(UserStatusShift).hashCode = function () {
  var result = this.z9n_1.hashCode();
  result = imul(result, 31) + (this.a9o_1 == null ? 0 : this.a9o_1.hashCode()) | 0;
  result = imul(result, 31) + (this.b9o_1 == null ? 0 : getStringHashCode(this.b9o_1)) | 0;
  result = imul(result, 31) + this.c9o_1.hashCode() | 0;
  result = imul(result, 31) + (this.d9o_1 == null ? 0 : this.d9o_1.hashCode()) | 0;
  result = imul(result, 31) + (this.e9o_1 == null ? 0 : getStringHashCode(this.e9o_1)) | 0;
  result = imul(result, 31) + (this.f9o_1 == null ? 0 : getStringHashCode(this.f9o_1)) | 0;
  result = imul(result, 31) + this.g9o_1.hashCode() | 0;
  result = imul(result, 31) + this.h9o_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i9o_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.j9o_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.k9o_1) | 0;
  return result;
};
protoOf(UserStatusShift).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UserStatusShift))
    return false;
  var tmp0_other_with_cast = other instanceof UserStatusShift ? other : THROW_CCE();
  if (!this.z9n_1.equals(tmp0_other_with_cast.z9n_1))
    return false;
  if (!equals(this.a9o_1, tmp0_other_with_cast.a9o_1))
    return false;
  if (!(this.b9o_1 == tmp0_other_with_cast.b9o_1))
    return false;
  if (!this.c9o_1.equals(tmp0_other_with_cast.c9o_1))
    return false;
  if (!equals(this.d9o_1, tmp0_other_with_cast.d9o_1))
    return false;
  if (!(this.e9o_1 == tmp0_other_with_cast.e9o_1))
    return false;
  if (!(this.f9o_1 == tmp0_other_with_cast.f9o_1))
    return false;
  if (!this.g9o_1.equals(tmp0_other_with_cast.g9o_1))
    return false;
  if (!this.h9o_1.equals(tmp0_other_with_cast.h9o_1))
    return false;
  if (!(this.i9o_1 === tmp0_other_with_cast.i9o_1))
    return false;
  if (!(this.j9o_1 === tmp0_other_with_cast.j9o_1))
    return false;
  if (!(this.k9o_1 === tmp0_other_with_cast.k9o_1))
    return false;
  return true;
};
function Companion_12() {
  Companion_instance_15 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.t9p_1 = [null, null, null, null, null, null, null, null, null, null, lazy(tmp_0, ApiTimePunchUserInformation$Companion$$childSerializers$_anonymous__pyu45s), null];
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 == null)
    new Companion_12();
  return Companion_instance_15;
}
function $serializer_23() {
  $serializer_instance_23 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.punch.userstatus.data.models.ApiTimePunchUserInformation', this, 12);
  tmp0_serialDesc.wy('user_id', false);
  tmp0_serialDesc.wy('company_id', false);
  tmp0_serialDesc.wy('first_name', false);
  tmp0_serialDesc.wy('last_name', false);
  tmp0_serialDesc.wy('profile_picture_url', false);
  tmp0_serialDesc.wy('employee_id', false);
  tmp0_serialDesc.wy('state', false);
  tmp0_serialDesc.wy('clocked_out_info', false);
  tmp0_serialDesc.wy('clocked_in_info', false);
  tmp0_serialDesc.wy('on_break_info', false);
  tmp0_serialDesc.wy('available_actions', false);
  tmp0_serialDesc.wy('server_time_utc', false);
  this.u9p_1 = tmp0_serialDesc;
}
protoOf($serializer_23).v9p = function (encoder, value) {
  var tmp0_desc = this.u9p_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_15().t9p_1;
  tmp1_output.vs(tmp0_desc, 0, value.z9m_1);
  tmp1_output.vs(tmp0_desc, 1, value.a9n_1);
  tmp1_output.zs(tmp0_desc, 2, value.b9n_1);
  tmp1_output.zs(tmp0_desc, 3, value.c9n_1);
  tmp1_output.zs(tmp0_desc, 4, value.d9n_1);
  tmp1_output.zs(tmp0_desc, 5, value.e9n_1);
  tmp1_output.zs(tmp0_desc, 6, value.f9n_1);
  tmp1_output.dt(tmp0_desc, 7, $serializer_getInstance_16(), value.g9n_1);
  tmp1_output.dt(tmp0_desc, 8, $serializer_getInstance_18(), value.h9n_1);
  tmp1_output.dt(tmp0_desc, 9, $serializer_getInstance_19(), value.i9n_1);
  tmp1_output.bt(tmp0_desc, 10, tmp2_cached[10].t(), value.j9n_1);
  tmp1_output.bt(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), value.k9n_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_23).yn = function (encoder, value) {
  return this.v9p(encoder, value instanceof ApiTimePunchUserInformation ? value : THROW_CCE());
};
protoOf($serializer_23).zn = function (decoder) {
  var tmp0_desc = this.u9p_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = new Long(0, 0);
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_local8 = null;
  var tmp13_local9 = null;
  var tmp14_local10 = null;
  var tmp15_local11 = null;
  var tmp16_input = decoder.kr(tmp0_desc);
  var tmp17_cached = Companion_getInstance_15().t9p_1;
  if (tmp16_input.as()) {
    tmp4_local0 = tmp16_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp16_input.qr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp16_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp16_input.ur(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp16_input.ur(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp16_input.ur(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp16_input.ur(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp16_input.yr(tmp0_desc, 7, $serializer_getInstance_16(), tmp11_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp16_input.yr(tmp0_desc, 8, $serializer_getInstance_18(), tmp12_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp13_local9 = tmp16_input.yr(tmp0_desc, 9, $serializer_getInstance_19(), tmp13_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp14_local10 = tmp16_input.wr(tmp0_desc, 10, tmp17_cached[10].t(), tmp14_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp15_local11 = tmp16_input.wr(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp16_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp16_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp16_input.qr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp16_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp16_input.ur(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp16_input.ur(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp16_input.ur(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp16_input.ur(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp16_input.yr(tmp0_desc, 7, $serializer_getInstance_16(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp16_input.yr(tmp0_desc, 8, $serializer_getInstance_18(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp13_local9 = tmp16_input.yr(tmp0_desc, 9, $serializer_getInstance_19(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp14_local10 = tmp16_input.wr(tmp0_desc, 10, tmp17_cached[10].t(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp15_local11 = tmp16_input.wr(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp16_input.lr(tmp0_desc);
  return ApiTimePunchUserInformation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
};
protoOf($serializer_23).xn = function () {
  return this.u9p_1;
};
protoOf($serializer_23).pz = function () {
  var tmp0_cached = Companion_getInstance_15().t9p_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_16()), get_nullable($serializer_getInstance_18()), get_nullable($serializer_getInstance_19()), tmp0_cached[10].t(), InstantIso8601Serializer_getInstance()];
};
var $serializer_instance_23;
function $serializer_getInstance_23() {
  if ($serializer_instance_23 == null)
    new $serializer_23();
  return $serializer_instance_23;
}
function ApiTimePunchUserInformation_init_$Init$(seen0, userId, companyId, firstName, lastName, profilePictureUrl, employeeId, state, clockedOutInfo, clockedInInfo, onBreakInfo, availableActions, serverTimeUtc, serializationConstructorMarker, $this) {
  if (!(4095 === (4095 & seen0))) {
    throwMissingFieldException(seen0, 4095, $serializer_getInstance_23().u9p_1);
  }
  $this.z9m_1 = userId;
  $this.a9n_1 = companyId;
  $this.b9n_1 = firstName;
  $this.c9n_1 = lastName;
  $this.d9n_1 = profilePictureUrl;
  $this.e9n_1 = employeeId;
  $this.f9n_1 = state;
  $this.g9n_1 = clockedOutInfo;
  $this.h9n_1 = clockedInInfo;
  $this.i9n_1 = onBreakInfo;
  $this.j9n_1 = availableActions;
  $this.k9n_1 = serverTimeUtc;
  return $this;
}
function ApiTimePunchUserInformation_init_$Create$(seen0, userId, companyId, firstName, lastName, profilePictureUrl, employeeId, state, clockedOutInfo, clockedInInfo, onBreakInfo, availableActions, serverTimeUtc, serializationConstructorMarker) {
  return ApiTimePunchUserInformation_init_$Init$(seen0, userId, companyId, firstName, lastName, profilePictureUrl, employeeId, state, clockedOutInfo, clockedInInfo, onBreakInfo, availableActions, serverTimeUtc, serializationConstructorMarker, objectCreate(protoOf(ApiTimePunchUserInformation)));
}
function ApiTimePunchUserInformation(userId, companyId, firstName, lastName, profilePictureUrl, employeeId, state, clockedOutInfo, clockedInInfo, onBreakInfo, availableActions, serverTimeUtc) {
  Companion_getInstance_15();
  this.z9m_1 = userId;
  this.a9n_1 = companyId;
  this.b9n_1 = firstName;
  this.c9n_1 = lastName;
  this.d9n_1 = profilePictureUrl;
  this.e9n_1 = employeeId;
  this.f9n_1 = state;
  this.g9n_1 = clockedOutInfo;
  this.h9n_1 = clockedInInfo;
  this.i9n_1 = onBreakInfo;
  this.j9n_1 = availableActions;
  this.k9n_1 = serverTimeUtc;
}
protoOf(ApiTimePunchUserInformation).toString = function () {
  return 'ApiTimePunchUserInformation(userId=' + this.z9m_1.toString() + ', companyId=' + this.a9n_1.toString() + ', firstName=' + this.b9n_1 + ', lastName=' + this.c9n_1 + ', profilePictureUrl=' + this.d9n_1 + ', employeeId=' + this.e9n_1 + ', state=' + this.f9n_1 + ', clockedOutInfo=' + toString(this.g9n_1) + ', clockedInInfo=' + toString(this.h9n_1) + ', onBreakInfo=' + toString(this.i9n_1) + ', availableActions=' + toString_0(this.j9n_1) + ', serverTimeUtc=' + this.k9n_1.toString() + ')';
};
protoOf(ApiTimePunchUserInformation).hashCode = function () {
  var result = this.z9m_1.hashCode();
  result = imul(result, 31) + this.a9n_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.b9n_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.c9n_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.d9n_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.e9n_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.f9n_1) | 0;
  result = imul(result, 31) + (this.g9n_1 == null ? 0 : this.g9n_1.hashCode()) | 0;
  result = imul(result, 31) + (this.h9n_1 == null ? 0 : this.h9n_1.hashCode()) | 0;
  result = imul(result, 31) + (this.i9n_1 == null ? 0 : this.i9n_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.j9n_1) | 0;
  result = imul(result, 31) + this.k9n_1.hashCode() | 0;
  return result;
};
protoOf(ApiTimePunchUserInformation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiTimePunchUserInformation))
    return false;
  var tmp0_other_with_cast = other instanceof ApiTimePunchUserInformation ? other : THROW_CCE();
  if (!this.z9m_1.equals(tmp0_other_with_cast.z9m_1))
    return false;
  if (!this.a9n_1.equals(tmp0_other_with_cast.a9n_1))
    return false;
  if (!(this.b9n_1 === tmp0_other_with_cast.b9n_1))
    return false;
  if (!(this.c9n_1 === tmp0_other_with_cast.c9n_1))
    return false;
  if (!(this.d9n_1 === tmp0_other_with_cast.d9n_1))
    return false;
  if (!(this.e9n_1 === tmp0_other_with_cast.e9n_1))
    return false;
  if (!(this.f9n_1 === tmp0_other_with_cast.f9n_1))
    return false;
  if (!equals(this.g9n_1, tmp0_other_with_cast.g9n_1))
    return false;
  if (!equals(this.h9n_1, tmp0_other_with_cast.h9n_1))
    return false;
  if (!equals(this.i9n_1, tmp0_other_with_cast.i9n_1))
    return false;
  if (!equals(this.j9n_1, tmp0_other_with_cast.j9n_1))
    return false;
  if (!this.k9n_1.equals(tmp0_other_with_cast.k9n_1))
    return false;
  return true;
};
function $getCOROUTINE$20(_this__u8e3s4, employeePunchId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.e9q_1 = _this__u8e3s4;
  this.f9q_1 = employeePunchId;
}
protoOf($getCOROUTINE$20).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.g9q_1 = this.e9q_1.k9q_1;
          this.n8_1 = 1;
          suspendResult = this.e9q_1.j9q_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.h9q_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.e9q_1.j9q_1.p37(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.i9q_1 = suspendResult;
          this.n8_1 = 3;
          suspendResult = this.g9q_1.m9q(this.h9q_1, this.f9q_1, this.i9q_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 4;
          continue $sm;
        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var this_1 = new Result(this_0);
            var tmp_1;
            try {
              var $this$runCatching = this_1.ul_1;
              var tmp_2 = _Result___get_value__impl__bjfvqg($this$runCatching);
              var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
              var value = toDomain_7(it, this.e9q_1.l9q_1);
              tmp_1 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var e = $p;
                tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_1 = tmp_3;
            }
            tmp_0 = tmp_1;
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          return new Result(tmp_0);
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 5) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
function UserStatusRepository(sessionDataProvider, remoteSource, logger) {
  this.j9q_1 = sessionDataProvider;
  this.k9q_1 = remoteSource;
  this.l9q_1 = logger;
}
protoOf(UserStatusRepository).n9q = function (employeePunchId, $completion) {
  var tmp = new $getCOROUTINE$20(this, employeePunchId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function IUserStatusRemoteSource() {
}
function UserStatusRemoteSource$getTimePunchesUserStatus$lambda($employeePunchId, $locationHash) {
  return function ($this$get, it) {
    $this$get.o44_1.r3q('employee_id', $employeePunchId);
    $this$get.o44_1.r3q('group_hash', $locationHash);
    return Unit_instance;
  };
}
function UserStatusRemoteSource$getTimePunchesUserStatus$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getTimePunchesUserStatusCOROUTINE$21(_this__u8e3s4, companyId, employeePunchId, locationHash, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w9q_1 = _this__u8e3s4;
  this.x9q_1 = companyId;
  this.y9q_1 = employeePunchId;
  this.z9q_1 = locationHash;
}
protoOf($getTimePunchesUserStatusCOROUTINE$21).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.a9r_1 = this.w9q_1.t9s_1;
          var tmp_1 = this;
          tmp_1.b9r_1 = 'company/' + this.x9q_1.toString() + '/time_punches_user_status';
          var tmp_2 = this;
          tmp_2.c9r_1 = ApiVersion_FEBRUARY_2026_getInstance();
          var tmp_3 = this;
          tmp_3.d9r_1 = UserStatusRemoteSource$getTimePunchesUserStatus$lambda(this.y9q_1, this.z9q_1);
          this.e9r_1 = this.a9r_1;
          this.f9r_1 = this.b9r_1;
          this.g9r_1 = this.c9r_1;
          this.h9r_1 = this.d9r_1;
          this.o8_1 = 2;
          var tmp_4 = this;
          tmp_4.j9r_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.k9r_1 = this.e9r_1.f6l_1;
          var tmp_6 = this;
          tmp_6.l9r_1 = buildV2Path(this.e9r_1, this.f9r_1);
          this.m9r_1 = this.k9r_1;
          this.n9r_1 = this.l9r_1;
          var tmp_7 = this;
          tmp_7.o9r_1 = this.m9r_1;
          this.p9r_1 = this.o9r_1;
          var tmp_8 = this;
          tmp_8.q9r_1 = this.p9r_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.n9r_1);
          headers(this_0, UserStatusRemoteSource$getTimePunchesUserStatus$lambda_0(this.g9r_1));
          this_0.z5n(this.h9r_1);
          tmp_9.r9r_1 = this_0;
          this.s9r_1 = this.q9r_1;
          this.t9r_1 = this.r9r_1;
          this.t9r_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.u9r_1 = this.s9r_1;
          var tmp_11 = this;
          tmp_11.v9r_1 = this.t9r_1;
          this.w9r_1 = this.u9r_1;
          this.x9r_1 = this.v9r_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.x9r_1, this.w9r_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.y9r_1 = suspendResult;
          var tmp_12 = this;
          this.j9r_1;
          var value = this.y9r_1;
          tmp_12.i9r_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.z9r_1 = this.q8_1;
            var tmp_14 = this;
            throw this.z9r_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.a9s_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.a9s_1;
              tmp_16.i9r_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.b9s_1 = this.i9r_1;
          this.c9s_1 = this.b9s_1;
          this.d9s_1 = Result__exceptionOrNull_impl_p6xea9(this.c9s_1);
          if (this.d9s_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.c9s_1);
            tmp_17.f9s_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.g9s_1 = this.f9s_1;
            var tmp_19 = this;
            tmp_19.h9s_1 = this.g9s_1;
            this.i9s_1 = this.h9s_1;
            this.j9s_1 = this.i9s_1.c4u().z43_1;
            var containsArg = this.j9s_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_20 = this;
              tmp_20.m9s_1 = Companion_instance;
              if (getKClass(ApiTimePunchUserInformation).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.o9s_1 = this.i9s_1;
                this.p9s_1 = this.o9s_1;
                this.n8_1 = 6;
                var tmp_22 = this.p9s_1.y4u();
                var tmp_23 = getKClass(ApiTimePunchUserInformation);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiTimePunchUserInformation), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.q9s_1 = this.i9s_1;
                this.r9s_1 = this.q9s_1;
                this.n8_1 = 5;
                var tmp_27 = this.r9s_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.s9s_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.i9s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.d9s_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_32.e9s_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.s9s_1;
          tmp_33.k9s_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiTimePunchUserInformation), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.n9s_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_37 = this;
          tmp_37.n9s_1 = suspendResult instanceof ApiTimePunchUserInformation ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.n9s_1;
          var tmp_38 = this;
          this.m9s_1;
          tmp_38.l9s_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.l9s_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_43 = this;
          var this_2 = this.l9s_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.k9s_1 = tmp_44.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.e9s_1 = new Result(this.k9s_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.e9s_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function UserStatusRemoteSource(apiClient) {
  this.t9s_1 = apiClient;
}
protoOf(UserStatusRemoteSource).m9q = function (companyId, employeePunchId, locationHash, $completion) {
  var tmp = new $getTimePunchesUserStatusCOROUTINE$21(this, companyId, employeePunchId, locationHash, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
var EndCriteria_CLOSE_instance;
var EndCriteria_BUSINESS_DECLINE_instance;
var EndCriteria_entriesInitialized;
function EndCriteria_initEntries() {
  if (EndCriteria_entriesInitialized)
    return Unit_instance;
  EndCriteria_entriesInitialized = true;
  EndCriteria_CLOSE_instance = new EndCriteria('CLOSE', 0);
  EndCriteria_BUSINESS_DECLINE_instance = new EndCriteria('BUSINESS_DECLINE', 1);
}
function EndCriteria(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function EndCriteria_CLOSE_getInstance() {
  EndCriteria_initEntries();
  return EndCriteria_CLOSE_instance;
}
function EndCriteria_BUSINESS_DECLINE_getInstance() {
  EndCriteria_initEntries();
  return EndCriteria_BUSINESS_DECLINE_instance;
}
function ClockedOut(preferredShift, preferredShiftPossibleRoles) {
  this.u9s_1 = preferredShift;
  this.v9s_1 = preferredShiftPossibleRoles;
}
protoOf(ClockedOut).toString = function () {
  return 'ClockedOut(preferredShift=' + toString(this.u9s_1) + ', preferredShiftPossibleRoles=' + toString(this.v9s_1) + ')';
};
protoOf(ClockedOut).hashCode = function () {
  var result = this.u9s_1 == null ? 0 : this.u9s_1.hashCode();
  result = imul(result, 31) + (this.v9s_1 == null ? 0 : hashCode(this.v9s_1)) | 0;
  return result;
};
protoOf(ClockedOut).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedOut))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedOut ? other : THROW_CCE();
  if (!equals(this.u9s_1, tmp0_other_with_cast.u9s_1))
    return false;
  if (!equals(this.v9s_1, tmp0_other_with_cast.v9s_1))
    return false;
  return true;
};
function ClockedIn(punch, currentShift, availableCustomBreaks) {
  this.w9s_1 = punch;
  this.x9s_1 = currentShift;
  this.y9s_1 = availableCustomBreaks;
}
protoOf(ClockedIn).toString = function () {
  return 'ClockedIn(punch=' + this.w9s_1.toString() + ', currentShift=' + toString(this.x9s_1) + ', availableCustomBreaks=' + toString(this.y9s_1) + ')';
};
protoOf(ClockedIn).hashCode = function () {
  var result = this.w9s_1.hashCode();
  result = imul(result, 31) + (this.x9s_1 == null ? 0 : this.x9s_1.hashCode()) | 0;
  result = imul(result, 31) + (this.y9s_1 == null ? 0 : hashCode(this.y9s_1)) | 0;
  return result;
};
protoOf(ClockedIn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ClockedIn))
    return false;
  var tmp0_other_with_cast = other instanceof ClockedIn ? other : THROW_CCE();
  if (!this.w9s_1.equals(tmp0_other_with_cast.w9s_1))
    return false;
  if (!equals(this.x9s_1, tmp0_other_with_cast.x9s_1))
    return false;
  if (!equals(this.y9s_1, tmp0_other_with_cast.y9s_1))
    return false;
  return true;
};
function OnBreak(punch, currentShift, currentBreak) {
  this.z9s_1 = punch;
  this.a9t_1 = currentShift;
  this.b9t_1 = currentBreak;
}
protoOf(OnBreak).toString = function () {
  return 'OnBreak(punch=' + this.z9s_1.toString() + ', currentShift=' + toString(this.a9t_1) + ', currentBreak=' + this.b9t_1.toString() + ')';
};
protoOf(OnBreak).hashCode = function () {
  var result = this.z9s_1.hashCode();
  result = imul(result, 31) + (this.a9t_1 == null ? 0 : this.a9t_1.hashCode()) | 0;
  result = imul(result, 31) + this.b9t_1.hashCode() | 0;
  return result;
};
protoOf(OnBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof OnBreak))
    return false;
  var tmp0_other_with_cast = other instanceof OnBreak ? other : THROW_CCE();
  if (!this.z9s_1.equals(tmp0_other_with_cast.z9s_1))
    return false;
  if (!equals(this.a9t_1, tmp0_other_with_cast.a9t_1))
    return false;
  if (!this.b9t_1.equals(tmp0_other_with_cast.b9t_1))
    return false;
  return true;
};
function Punch(clockedInAt, assignment) {
  this.c9t_1 = clockedInAt;
  this.d9t_1 = assignment;
}
protoOf(Punch).toString = function () {
  return 'Punch(clockedInAt=' + this.c9t_1.toString() + ', assignment=' + toString_0(this.d9t_1) + ')';
};
protoOf(Punch).hashCode = function () {
  var result = this.c9t_1.hashCode();
  result = imul(result, 31) + hashCode(this.d9t_1) | 0;
  return result;
};
protoOf(Punch).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Punch))
    return false;
  var tmp0_other_with_cast = other instanceof Punch ? other : THROW_CCE();
  if (!this.c9t_1.equals(tmp0_other_with_cast.c9t_1))
    return false;
  if (!equals(this.d9t_1, tmp0_other_with_cast.d9t_1))
    return false;
  return true;
};
function Shift(id, assignment, startTime, endTime, endCriteria) {
  this.l9o_1 = id;
  this.m9o_1 = assignment;
  this.n9o_1 = startTime;
  this.o9o_1 = endTime;
  this.p9o_1 = endCriteria;
}
protoOf(Shift).toString = function () {
  return 'Shift(id=' + this.l9o_1.toString() + ', assignment=' + toString_0(this.m9o_1) + ', startTime=' + this.n9o_1.toString() + ', endTime=' + this.o9o_1.toString() + ', endCriteria=' + toString(this.p9o_1) + ')';
};
protoOf(Shift).hashCode = function () {
  var result = this.l9o_1.hashCode();
  result = imul(result, 31) + hashCode(this.m9o_1) | 0;
  result = imul(result, 31) + this.n9o_1.hashCode() | 0;
  result = imul(result, 31) + this.o9o_1.hashCode() | 0;
  result = imul(result, 31) + (this.p9o_1 == null ? 0 : this.p9o_1.hashCode()) | 0;
  return result;
};
protoOf(Shift).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Shift))
    return false;
  var tmp0_other_with_cast = other instanceof Shift ? other : THROW_CCE();
  if (!this.l9o_1.equals(tmp0_other_with_cast.l9o_1))
    return false;
  if (!equals(this.m9o_1, tmp0_other_with_cast.m9o_1))
    return false;
  if (!this.n9o_1.equals(tmp0_other_with_cast.n9o_1))
    return false;
  if (!this.o9o_1.equals(tmp0_other_with_cast.o9o_1))
    return false;
  if (!equals(this.p9o_1, tmp0_other_with_cast.p9o_1))
    return false;
  return true;
};
function Break(startTime, customBreak) {
  this.e9t_1 = startTime;
  this.f9t_1 = customBreak;
}
protoOf(Break).toString = function () {
  return 'Break(startTime=' + this.e9t_1.toString() + ', customBreak=' + toString(this.f9t_1) + ')';
};
protoOf(Break).hashCode = function () {
  var result = this.e9t_1.hashCode();
  result = imul(result, 31) + (this.f9t_1 == null ? 0 : this.f9t_1.hashCode()) | 0;
  return result;
};
protoOf(Break).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Break))
    return false;
  var tmp0_other_with_cast = other instanceof Break ? other : THROW_CCE();
  if (!this.e9t_1.equals(tmp0_other_with_cast.e9t_1))
    return false;
  if (!equals(this.f9t_1, tmp0_other_with_cast.f9t_1))
    return false;
  return true;
};
function CustomBreak(id, name, minLengthInMinutes) {
  this.g9t_1 = id;
  this.h9t_1 = name;
  this.i9t_1 = minLengthInMinutes;
}
protoOf(CustomBreak).toString = function () {
  return 'CustomBreak(id=' + this.g9t_1.toString() + ', name=' + this.h9t_1 + ', minLengthInMinutes=' + this.i9t_1 + ')';
};
protoOf(CustomBreak).hashCode = function () {
  var result = this.g9t_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.h9t_1) | 0;
  result = imul(result, 31) + this.i9t_1 | 0;
  return result;
};
protoOf(CustomBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CustomBreak))
    return false;
  var tmp0_other_with_cast = other instanceof CustomBreak ? other : THROW_CCE();
  if (!this.g9t_1.equals(tmp0_other_with_cast.g9t_1))
    return false;
  if (!(this.h9t_1 === tmp0_other_with_cast.h9t_1))
    return false;
  if (!(this.i9t_1 === tmp0_other_with_cast.i9t_1))
    return false;
  return true;
};
function User(id, firstName, lastName, profilePictureUrl) {
  this.j9t_1 = id;
  this.k9t_1 = firstName;
  this.l9t_1 = lastName;
  this.m9t_1 = profilePictureUrl;
}
protoOf(User).toString = function () {
  return 'User(id=' + this.j9t_1.toString() + ', firstName=' + this.k9t_1 + ', lastName=' + this.l9t_1 + ', profilePictureUrl=' + this.m9t_1 + ')';
};
protoOf(User).hashCode = function () {
  var result = this.j9t_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.k9t_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.l9t_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.m9t_1) | 0;
  return result;
};
protoOf(User).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof User))
    return false;
  var tmp0_other_with_cast = other instanceof User ? other : THROW_CCE();
  if (!this.j9t_1.equals(tmp0_other_with_cast.j9t_1))
    return false;
  if (!(this.k9t_1 === tmp0_other_with_cast.k9t_1))
    return false;
  if (!(this.l9t_1 === tmp0_other_with_cast.l9t_1))
    return false;
  if (!(this.m9t_1 === tmp0_other_with_cast.m9t_1))
    return false;
  return true;
};
function UserStatus(user, state, availableActions, serverTime) {
  this.n9t_1 = user;
  this.o9t_1 = state;
  this.p9t_1 = availableActions;
  this.q9t_1 = serverTime;
}
protoOf(UserStatus).toString = function () {
  return 'UserStatus(user=' + this.n9t_1.toString() + ', state=' + toString_0(this.o9t_1) + ', availableActions=' + toString_0(this.p9t_1) + ', serverTime=' + this.q9t_1.toString() + ')';
};
protoOf(UserStatus).hashCode = function () {
  var result = this.n9t_1.hashCode();
  result = imul(result, 31) + hashCode(this.o9t_1) | 0;
  result = imul(result, 31) + hashCode(this.p9t_1) | 0;
  result = imul(result, 31) + this.q9t_1.hashCode() | 0;
  return result;
};
protoOf(UserStatus).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof UserStatus))
    return false;
  var tmp0_other_with_cast = other instanceof UserStatus ? other : THROW_CCE();
  if (!this.n9t_1.equals(tmp0_other_with_cast.n9t_1))
    return false;
  if (!equals(this.o9t_1, tmp0_other_with_cast.o9t_1))
    return false;
  if (!equals(this.p9t_1, tmp0_other_with_cast.p9t_1))
    return false;
  if (!this.q9t_1.equals(tmp0_other_with_cast.q9t_1))
    return false;
  return true;
};
function IUserStatusAccessor() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_1).qz = typeParametersSerializers;
protoOf($serializer_2).qz = typeParametersSerializers;
protoOf($serializer_3).qz = typeParametersSerializers;
protoOf($serializer_4).qz = typeParametersSerializers;
protoOf($serializer_5).qz = typeParametersSerializers;
protoOf($serializer_6).qz = typeParametersSerializers;
protoOf($serializer_7).qz = typeParametersSerializers;
protoOf($serializer_8).qz = typeParametersSerializers;
protoOf(ClockRepository).n9c = clockOut$default;
protoOf($serializer_9).qz = typeParametersSerializers;
protoOf($serializer_10).qz = typeParametersSerializers;
protoOf($serializer_11).qz = typeParametersSerializers;
protoOf($serializer_12).qz = typeParametersSerializers;
protoOf($serializer_13).qz = typeParametersSerializers;
protoOf($serializer_14).qz = typeParametersSerializers;
protoOf($serializer_15).qz = typeParametersSerializers;
protoOf($serializer_16).qz = typeParametersSerializers;
protoOf($serializer_17).qz = typeParametersSerializers;
protoOf($serializer_18).qz = typeParametersSerializers;
protoOf($serializer_19).qz = typeParametersSerializers;
protoOf($serializer_20).qz = typeParametersSerializers;
protoOf($serializer_21).qz = typeParametersSerializers;
protoOf($serializer_22).qz = typeParametersSerializers;
protoOf($serializer_23).qz = typeParametersSerializers;
//endregion
//region block: init
AssignmentMappers_instance = new AssignmentMappers();
LdrMapperHelpers_instance = new LdrMapperHelpers();
RoleMappers_instance = new RoleMappers();
Location_instance = new Location();
Companion_instance_4 = new Companion_1();
Companion_instance_10 = new Companion_7();
Companion_instance_12 = new Companion_9();
//endregion
//region block: exports
export {
  Department as Departmentzzct4e6r4fp,
  Location as Location5fymj972tpv5,
  Role as Roles62ey455m3o2,
  AttestationRepository as AttestationRepository2urbmm1459bxp,
  ClockResponse as ClockResponse147efja5yzcjq,
  IClockRepository as IClockRepository26nxob36qlael,
  get_punchModule as get_punchModule3iwry7ctva3is,
  QuestionResponse_1 as QuestionResponse37cr3rtovd30e,
  HealthCheckQuestionnaireResponses as HealthCheckQuestionnaireResponsesauwvwoqz7ax3,
  HealthCheckRepository as HealthCheckRepository3a392dyv8u8y0,
  ClockedIn as ClockedInhud4qec4hav4,
  ClockedOut as ClockedOut1s2pj1kq6e899,
  OnBreak as OnBreak2nwx24726j996,
  IUserStatusAccessor as IUserStatusAccessorqt4q4njsukyo,
  TimePunchUserAction_END_BREAK_getInstance as TimePunchUserAction_END_BREAK_getInstance3i0kp9qmqf1ov,
  Status_IN_getInstance as Status_IN_getInstance3h4ep6fwyc5xe,
  Status_OUT_getInstance as Status_OUT_getInstance1d7jb2qds8bbx,
  Location_instance as Location_instance308x7rrsuc6y3,
};
//endregion

